import React, { Component, createRef  } from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import { CssBaseline, CircularProgress, Container, Button, Grid, IconButton, Menu, MenuItem, Tooltip, Divider, ListItemIcon, DialogContentText, Grow, Paper, MenuList, ClickAwayListener, Popper, Stack } from "@mui/material";
import { withStyles } from "@mui/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import CustomizedSnackbars from "../../components/material-snackbars";
import HeaderMenu from "../../components/header-menu";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { Link, useLocation } from 'react-router-dom';
import  {Link as LinkA} from '@mui/material'
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { TablePopup } from '../../components/table/table-popup';
import * as CalledOrganizationChecklistService from '../../services/calledorganizationchecklist.service'
import { WithContext as ReactTags } from 'react-tag-input';
import Api from "../../services/api";
import * as calledsActions from '../../redux/actions/calleds';
import * as headerMenuActions from '../../redux/actions/header-menu';
import * as lastCalledsQueueActions from '../../redux/actions/last-calleds-queue'
import { Can } from '../../config/ability-context'
import { AbilityContext } from '../../config/ability-context'
import Footer from '../../components/footer';
import moment from "moment";
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'react-intl';
import { getSlaAtendimento, getSlaSolucao, getSlaSnapshotWithPriority } from './called.functions';
import { ensureSlaPrioritiesLoaded, resolveSlaPriorityTimes } from '../../helpers/sla-priority-resolver';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Pagination from '@mui/material/Pagination';
import Search from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import SimpleSelect from '../../components/select/simple-search';
import ClearIcon from '@mui/icons-material/Clear';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import SaveIcon from '@mui/icons-material/Save'
import * as Service from "../../services/organizationsetting.service";
import CallMade from '@mui/icons-material/CallMade';
import Rating from '@mui/material/Rating';
import Chip from '@mui/material/Chip';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import EmailIcon from '@mui/icons-material/Email';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import TreeDots from '../../components/tree-dots';
import ModalVideoCall from "../../components/modal-video-call-list";
import FirstElement from "../../components/first-element";
import QueuePlayNextIcon from '@mui/icons-material/QueuePlayNext';
import { PapiroConsole } from '../../utils/papiroConsole';
import SimpleAutoComplete from '../../components/select/simple';
import RealSimpleAutoComplete from '../../components/auto-complete/autocomplete-with-onclick';
import fileDownload from 'js-file-download'  
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MoreVert from "@mui/icons-material/MoreVert";
import * as TableCustomFilterService from '../../services/tablecustomfilter.service';
import HelpIcon from '@mui/icons-material/Help';
import StarRateIcon from '@mui/icons-material/StarRate';
import { CSSTransition } from "react-transition-group";
import SimpleCheckBox from "../../components/checkbox/check";
import './style.css';
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import PanToolIcon from '@mui/icons-material/PanTool';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SearchBar from './components/search-bar';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import SearchBarDialog from './components/search-bar-dialog'
import SavedFiltersModal from './components/saved-filters-modal';
import { ItemCard } from './components/itemcard/item-card'
import TreatCalledModal from './components/treat-called-modal'
import MassMoveCalledModal from './components/mass-move-called-modal'
import { getAllSelectionModelToTableCustomFilterByRoleType } from "../../services/organization.service";
import SimpleAutoCompleteMultiple from "../../components/auto-complete/autocomplete-multiple";
import CalledsQuantityCards from "../dashboard/components/calledsquantitycards/calledsquantitycards";
import Favoritefilterscards from "../dashboard/components/favoritefilterscards/favoritefilterscards";
import { getLastCalledsQueueByUserId, searchById } from "../../services/called.service";
import SimpleAutoCompleteByName from '../../components/auto-complete/autocomplete-by-name';
import * as CalledService from '../../services/called.service';
import SimpleAutoCompleteSearch from '../../components/auto-complete/autocomplete-search-api';
import SimpleDatePicker from '../../components/date-pickers/inline';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import * as ChatbotService from "../../services/2talk/chatbot.service.js";
import * as WebchatService from "../../services/2talk/webchat.service.js";
import { getPhoneNumberList } from "../../services/2talk/registrationphonenumber.js";
import { CheckIcon } from "lucide-react";
import TagInputMui from '../../components/tag-input/tag-input-mui';
import SearchOffIcon from '@mui/icons-material/SearchOff'; 
import { add } from "date-fns";
import SimpleDatePickerRequired from '../../components/date-pickers/inline-required';
import RegexInput from "src/components/regex-input/regex-input";
import CalledFilters from '../../components/called-filters/CalledFilters';

var TableTitles = [];

class NewCalleds extends Component {

    constructor(props) {

        super(props);
        this.nodeRef = createRef();
        this.Reload = this.Reload.bind(this);
        this.Reload();

        PapiroConsole.log("constructor")
        PapiroConsole.log(props)

        this.isFinishedState = 0
        this.isArchivedState = 0
        this.isCanceledState = 0
        if (this.props.location && this.props.location.state && this.props.location.state == "finishedCalleds"){
            this.isFinishedState = 1
            this.cleanLocalStorageFilter();
        }

        if (this.props.location && this.props.location.state && this.props.location.state == "archivedcallleds")
        {
            this.isArchivedState = 1
            PapiroConsole.log(this.isArchivedState)
            PapiroConsole.log("this.isArchivedState")
            this.cleanLocalStorageFilter();
        }

        if (this.props.location && this.props.location.state && this.props.location.state == "canceledcalleds")
        {
            this.isCanceledState = 1
            PapiroConsole.log(this.isCanceledState)
            PapiroConsole.log("this.isCanceledState")
            this.cleanLocalStorageFilter();
        }
        

        this.typingTimeout = null;

        const { userSession, location } = this.props;

        if(!userSession?.user?.enablenewscreencalled && window.location.pathname == `/${this.props.match.params.lang}/new-calleds`) {
            this.props.history.push(`/${this.props.match.params.lang}/calleds`)
        }

        this.userId = userSession?.user?.id;
        this.hirerId = Api?.getSassHirerId();

        PapiroConsole.log("location nessa linha")
        PapiroConsole.log(this.props)

        const intl = this.props.intl;
        this.arrayConteudo = []
        this.organizationsettings = null;
        
        this.emptySearchArchived = null;
        this.emptySearchCanceled = null;
        this.emptySearchFinishCalleds = null;

        let filterTypes = [
            { name: intl.formatMessage({ id: "and" }), id: 1 },
            { name: intl.formatMessage({ id: "or" }), id: 2 }
        ]

        let filters = [
            { name: intl.formatMessage({ id: "id" }), id: "id" },
            { name: intl.formatMessage({ id: "title" }), id: "title" },
            { name: intl.formatMessage({ id: "organization" }), id: "org" },
            { name: intl.formatMessage({ id: "category" }), id: "category" },
            { name: intl.formatMessage({ id: "menu.statuses" }), id: "status" },
            { name: intl.formatMessage({ id: "type" }), id: "type" },
            { name: intl.formatMessage({ id: "requestuser" }), id: "requestuser" },
            { name: intl.formatMessage({ id: "assigned" }), id: "assigneduser" },
            { name: intl.formatMessage({ id: "open.date" }), id: "open" },
            { name: intl.formatMessage({ id: "location" }), id: "loc" },
            { name: intl.formatMessage({id:"classification"}), id: "classification" },
            { name: intl.formatMessage({id:"origin.call"}), id: "origin" },
            { name: intl.formatMessage({id:"called.list.calls.with.geolocalization"}), id: "geolocalization" },
            { name: intl.formatMessage({id:"tags"}), id: "tag" },
        ];

        let orderNewFieldList = [
            { name: intl.formatMessage({ id: "id" }), id: "id" },
            { name: intl.formatMessage({ id: "title" }), id: "title" },
            { name: intl.formatMessage({ id: "organization" }), id: "org" },
            { name: intl.formatMessage({ id: "category" }), id: "category" },
            { name: intl.formatMessage({ id: "menu.statuses" }), id: "status" },
            { name: intl.formatMessage({ id: "type" }), id: "type" },
            { name: intl.formatMessage({ id: "requestuser" }), id: "requestuser" },
            { name: intl.formatMessage({ id: "assigned" }), id: "assigneduser" },
            { name: intl.formatMessage({ id: "open.date" }), id: "open" },
            { name: intl.formatMessage({ id: "location" }), id: "loc" },
            { name: intl.formatMessage({id:"classification"}), id: "classification" },
            { name: intl.formatMessage({id:"origin.call"}), id: "origin" },
        ];

        this.popupColumns = [
            { title: intl.formatMessage({ id: "type" }), field: 'typeName' },
            { title: intl.formatMessage({id:"menu.organizationpatrimonies"}), field: 'patrimonies' },
            { title: intl.formatMessage({ id: "attendance.team" }), field: 'time' },
        ]

        this.popupColumnsClient = [
            { title: intl.formatMessage({id:"menu.organizationpatrimonies"}), field: 'patrimonies' },
            { title: intl.formatMessage({ id: "menu.statuses" }), field: 'statusName' },
            { title: intl.formatMessage({ id: "open.date" }), field: 'opening' },
            { title: intl.formatMessage({ id: "assigned" }), field: 'assignedUser' },
        ]


        this.categorySetting = true
        this.typeSetting = false

        this.isClient = true;
        this.isAdm = false;
        this.isTechnical = false
        this.admGlobal = false;
        this.isAdmOrg = false;
        this.isCoordenator = false;

        if (userSession == null ||  userSession.user == null || userSession.user.userrole == null) {
            Api.logoff();
        }
        this.userOrganizations = userSession.user.userorganizations;

        userSession.user.userrole.map((item, key) => {
            if (item.role.roletype != 3) {
                this.isClient = false;
            }
            if (item.role.roletype == 2) {
                this.isTechnical = true;
            }
            if (item.role.roletype == 0 || item.role.roletype == 1 || item.role.roletype == 4) {
                this.isAdm = true;
            }
            if (item.role.roletype == 1)
                this.isAdmOrg = true;
            if (item.role.roletype == 4)
                this.isCoordenator = true;
            if (item.role.roletype == 0) {
                this.admGlobal = true;
            }
        });

        if(!this.isClient) {
            filters.push(
                { name: 'E-mail do solicitante', id: "requestusermail" },
                { name: intl.formatMessage({ id: "request.user.document" }), id: "requestuserdocument" },
                { name: intl.formatMessage({ id: "departament" }), id: "dept" },
                { name: 'Campo personalizado', id: "customfield" },
                { name: intl.formatMessage({id:"is.called.expired"}), id: "expiredcall" },
                { name: intl.formatMessage({id:"attendance.team"}), id: "techinicalteam" },
                { name: intl.formatMessage({id:"mail.box.config"}), id: "mailboxaddress" },
                { name: intl.formatMessage({id:"menu.called.service.settings"}), id: "calledservicesettings" },
                { name: intl.formatMessage({id:"registered.number"}), id: "registerednumber" },
                { name: "Webchat", id: "webchat" },
                { name: "Chatbot", id: "chatbot" }
            )

            orderNewFieldList.push(
                { name: 'E-mail do solicitante', id: "requestusermail" },
                { name: intl.formatMessage({ id: "request.user.document" }), id: "requestuserdocument" },
                { name: intl.formatMessage({ id: "departament" }), id: "dept" },
                { name: intl.formatMessage({id:"attendance.team"}), id: "techinicalteam" },
                { name: intl.formatMessage({id:"registered.number"}), id: "registerednumber" },
                { name: intl.formatMessage({id:"customer.number"}), id: "customernumber" },
                { name: "Chatbot", id: "chatbot" }
            )
        }

        let selectedColumnns = []
        if (this.isAdm) {
            TableTitles.push(
                { title: intl.formatMessage({id:"situation"}), field: 'CallDueDate' },
                { title: intl.formatMessage({ id: "id" }), field: 'id' },
                { title: intl.formatMessage({ id: "organization" }), field: 'Organization' },
                { title: intl.formatMessage({ id: "title" }), field: 'title' },
                { title: intl.formatMessage({ id: "category" }), field: 'OrganizationCategory' },
                { title: intl.formatMessage({ id: "sla.service" }), field: 'slaAtendimento' },
                { title: intl.formatMessage({ id: "sla.solution" }), field: 'slaSolucao' },
                { title: intl.formatMessage({ id: "menu.statuses" }), field: 'statusName', },
                { title: intl.formatMessage({ id: "requestuser" }), field: 'requestingUser' },
                { title: intl.formatMessage({ id: "location" }), field: 'addressname' },
                { title: intl.formatMessage({id:"classification"}), field: 'classification' },
                { title: intl.formatMessage({ id: "creation.date" }), field: 'DateCreatedAt' },
                { title: intl.formatMessage({id:"assigned"}), field: 'assignedUser' }
            )
        } else if (!this.isAdm && this.isClient) {
            TableTitles.push(
                { title: intl.formatMessage({ id: "id" }), field: 'id' },
                { title: intl.formatMessage({id:"title"}), field: 'title' },
                { title: (this.categorySetting && this.typeSetting) ? intl.formatMessage({ id: "category.and.type" }) : (!this.categorySetting && this.typeSetting) ? intl.formatMessage({ id: "type" }) : intl.formatMessage({ id: "category" }), field: 'orgCat' },
                { title: intl.formatMessage({ id: "menu.statuses" }), field: 'statusName' },
                { title: intl.formatMessage({ id: "requestuser" }), field: 'requestingUser' },
                { title: intl.formatMessage({id:"assigned"}), field: 'assignedUser' },
            )
        } else {
            TableTitles.push(
                { title: intl.formatMessage({id:"situation"}), field: 'CallDueDate' },
                { title: intl.formatMessage({ id: "id" }), field: 'id' },
                { title: intl.formatMessage({ id: "organization" }), field: 'Organization' },
                { title: intl.formatMessage({id:"title"}), field: 'title' },
                { title: intl.formatMessage({ id: "category" }), field: 'OrganizationCategory' },
                { title: intl.formatMessage({id:"menu.organizationpatrimonies"}), field: 'patrimonies' },
                { title: intl.formatMessage({ id: "menu.statuses" }), field: 'statusName' },
                { title: intl.formatMessage({ id: "sla.service" }), field: 'slaAtendimento' },
                { title: intl.formatMessage({ id: "sla.solution" }), field: 'slaSolucao' },
                { title: intl.formatMessage({ id: "location" }), field: 'addressname' },
                { title: intl.formatMessage({ id: "requestuser" }), field: 'requestingUser' },
                { title: intl.formatMessage({id:"assigned"}), field: 'assignedUser' },
            )
        }

        this.organizationId = null;
        
        if (userSession.user.organizationusers) {
            this.organizationId = userSession.user.organizationlistid;
        }
        this.isCheckEmail = false;
        this.canStartCallCenter = false;
        userSession.user.organizationusers.map((item) => {
            if (item.organization.organizationsettings) {
                if (item.organization.organizationsettings.allowscreateanonymouscalledsbyemail) {
                    this.isCheckEmail = true;
                }
                if (item.organization.organizationsettings.canstartcallcenter) {
                    this.canStartCallCenter = true;
                }
            }
        });

        if (this.admGlobal == true && this.isClient == false) {
            this.isCheckEmail = true;
            this.canStartCallCenter = true;
        }

        this.orderFieldList = [
            {
                name: "id",
                displayName: "ID",
            },
            {
                name: "openingdate",
                displayName: intl.formatMessage({ id: "creation.date" }),
            },
            {
                name: "duedate",
                displayName: intl.formatMessage({id:"estimated.solution.date"}),
            }
        ];

        this.createTableCustomDialogInitialState = {
            name: '',
            exhibitionName:'',
            displayFilterInCalledList : false,
            isPrivate: false,
            fields: '',
            operators: '',
            values: '',
            isFavorite: false,
            isDefault: false,
            tableCustomFilterOrganizationIds: [],
            createdAt: moment().format('YYYY/MM/DD HH:mm:ss'),
            createdUser: userSession.user && userSession.user.id
        }

        this.editTableCustomDialogInitialState = {
            id: '',
            userId: 0,
            name: '',
            isPrivate: false,
            fields: '',
            operators: '',
            values: '',
            isFavorite: false,
            isDefault: false,
            exhibitionName:'',
            displayFilterInCalledList : false,
            displayFilterInCreatorCalledList : false,
            tableCustomFilterOrganizationIds: [],
            tablecustomfilterorganizations: [],
            tablecustomfilterfields: [],
            updatedAt: moment().format('YYYY/MM/DD HH:mm:ss'),
            updatedUser: userSession.user && userSession.user.id
        }

        this.state = {
            emptyArray : null, 
            emptySearchArchived : false,
            emptySearchCanceled : false,
            emptySearchFinishCalleds : false,
            locationState: 'calleds',
            selectedColumnns: selectedColumnns,
            tableTitles: TableTitles,
            countExpiredCalleds : 0,
            countExpiredCalledsToday : 0,
            countOpenCalleds : 0,
            countPendingCalledsToday : 0,
            openAccordionFilter : false,
            countCalledsWithoutAssignedUser : 0,
            countOpenCalledsToday : 0,

            isFetchTheGetStatisticsCalledsByDueDate: false,
            countCalledsDueDateToday: 0,
            countCalledsDueDateWeek: 0,
            countCalledsDueDateMonth: 0,

            filters: filters,
            itemsTree: [],
            filterMenuAnchorEl: null,
            filterFavorite: [],
            filtersByFlag: [],
            createTableCustomDialog: this.createTableCustomDialogInitialState,
            editTableCustomDialog: this.editTableCustomDialogInitialState,
            deleteTableCustomFilter: null,
            listTableCustomDialogList: [],
            calledToAssign: null,
            calledsList: [],
			tableCustomFilterOrganizationList: [],
			countLoading: 0,
            organizationId: this.organizationId,
            currentPopupData: null,
            loading: false,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",
            dataFilter: false,
            totalPages: 0,
            page: 1,
            pageStart: 0,
            pageEnd: 0,
            count: 0,
            searchValue: '',
            searchValueListTableCustomField: '',
            searchValueEdit: '',
            filterSelected: 0,
            filterSelectedEdit: 0,
            filterTypes: filterTypes,
            multipleSearch: '',
            multipleFilter: '',
            contentFilter: '',
            contentFilterEdit: '',
            contentOrder: '',
            contentOrderEdit: '',
            filterType: 0,
            viewFilterType: false,
            calledCall: null,
            modalopen: false,
            organizationsList: [],
            MessageCreateNewCall: intl.formatMessage({id:"called.list.create.first.call"}),
            disabledvertex: true,
            checkMailAndVideoCallInsert: false,
            organizationCheckEmail: 0,
            calledCountTimeData: 0,
            calledCountNotTimeData: 0,
            countFavorite: 0,
            confirmDeleteTableCustomFilterDialogOpen: false,
            createTableCustomDialogOpen: false,
            listTableCustomDialogOpen: false,
            listTableCustomDialogLoading: false,
            canAssignCalledDialogOpen: false,
            canAssignCalledRowData: null,
            canAssignCalledNewTab: false,
            editTableCustomFilterStep: 1,
            customFilters: intl.formatMessage({id:"custom.filters"}),
            tableCustomFilterToDeleteId: 0,
            typeSetting: false,
            categorySetting: false,
            confirmAssignCalledDialogOpen: false,
            confirmTreatCalledDialogOpen: false,
            treatCalledModalOpen: false,
            massMoveCalledModalOpen: false,
            openDrawerFilterMenu: false,
            drawerAnimationClass: '',
            valueSpacingGrid: 12,
            openDrawerOrderMenu: false,
            isFinished: this.isFinishedState,
            isArchived: this.isArchivedState,
            isCanceled: this.isCanceledState,
			orderFields: this.orderFieldList,
            orderNewFields: orderNewFieldList,
            orderFilterSelected: { name: intl.formatMessage({ id: "open.date" }), id: "open" },
            orderTypeFilterSelected: 'desc',
            orderActions: [
                {
                    id: 1,
                    name: intl.formatMessage({ id: "search" })
                }
            ],
            populateCalledsDialogOpen: false,
            populateCalledsSize: { id: 10000, name: '10000' },
            canselectorganizationcategoriesbylevels: false,
            displayNotFound: false,
            organizationsFilterList: [],
            statusFilterList: [],
            typeFilterList: [],
            requestUserFilterList: [],
            assignedUserFilterList: [],
            locationFilterList: [],
            originFilterList: [],
            geoLocationFilterList: [],
            deptFilterList: [],
            registeredNumberFilterList: [],
            techinicalTeamFilterList: [],
            mailboxAddressFilterList: [],
            chatbotFilterList: [],
            webChatFilterList: [],
            categoriesFilterList: [],
            externalFormsFilterList: [],
            classificationFilterList: [],
            customerNumberFilterList: [],
            customOrganizationFilterFields: [],
            customOrganizationFilterFieldsValues: [],
            customOrganizationFilterFieldsList: [],
            loadingOrganizationFilter: false,
            loadingCategoryFilter: false,
            loadingStatusFilter: false,
            loadingTypeFilter: false,
            loadingRequestUserFilter: false,
            loadingAssignedUserFilter: false,
            loadingLocationFilter: false,
            loadingOriginFilter: false,
            loadingGeoLocationFilter: false,
            loadingDeptFilter: false,
            loadingTechinicalTeamFilter: false,
            loadingChatbotFilter: false,
            loadingWebChatFilter: false,
            loadingExternalFormsFilter: false,
            loadingCustomerNumberFilter: false,
            loadingMailboxAddressFilter: false,
            loadingRegisteredNumberFilter: false,
            orderCurrent: null,
            filterOrder: null,
            filtersCalled: {
                calledId: undefined,
                calledTitle: "",
                organizationId: undefined,
                categoryId: undefined,
                statusId: undefined,
                typeId: undefined,
                requestuserId: undefined,
                assigneduserId: undefined,
                openDate: undefined,
                locationId: undefined,
                classification: undefined,
                originId: undefined,
                geolocalization: undefined,
                requestusermailId: undefined,
                requestUserEmail: undefined,
                requestuserdocument: undefined,
                externalFormsId: undefined,
                deptId: undefined,
                techinicalteamId: undefined,
                mailboxaddress: undefined,
                registerednumber: undefined,
                customernumber: undefined,
                webchat: undefined,
                chatbot: undefined,
                tagIds: undefined,
            },
            callSearchQueue: [], // Adiciona a fila ao estado
            isProcessingQueue: false, // Adiciona o 
            dateStart: moment().format('YYYY/MM/DD HH:mm:ss'),
            dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
            dateOptions: [
                { id: 1, name: 'Data de abertura' },
                { id: 2, name: 'Data da solução' }
            ],
            dateOptionSelected: { id: 1, name: 'Data de abertura' },
        };

        this.orderTwoActions = [
            "id", "title", "open", "duedate"
        ]

        this.changeValues = this.changeValues.bind(this);
        this.changeValuesCreateTableCustomDialog = this.changeValuesCreateTableCustomDialog.bind(this)
        this.getCalledsToCard = this.getCalledsToCard.bind(this);
        this.getStatisticsCalledsByDueDate = this.getStatisticsCalledsByDueDate.bind(this);
        this.fetchTheGetStatisticsCalledsByDueDate = this.fetchTheGetStatisticsCalledsByDueDate.bind(this);
        this.setAccordion = this.setAccordion.bind(this)
        this.handleInputChange = this.handleInputChange.bind(this)
        this.closeNotification = this.closeNotification.bind(this);
        this.closeCreateTableCustomDialog = this.closeCreateTableCustomDialog.bind(this)
        this.openCreateTableCustomDialog = this.openCreateTableCustomDialog.bind(this)
        this.openListTableCustomDialog = this.openListTableCustomDialog.bind(this)
        this.closeListTableCustomDialog = this.closeListTableCustomDialog.bind(this)
        this.closeEditStep = this.closeEditStep.bind(this)
        this.setEditStep = this.setEditStep.bind(this)
        this.setFilters = this.setFilters.bind(this)
        this.openConfirmDeleteTableCustomFilterDialog = this.openConfirmDeleteTableCustomFilterDialog.bind(this)
        this.closeConfirmDeleteTableCustomFilterDialog = this.closeConfirmDeleteTableCustomFilterDialog.bind(this)
        this.editTableCustomFilter = this.editTableCustomFilter.bind(this)
        this.addFilterOnComponentDidMount = this.addFilterOnComponentDidMount.bind(this)
        this.callSearch = this.callSearch.bind(this);
        this.callSearchEdit = this.callSearchEdit.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.clearFields = this.clearFields.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.removeCalledFromList = this.removeCalledFromList.bind(this);
        
        this.checkEmail = this.checkEmail.bind(this);
        this.addFilter = this.addFilter.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.videoCallClick = this.videoCallClick.bind(this);
        this.setCurrentPopupData = this.setCurrentPopupData.bind(this);
        this.consultCalled = this.consultCalled.bind(this);
        this.loading = this.loading.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleOrderDelete = this.handleOrderDelete.bind(this)
        this.handleDeleteFilterEdit = this.handleDeleteFilterEdit.bind(this)
        this.handleDeleteOrderEdit = this.handleDeleteOrderEdit.bind(this)
        this.VertexIsAvaliable = this.VertexIsAvaliable.bind(this);
        this.getById = this.getById.bind(this);
        this.getOrganizations = this.getOrganizations.bind(this);
        this.getOrganizationsSettings = this.getOrganizationsSettings.bind(this);
        this.setCountLoading = this.setCountLoading.bind(this)
        this.getCalleds = this.getCalleds.bind(this);
        this.handleClickFilterMenu = this.handleClickFilterMenu.bind(this)
        this.handleCloseFilterMenu = this.handleCloseFilterMenu.bind(this)
        this.getFavoritesAndCountByUserIdAndTableName = this.getFavoritesAndCountByUserIdAndTableName.bind(this)
        this.getFavoritesByUserIdAndTableName = this.getFavoritesByUserIdAndTableName.bind(this)
        this.getCountByUserIdAndTableName = this.getCountByUserIdAndTableName.bind(this)
        this.saveTableCustomFilter = this.saveTableCustomFilter.bind(this)
        this.openConfirmAssignCalledDialog = this.openConfirmAssignCalledDialog.bind(this)
        this.closeConfirmAssignCalledDialog = this.closeConfirmAssignCalledDialog.bind(this)
        this.openConfirmTreatCalledDialog = this.openConfirmTreatCalledDialog.bind(this)
        this.closeConfirmTreatCalledDialog = this.closeConfirmTreatCalledDialog.bind(this)
        this.confirmTreatCalled = this.confirmTreatCalled.bind(this)
        this.openTreatCalledModal = this.openTreatCalledModal.bind(this)
        this.closeTreatCalledModal = this.closeTreatCalledModal.bind(this)
        this.openMassMoveCalledModal = this.openMassMoveCalledModal.bind(this)
        this.closeMassMoveCalledModal = this.closeMassMoveCalledModal.bind(this)
        this.assignCalledForTreatment = this.assignCalledForTreatment.bind(this)
        this.showNotification = this.showNotification.bind(this)
        this.setColumnTitles = this.setColumnTitles.bind(this)
        this.calledListDataFormmat = this.calledListDataFormmat.bind(this)
        this.arrayUnique = this.arrayUnique.bind(this)
        this.populateAllCalleds = this.populateAllCalleds.bind(this)
        this.getCalledCostCount = this.getCalledCostCount.bind(this)
        this.assignCalled = this.assignCalled.bind(this)
        this.goToCalled = this.goToCalled.bind(this)
        this.showMessage = this.showMessage.bind(this)
        this.openConfirmAssignCalledDialogFinal = this.openConfirmAssignCalledDialogFinal.bind(this)
        this.handleChangeFieldValue = this.handleChangeFieldValue.bind(this)
        this.handleClickExportToCSV = this.handleClickExportToCSV.bind(this)
        this.openPopulateCalledsDialog = this.openPopulateCalledsDialog.bind(this)
        this.closePopulateCalledsDialog = this.closePopulateCalledsDialog.bind(this)
        this.closeCanAssignCalledDialog = this.closeCanAssignCalledDialog.bind(this)
        this.openCanAssignCalledDialog = this.openCanAssignCalledDialog.bind(this)
        this.negativeCanAssignCalledDialog = this.negativeCanAssignCalledDialog.bind(this)
        this.handleChangeValue= this.handleChangeValue.bind(this)
        this.RateLimit = this.RateLimit.bind(this);
    }

    //É necessário devido a retrocontabilidade dos filtros antigos
    addFilter2InFilter1 = async () => {
        const intl = this.props.intl;
        const newFielter2 = localStorage.getItem('newFilter2');
        if(newFielter2 != null && newFielter2 != "", newFielter2 != "null") {
            localStorage.setItem("newFilter", newFielter2);
        }
        
        const newSearch2 = localStorage.getItem('newSearch2');
        if(newSearch2 != null && newSearch2 != "", newSearch2 != "null") {
            localStorage.setItem("newSearch", newSearch2);
        }

        const newOrderFilter2 = localStorage.getItem('newOrderFilter2');
        if(newOrderFilter2 != null && newOrderFilter2 != "", newOrderFilter2 != "null") {
            localStorage.setItem("newOrderFilter", newOrderFilter2);

            const orderSelected = this.state.orderNewFields.filter(f => f.id == newOrderFilter2);
            const sele = orderSelected .length > 0 ? orderSelected[0] : { name: intl.formatMessage({ id: "open.date" }), id: "open" };

            this.setState({orderSelected: sele});
        }

        const newOrderSearch2 = localStorage.getItem('newOrderSearch2');
        if(newOrderSearch2 != null && newOrderSearch2 != "", newOrderSearch2 != "null") {
            localStorage.setItem("newOrderSearch", newOrderSearch2);
        }
    }

    cleanLocalStorageFilter = () => {
        localStorage.removeItem("newFilter");
        localStorage.removeItem("newSearch");
        localStorage.removeItem("newOrderFilter");
        localStorage.removeItem("newOrderSearch");
    }

    async RateLimit()   {

        let url = `/users/test`;
         url = `/ratelimit`;
        
        this.setState({ loading:true })
    
        await Api.get(url)
          .then(result => {
            if (result.data.success) {
            }
            else {
              const intl = this.props.intl;
              this.setState({
                openNotification: true, notificationVariant: "error",
                notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
              });
            }
          })
          .catch(err => {
            const intl = this.props.intl;
            this.setState({
              openNotification: true, notificationVariant: "error",
              notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
            });
          });
    
    
         this.setState({ loading:false })
    }
    

    closeCanAssignCalledDialog = _ => this.setState({ canAssignCalledDialogOpen: false, canAssignCalledRowData: null,
        canAssignCalledNewTab: false })

    openCanAssignCalledDialog = (rowData, newTab = false) => {
        if (this.isTechnical && !this.isClient && !this.isCoordenator && !this.isAdmOrg && !this.admGlobal && !this.isAdm && rowData && rowData.status && rowData.status.statustypeid && rowData.status.statustypeid == 1) {
            this.setState({
                canAssignCalledDialogOpen: true,
                canAssignCalledRowData: rowData,
                canAssignCalledNewTab: newTab
            })
        } else {
            this.goToCalled(rowData, newTab)
        }
    }

    changeSelectedOrderFilter = (value) => {
        this.setState({
            orderFilterSelected: value,
        });

        setTimeout(() => {
            this.submitNewFilter();
        }, 100);
    }

    handleChangeValue = (name, value) => {
        this.setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    changeSelectedTypeOrderFilter = (value) => {
        this.setState({
            orderTypeFilterSelected: value,
        });
    }

    changeDrawerOpenFilter = () => {
        let actualValue = this.state.openDrawerFilterMenu;
        this.setState({
            openDrawerFilterMenu: !actualValue,
        })
    }

    openDrawerOrder = (value) => {
        this.setState({
            orderCurrent: value?.currentTarget,
        });
    }

    closeDrawerOrder = () => {
        this.setState({
            orderCurrent: null,
        });
    }

    negativeCanAssignCalledDialog = async _ => {
        this.setState({
            canAssignCalledDialogOpen: false,
            canAssignCalledRowData: null,
            canAssignCalledNewTab: false
        })
        await this.goToCalled(this.state.canAssignCalledRowData, this.state.canAssignCalledNewTab)
    }

    confirmCanAssignCalledDialog = async _ => {
        this.setState({
            canAssignCalledDialogOpen: false,
            canAssignCalledNewTab: false,
            calledToAssign: this.state.canAssignCalledRowData
        }, () => this.assignCalled())
    }

    openPopulateCalledsDialog = _ => this.setState({ populateCalledsDialogOpen: true })
    closePopulateCalledsDialog = _ => this.setState({ populateCalledsDialogOpen: false })

    handleClickExportToCSV = () => {
        this.setState({ loading: true });

        let url = "calleds/getallcsv"

        let newFilter = localStorage.getItem('newFilter');
        let newSearch = localStorage.getItem('newSearch');
        let newOrderFilter = localStorage.getItem('newOrderFilter');
        let newOrderSearch = localStorage.getItem('newOrderSearch');

        url += `?type=0`;

        if (newFilter != '' && newSearch != '') {

            url += `&search=${newSearch}&field=${newFilter}`;
            this.setState({ dataFilter: true });
        }
        if (newOrderFilter != '' && newOrderSearch != '') {
            url += `&osearch=${newOrderSearch}&ofield=${newOrderFilter}`
        }
        let filter = ""
        if (filter != '') {
            url = url + '&filter=' + filter;
        }

        url += `&isfinished=${this.state.isFinished}`;

        url += `&isarchived=${this.state.isArchived}`;

        url += `&iscanceled=${this.state.isCanceled}`;

        Api.get(url, {
            responseType: 'blob'
        })
            .then((response) => {

                /*let url = window.URL.createObjectURL(new Blob([response.data]));
                saveAs(url, 'called_list.csv');*/
                fileDownload(response.data, `called_list.csv.zip`);
                this.setState({ loading: false });
            })
            .catch((error) => {
                this.setState({ loading: false });
            });
    }

    async getCalledsToCard() {
    
    
        this.setState({ loading: true })
      
    
        let url = `/cards/getcalledstocards`;
    
        await Api.get(url)
          .then(result => {
            if (result.data.success) {
              this.setState({
                countOpenCalleds: result.data.data.countopencalleds,
                countPendingCalledsToday: result.data.data.countpendingcalledstoday,
                countExpiredCalleds: result.data.data.countexpiredcalleds,
                countExpiredCalledsToday: result.data.data.countexpiredcalledstoday,
                countCalledsWithoutAssignedUser: result.data.data.countcalledswithoutassigneduser,
                countOpenCalledsToday : result.data.data.countopencalledstoday
               
              });
            }
            else {
              const intl = this.props.intl;
              this.setState({
                openNotification: true, notificationVariant: "error",
                notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
              });
            }
          })
          .catch(err => {
            const intl = this.props.intl;
            this.setState({
              openNotification: true, notificationVariant: "error",
              notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
            });
          });
    
    
         this.setState({ loading:false })
      }

    async getStatisticsCalledsByDueDate() {
        this.setState({ loading: true })

        let url = `/cards/getStatisticsCalledsByDueDate`;
        await Api.get(url)
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        countCalledsDueDateToday: result.data.data.countcalledsduedatetoday,
                        countCalledsDueDateWeek: result.data.data.countcalledsduedateweek,
                        countCalledsDueDateMonth: result.data.data.countcalledsduedatemonth,

                        //IS fetchTheGetStatisticsCalledsByDueDate
                        isFetchTheGetStatisticsCalledsByDueDate: true
                    });
                }
                else {
                    const intl = this.props.intl;
                    this.setState({
                        openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch(err => {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
            });

        this.setState({ loading: false })
    }

    async fetchTheGetStatisticsCalledsByDueDate() {
        const { isFetchTheGetStatisticsCalledsByDueDate } = this.state;

        if (!isFetchTheGetStatisticsCalledsByDueDate) {
            await this.getStatisticsCalledsByDueDate();
        }
    }

    handleChangeFieldValue = (value) => {
        const { intl } = this.props
        PapiroConsole.log("=== handleChangeFieldValue ===")
        PapiroConsole.log(value)

        let returnAction = [
            {
                id: 1,
                name: intl.formatMessage({ id: "search" })
            }
        ]

        let twoActions = this.orderTwoActions.find(e => e === value)
        PapiroConsole.log(twoActions)
        if (twoActions && twoActions.length > 0) {
            returnAction = [
                {
                    id: 1,
                    name: intl.formatMessage({ id: "search" })
                },
                {
                    id: 2,
                    name: intl.formatMessage({ id: "order" })
                }
            ]
        }
        PapiroConsole.log(returnAction)

        return returnAction
    }

    showMessage = async ( loading , openNotification , notificationVariant , notificationMessage) =>  {
            await this.setState({
                loading: loading,
                openNotification: openNotification,
                notificationVariant: notificationVariant,
                notificationMessage: notificationMessage
            });
    }

    openConfirmAssignCalledDialog = async (rowData) =>  {
        const intl = this.props.intl;
        
        if(rowData.assigneduserid != null && typeof rowData.assigneduserid !== 'undefined' && rowData.assigneduserid > 0) {
            await this.setState({
                openNotification: true,
                notificationVariant: "info",
                notificationMessage: intl.formatMessage({id:"called.list.notification.call.has.assigned.tech"})
            });
        } else {
            this.setState({ confirmAssignCalledDialogOpen: true, calledToAssign: rowData })
        }
    }

	openConfirmAssignCalledDialogFinal = async (confirm, rowData) =>  {
            this.setState({ confirmAssignCalledDialogOpen: confirm, calledToAssign: rowData })
    }

    closeConfirmAssignCalledDialog = () => this.setState({ confirmAssignCalledDialogOpen: false, calledToAssign: null })

    // O chamado já em tratamento pertence ao usuário logado? Nesse caso ele pode RETOMAR o
    // tratamento rápido (abre direto, sem diálogo — não há nada a assumir). Se o responsável for
    // outro técnico, segue bloqueado como antes.
    isCalledAssignedToLoggedUser = (called) => {
        const loggedUserId = (this.props.userSession && this.props.userSession.user) ? this.props.userSession.user.id : null
        if (loggedUserId == null || called == null) return false
        if (called.assigneduserid != null && Number(called.assigneduserid) === Number(loggedUserId)) return true
        if (called.assigneduser && called.assigneduser.id != null && Number(called.assigneduser.id) === Number(loggedUserId)) return true
        return false
    }

    openConfirmTreatCalledDialog = (called) => {
        const hasAssignedUser = called.assigneduserid != null && typeof called.assigneduserid !== 'undefined' && called.assigneduserid > 0

        if (hasAssignedUser && this.isCalledAssignedToLoggedUser(called)) {
          // Retomada: abre o modal direto (o modal recebe skipAssignment e não reatribui).
          this.openTreatCalledModal(called);
        } else if (hasAssignedUser) {
          this.showMessage( false, true, "info", "O chamado já iniciou o tratamento.");
        } else {
          this.setState({ confirmTreatCalledDialogOpen: true, calledToTreat: called });
        }
    }

    closeConfirmTreatCalledDialog = () => {
        this.setState({ confirmTreatCalledDialogOpen: false, calledToTreat: null });
    }

    confirmTreatCalled = () => {
        const called = this.state.calledToTreat;
        this.setState({ confirmTreatCalledDialogOpen: false });
        this.openTreatCalledModal(called);
    }

    openTreatCalledModal = (called) => {
        this.props.setTreatCalledModalData(called);
        this.setState({ treatCalledModalOpen: true, calledToTreat: called, calledToAssign: called });
    }

    closeTreatCalledModal = () => {
        this.setState({ treatCalledModalOpen: false });
    }

    openMassMoveCalledModal = () => {
        this.setState({ massMoveCalledModalOpen: true });
    }

    closeMassMoveCalledModal = () => {
        this.setState({ massMoveCalledModalOpen: false });
    }

    assignCalledForTreatment = async () => {
        console.log("=== assignCalledForTreatment chamado ===");

        let calledToAssign = this.state.calledToAssign;
        if(calledToAssign == null) {
            console.error("calledToAssign é null!");
            return false;
        }

        const { userSession } = this.props;
        const intl = this.props.intl;

        let data = new FormData();
        data.append("calledid", calledToAssign.id);
        data.append("userid", userSession.user.id);

        try {
            const result = await Api.post(`/calleds/canassignuser/team/treat`, data);

            if (result.data.success) {
                this.setState({
                    openNotification: true,
                    notificationVariant: "success",
                    notificationMessage: intl.formatMessage({id:"called.list.notification.called.taken"}),
                });
                // NÃO chama goToCalled aqui, pois queremos manter o usuário no modal
                // this.goToCalled(calledToAssign);
                console.log("Atribuição bem-sucedida!");
                return true;
            }

            return false;
        } catch (err) {
            console.error("Erro ao atribuir chamado:", err);
            this.setState({
                openNotification: true,
                notificationVariant: "error",
                notificationMessage:
                    err.response &&
                    err.response.data &&
                    err.response.data.errors &&
                    err.response.data.errors[0]
                    ? err.response.data.errors[0]
                    : intl.formatMessage({ id: "process.error" }),
            });
            Api.kickoff(err);
            return false;
        }
    }

    showNotification = (variant, message) => {
        this.setState({
            openNotification: true,
            notificationVariant: variant,
            notificationMessage: message,
        });
    }

    removeCalledFromList = (calledId) => {
        console.log("=== removeCalledFromList chamado ===");
        console.log("ID do chamado a remover:", calledId);
        console.log("Lista antes:", this.state.calledsList.length, "chamados");

        this.setState(prevState => {
            const novaLista = prevState.calledsList.filter(called => called.id !== calledId);
            console.log("Lista depois:", novaLista.length, "chamados");
            return { calledsList: novaLista };
        });
    }

    closeListTableCustomDialog = () => { 
        const intl = this.props.intl;   
        this.setState({listTableCustomDialogOpen: !this.state.listTableCustomDialogOpen, editTableCustomFilterStep: 1, customFilters: intl.formatMessage({id:"custom.filters"}), contentFilterEdit: '', contentOrderEdit: '' })
    }
    openListTableCustomDialog = () => {
        this.handleCloseFilterMenu()
        this.setState({ listTableCustomDialogOpen: true, listTableCustomDialogLoading: true }, () => {
            this.listTableCustomFilters(true)
        })
    }

    closeCreateTableCustomDialog = () => this.setState({ createTableCustomDialogOpen: !this.state.createTableCustomDialogOpen })

    openCreateTableCustomDialog = async () => {


        this.setState({ loading: true })
        const intl = this.props.intl;

        if (this.state.tableCustomFilterOrganizationList == null || (this.state.tableCustomFilterOrganizationList && this.state.tableCustomFilterOrganizationList.length == 0))
        {
            let result = await getAllSelectionModelToTableCustomFilterByRoleType();
            if(result && result.success) {
                if(result.data != null)
                    this.setState({ loading: false, tableCustomFilterOrganizationList: result.data })
            } else {
                this.setState({
                  loading: false,
                  openNotification: true,
                  notificationVariant: 'error',
                  notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(result)
            }
        }

		if(this.state.contentFilter || this.state.contentOrder){
            if ((this.isClient) || (this.isTechnical && !this.isAdm && !this.admGlobal)) {
                this.setState(prevState => ({
                    createTableCustomDialog: {
                        ...prevState.createTableCustomDialog,
                        isPrivate: true,
                    },
                    createTableCustomDialogOpen: !this.state.createTableCustomDialogOpen,
                    loading: false,
                }));
            } else {
                this.setState({ createTableCustomDialogOpen: !this.state.createTableCustomDialogOpen,loading: false, });
            }
		}
		else{
			this.setState({
                openNotification: true, notificationVariant: "error",
                loading: false,
                notificationMessage: intl.formatMessage({id:"called.list.notification.missing.filter"})
            });
		}
	}

    openConfirmDeleteTableCustomFilterDialog = (id) => this.setState({ confirmDeleteTableCustomFilterDialogOpen: !this.state.confirmDeleteTableCustomFilterDialogOpen, tableCustomFilterToDeleteId: id })

    closeConfirmDeleteTableCustomFilterDialog = () => this.setState({ confirmDeleteTableCustomFilterDialogOpen: !this.state.confirmDeleteTableCustomFilterDialogOpen, tableCustomFilterToDeleteId: 0 })

    closeEditStep = () => {
        const intl = this.props.intl;
        this.setState({
            editTableCustomDialog: this.editTableCustomDialogInitialState,
            editTableCustomFilterStep: 1,
            customFilters: intl.formatMessage({id:"custom.filters"}),
            contentFilterEdit: '',
            contentOrderEdit: ''
        })
    }

    setEditStep = async (id) => {
        this.setState({ listTableCustomDialogLoading: true })

        if (this.state.tableCustomFilterOrganizationList == null || (this.state.tableCustomFilterOrganizationList && this.state.tableCustomFilterOrganizationList.length == 0))
        {
            let result = await getAllSelectionModelToTableCustomFilterByRoleType();
            if(result && result.success) {
                if(result.data != null)
                    this.setState({ listTableCustomDialogLoading: false, tableCustomFilterOrganizationList: result.data })
            } else {
                const intl = this.props.intl
                this.setState({
                  listTableCustomDialogLoading: false,
                  openNotification: true,
                  notificationVariant: 'error',
                  notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(result)
            }
        }

        let tableCustom = null
        PapiroConsole.log(this.state.listTableCustomDialogList)
        PapiroConsole.log("this.state.listTableCustomDialogList")
        if(this.state.listTableCustomDialogList && this.state.listTableCustomDialogList.length > 0) {
            PapiroConsole.log("entrei no if")
            let tableCustomFilter = this.state.listTableCustomDialogList.filter(item => item.id == id)
            PapiroConsole.log("tableCustomFilter")
            PapiroConsole.log(tableCustomFilter)
            
            if(tableCustomFilter && tableCustomFilter.length > 0) {
                tableCustom = tableCustomFilter[0]
            } else {
                PapiroConsole.log("entrei no else")
                let result = await TableCustomFilterService.getById(id)

                PapiroConsole.log("result")
                PapiroConsole.log(result)
                if(result && result.success) {
                    if(result.data != null)
                        tableCustom = result.data
                } else {
                    const intl = this.props.intl
                    this.setState({
                      listTableCustomDialogLoading: false,
                      openNotification: true,
                      notificationVariant: 'error',
                      notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result)
                }
            }
        } else {
            PapiroConsole.log("entrei no else dois")
            let result = await TableCustomFilterService.getById(id)
            PapiroConsole.log("result 2")
            if(result && result.success) {
                if(result.data != null)
                    tableCustom = result.data
            } else {
                const intl = this.props.intl
                this.setState({
                  listTableCustomDialogLoading: false,
                  openNotification: true,
                  notificationVariant: 'error',
                  notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(result)
            }
        }

        PapiroConsole.log("=== tableCustom")
        PapiroConsole.log(tableCustom)
        if(tableCustom != null) {
            const intl = this.props.intl
            const { userSession } = this.props;

            let displayFilterInCreatorCalledList = false
            let displayFilterInCalledList = false

            let checkIfUserLoggedAddFilterInCalledList = await TableCustomFilterService.getByIdAndUserId(tableCustom.id,userSession.user.id )
            if(checkIfUserLoggedAddFilterInCalledList && checkIfUserLoggedAddFilterInCalledList.success) {
                if(checkIfUserLoggedAddFilterInCalledList.data != null)
                    if(checkIfUserLoggedAddFilterInCalledList.data.tablecustomfilterappearincalledlist != null){

                        displayFilterInCalledList = true
                    }
            }


            if(this.admGlobal && tableCustom.userid != userSession.user.id){

                PapiroConsole.log("entrei no if da requisição")
                let checkIfUserOfFilterAddFilterInCalledList = await TableCustomFilterService.getByIdAndUserId(tableCustom.id,tableCustom.userid )
                if(checkIfUserOfFilterAddFilterInCalledList && checkIfUserOfFilterAddFilterInCalledList.success) {
                    if(checkIfUserOfFilterAddFilterInCalledList.data != null)
                        if(checkIfUserOfFilterAddFilterInCalledList.data.tablecustomfilterappearincalledlist != null){
                            PapiroConsole.log("entrei nesse if checkIfUserOfFilterAddFilterInCalledList")
                            displayFilterInCreatorCalledList = true
                        }
                }


            }

            this.setState(prevState => ({
                editTableCustomDialog: {
                    ...prevState.editTableCustomDialog,
                    id: tableCustom.id,
                    userId: tableCustom.userid,
                    name: tableCustom.name,
                    isPrivate: ((this.isClient) || (this.isTechnical && !this.isAdm && !this.admGlobal)) ? true : tableCustom.isprivate,
                    isFavorite: tableCustom.tablecustomfilterfavorite != null ? true : false,
                    isDefault: tableCustom.tablecustomfilterdefault != null ? true : false,
                    exhibitionName: tableCustom.exhibitionname != null ? tableCustom.exhibitionname : '',
                    displayFilterInCalledList : displayFilterInCalledList,
                    displayFilterInCreatorCalledList : displayFilterInCreatorCalledList,
                    tableCustomFilterOrganizationIds: tableCustom.tablecustomfilterorganizations.map(item => { return item.organization }),
                    tablecustomfilterorganizations: tableCustom.tablecustomfilterorganizations != null ? tableCustom.tablecustomfilterorganizations : [],
                    tablecustomfilterfields: tableCustom.tablecustomfilterfields != null ? tableCustom.tablecustomfilterfields : []
                },
                editTableCustomFilterStep: 2,
                customFilters: intl.formatMessage({id:"custom.filter.edit"}),
                listTableCustomDialogLoading: false
            }), () => this.setFiltersEdit(tableCustom))
        } else {
            const intl = this.props.intl
            this.setState({
                listTableCustomDialogLoading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: intl.formatMessage({ id: "process.error" })
            })
        }


       
    }

    handleClickFilterMenu = (event) => {
        this.setState({ filterMenuAnchorEl: event.currentTarget })
    }

    handleCloseFilterMenu = _ => {
        this.setState({ filterMenuAnchorEl: null })
    }

    searchFilter = async _ => {
        this.setState({ listTableCustomDialogLoading: true })
        if(this.state.searchValueListTableCustomField && this.state.searchValueListTableCustomField.length > 0) {
            const { userSession } = this.props
            const intl = this.props.intl;
            let userId = userSession && userSession.user && userSession.user.id

            let formData = new FormData();
            formData.append("userid", userId)
            formData.append("tablename", "calleds")
            formData.append("search", this.state.searchValueListTableCustomField)

            var result = await TableCustomFilterService.getAllByUserIdAndTableNameSearch(formData)
            PapiroConsole.log("print resultado aqui")
            PapiroConsole.log(result)
            if(result && result.success) {
                if(result.data != null) {
                    let formattedList = result.data.map(item => {
                        return {
                            ...item,
                            isfavorite: item.tablecustomfilterfavorite != null ? true : false,
                            isDefault: item.tablecustomfilterdefault != null ? true : false,
                            exhibitionName: item.exhibitionname != null ? item.exhibitionname : '',
                            filterCreatorName: item.user? item.user.name : '' ,
                            displayFilterInCalledList : item.tablecustomfilterappearincalledlist ? this.props.intl.formatMessage({id:"yes"}) : this.props.intl.formatMessage({id:"no"}),
                            deleteId: { id: item.id, user: item.userid == userId ? true : false },
                            editId: { id: item.id, user: item.userid == userId ? true : false },
                            isPrivateText: item.isprivate ? this.props.intl.formatMessage({id:"yes"}) : this.props.intl.formatMessage({id:"no"}),
                            data: item
                        }
                    })

                    this.setState({
                        listTableCustomDialogLoading: false,
                        listTableCustomDialogList: formattedList,
                        editTableCustomFilterStep: 1,
                        customFilters: intl.formatMessage({id:"custom.filters"}),
                        contentFilterEdit: '',
                        contentOrderEdit: '',
                        searchValueListTableCustomField: ''
                    })
                }
            } else {
                const intl = this.props.intl
                this.setState({
                listTableCustomDialogLoading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(result)
            }
        } else {
            const intl = this.props.intl;

            this.setState({
                listTableCustomDialogLoading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: intl.formatMessage({id:"called.list.notification.insert.search.value"})
            })
        }
    }

    setFilters = async (item, modal = '') => {
        let { intl } = this.props
        if(modal && modal.length > 0) {
            if(modal == 'listCustomTableFilter')
                this.closeListTableCustomDialog()
        }

        this.handleCloseFilterMenu();
        localStorage.setItem('newFilter', '');
        localStorage.setItem('newSearch', '');
        localStorage.setItem('newOrderFilter', '');
        localStorage.setItem('newOrderSearch', '');

        localStorage.setItem('newFilter2', '');
        localStorage.setItem('newSearch2', '');
        localStorage.setItem('newOrderFilter2', '');
        localStorage.setItem('newOrderSearch2', '');
        PapiroConsole.log("content filter atualizado 1")
        await this.setState({ filterSelected: 0, searchValue: '', contentFilter: '', contentOrder: '', loading: true })

        let newFilter = ''
        let newSearch = ''
        let newOrderFilter = ''
        let newOrderSearch = ''
        item.tablecustomfilterfields.map(field => {

            let operator = ''

            switch(field.operator) {
                case 1:
                    operator = ' == '
                    break
                case 2:
                    operator = ' = '
                    break
                case 3:
                    operator = ' STARTS WITH '
                    break
                case 4:
                    operator = ' ENDS WITH '
                    break
                case 5:
                    operator = ' IS EMPTY '
                    break
                case 6:
                    operator = ' IS NOT EMPTY '
                    break
                case 7:
                    operator = ' BIGGER THEN '
                    break
                case 8:
                    operator = ' LESS THAN '
                    break
                case 9:
                    operator = ' BIGGER OR EQUAL '
                    break
                case 10:
                    operator = ' LESS OR EQUAL '
                    break
                case 11:
                    operator = ` ${intl.formatMessage({id:"order.filter"})}: `
                    break
            }

            if (field.field.trim() === "open") {
                let date = field.value.split("/");
                if (date.length === 3) {
                    date = `${date[2]}-${date[1]}-${date[0]}`
                }
                newFilter += field.field.trim() + "|";
                newSearch += date + "|";

                let nameField;
                for (let i = 0; i < this.state.filters.length; i++) {
                    if (this.state.filters[i].id === field.field.trim()) {
                        nameField = this.state.filters[i].name;
                    }
                }
                PapiroConsole.log("content filter atualizado 3")
                this.setState({
                    contentFilter: this.state.contentFilter + nameField + operator + field.value.trim() + "\n"
                })
            } else {
                let effectiveField = field.field.trim();
                let effectiveValue = field.value.trim();

                // Legacy fix: "tagid" saved with tag name (not numeric ID) → convert to "tag" for name-based lookup
                if (effectiveField === "tagid" && isNaN(effectiveValue)) {
                    effectiveField = "tag";
                }

                if (field.operator != 11) {
                    newFilter += effectiveField + "|";
                    newSearch += effectiveValue + "|";
                } else {
                    newOrderFilter += effectiveField + "|";
                    newOrderSearch += effectiveValue + "|";
                }

                let nameField;
                for (let i = 0; i < this.state.filters.length; i++) {
                    if (this.state.filters[i].id === effectiveField) {
                        nameField = this.state.filters[i].name;
                    }
                }
                if (field.operator != 11) {
                    PapiroConsole.log("content filter atualizado 4")
                    if (nameField !== undefined) {
                        this.setState({
                            contentFilter: `${this.state.contentFilter}${nameField}${operator}${effectiveValue}\n`
                        });
                    }
                } else {
                    if (nameField !== undefined) {
                        this.setState({
                            contentOrder: `${this.state.contentOrder}${nameField}${operator}${effectiveValue == 1 ? `${intl.formatMessage({id:"order.filter.ascending"})}\n` : `${intl.formatMessage({id:"order.filter.descending"})}`}\n`
                        });
                    }
                }
            }
        })

        localStorage.setItem("newFilter", newFilter);
        localStorage.setItem("newSearch", newSearch);
        localStorage.setItem('newOrderFilter', newOrderFilter);
        localStorage.setItem('newOrderSearch', newOrderSearch);
        
        localStorage.setItem("newFilter2", newFilter);
        localStorage.setItem("newSearch2", newSearch);
        localStorage.setItem('newOrderFilter2', newOrderFilter);
        localStorage.setItem('newOrderSearch2', newOrderSearch);
        
        //await this.getCalleds('', this.state.page)
        this.callSearch(newFilter, newSearch, 1);
    }

    setFiltersEdit = async (item) => {
        PapiroConsole.log("=== setFiltersEdit")
        PapiroConsole.log(item)
        let { intl } = this.props
        let newFilter = ''
        let newSearch = ''
        let newFilterEdit = ''
        let newOrderEdit = ''
        
        item.tablecustomfilterfields.map(field => {
            let operator = ''
            switch(field.operator) {
                case 1:
                    operator = ' == '
                    break
                case 2:
                    operator = ' = '
                    break
                case 3:
                    operator = ' STARTS WITH '
                    break
                case 4:
                    operator = ' ENDS WITH '
                    break
                case 5:
                    operator = ' IS EMPTY '
                    break
                case 6:
                    operator = ' IS NOT EMPTY '
                    break
                case 7:
                    operator = ' BIGGER THEN '
                    break
                case 8:
                    operator = ' LESS THAN '
                    break
                case 9:
                    operator = ' BIGGER OR EQUAL '
                    break
                case 10:
                    operator = ' LESS OR EQUAL '
                    break
                case 11:
                    operator = ` ${intl.formatMessage({id:"order.filter"})}: `
                    break
            }

            if (field.field.trim() === "open") {
                let date = field.value.split("/");
                if (date.length === 3) {
                    date = `${date[2]}-${date[1]}-${date[0]}`
                }
                newFilter += field.field.trim() + "|";
                newSearch += date + "|";

                let nameField;
                for (let i = 0; i < this.state.filters.length; i++) {
                    if (this.state.filters[i].id === field.field.trim()) {
                        nameField = this.state.filters[i].name;
                    }
                }

                newFilterEdit += `${nameField}${operator}${field.value.trim()}\n`
            } else {
                const rawField = field.field.trim();
                const rawValue = field.value.trim();

                // Legacy fix: "tagid" saved with tag name (non-numeric) → convert to "tag" for display
                // "tagid" with numeric ID → skip (paired "tag" entry already handles the display)
                if (rawField === "tagid") {
                    if (!isNaN(rawValue)) {
                        return; // skip numeric tagid entries — the paired "tag" entry provides the display
                    }
                    // non-numeric value means name was mistakenly stored in tagid → treat as "tag"
                }
                const effectiveField = (rawField === "tagid" && isNaN(rawValue)) ? "tag" : rawField;

                newFilter += effectiveField + "|";
                newSearch += field.operator != 11 ? rawValue + "|" : field.value == 1 ? `${intl.formatMessage({id:"order.filter.ascending"})}|` : `${intl.formatMessage({id:"order.filter.descending"})}|`

                let nameField;
                for (let i = 0; i < this.state.filters.length; i++) {
                    if (this.state.filters[i].id === effectiveField) {
                        nameField = this.state.filters[i].name;
                    }
                }

                let fieldValue = field.operator != 11 ? rawValue : field.value == 1 ? `${intl.formatMessage({id:"order.filter.ascending"})}` : `${intl.formatMessage({id:"order.filter.descending"})}`

                if (nameField !== undefined) {
                    if (field.operator != 11)
                        newFilterEdit += `${nameField}${operator}${fieldValue}\n`
                    else
                        newOrderEdit += `${nameField}${operator}${fieldValue}\n`
                }
            }
        })

        PapiroConsole.log("=== setFiltersEdit ===")
        PapiroConsole.log(newFilterEdit)
        PapiroConsole.log(newOrderEdit)

        this.setState({
            contentFilterEdit: newFilterEdit,
            contentOrderEdit: newOrderEdit
        })

       
    }

    async VertexIsAvaliable() {
        var result = await Api.VertexIsAvaliable();
        this.setState({ disabledvertex: !result });

    }

    Reload = () => {
        const reload = localStorage.getItem('reload');
        if (reload == "true") {
            localStorage.setItem('reload', false);


        }
        return null;
    }

    closeModal = () => {

        this.setState({ modalopen: false });

    }

    videoCallClick = () => {
        this.setState({ modalopen: true });
    };

    onChangePaginate = async (e, page) => {
        this.setState({
            loading: true,
        });

        this.setState({ page: page, countLoading: 0 });
        localStorage.setItem('calledsPage', `${page}`)
        await this.getCalleds('', page);
    }

    loading(choice) {
        this.setState({ loading: choice });
    }

    async getUserById(id) {
        await Api.get(`/users/${id}`)
            .then(result => {
                if (result.data.success) {
                }
            })

            .catch(err => {
                const intl = this.props.intl;
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({id:"process.error"})
                });
                Api.kickoff(err);

            });
    }

    setPagination(count, page, pageCount) {
        let result = {};
        let totalPage = Math.ceil(count / pageCount);
        //this.setState({ totalPages: totalPage })
        if (count > 0) {
            if (page == 1) {
                if (count < pageCount) {
                    //this.setState({ pageStart: 1, pageEnd: count });
					result.pageStart =1;
					result.pageEnd = count;
                } else {
                    //this.setState({ pageStart: 1, pageEnd: 10 });
					result.pageStart =1;
					result.pageEnd = pageCount;
                }
            } else {
                let pageStart = ((page - 1) * pageCount) + 1;

				result.pageStart =pageStart;


                if (count >= page * pageCount) {
                   // this.setState({ pageStart: pageStart, pageEnd: page * pageCount });
					result.pageEnd = page * pageCount ;
                } else {
                    //this.setState({ pageStart: pageStart, pageEnd: count });
					result.pageEnd = page * pageCount ;
                }
            }
			result.totalPages =totalPage;
			result.page =page;
			result.count =count;
			result.pageCount =pageCount;


        } else {
            //this.setState({ pageStart: 0, pageEnd: 0, totalPages: 0, page: 1, count: 0 });
			result.totalPages =0;
			result.page =1;
			result.count =0;
			result.pageStart =0;
			result.pageEnd = 0;
			result.pageCount = pageCount;
		}
		return result;

    }

    onFieldChange(event) {
        event.preventDefault();
        let name = event.target.name
        let value = event.target.value

        this.setState({ [name]: value });
    }

    onFieldChangeEdit = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    callSearch = async (filter, value, type = 1) => {
        this.setState({ loading: true });
        // Adicione a chamada à fila no estado
        this.setState(prevState => ({
            callSearchQueue: [...prevState.callSearchQueue, { filter, value, type }]
        }), this.processQueue); // Processa a fila após adicionar o item
    };

    processQueue = async () => {
        
        // Verifica se já está processando a fila
        if (this.state.isProcessingQueue) return;
    
        // Define o estado de processamento como verdadeiro
        this.setState({ isProcessingQueue: true });
    
        while (this.state.callSearchQueue.length > 0) {
            const { filter, value, type } = this.state.callSearchQueue[0]; // Pega o primeiro item da fila
    
            // Remove o item da fila
            this.setState(prevState => ({
                callSearchQueue: prevState.callSearchQueue.slice(1)
            }));
    
            // Processa a chamada
            
            if ((value && value.trim() !== '') && filter !== 0) {
                await this.addFilter(filter, value, type);
            }
    
            clearTimeout(this.typingTimeout);
    
            this.typingTimeout = setTimeout(async () => {
                this.onlyCleanFilterState();
    
                let newFilter = localStorage.getItem('newFilter');
                let newSearch = localStorage.getItem('newSearch');
    
                this.addValuesInNewFilter(newFilter, newSearch);
    
                await this.getCalleds('', this.state.page);
    
                this.setState({ loading: false });
            }, 1000); // Aguarda 1 segundo antes de executar
        }
    
        // Finaliza o processamento da fila
        this.setState({ isProcessingQueue: false });
    };

    /*callSearch = async (filter, value, type = 1) => {
        this.onlyCleanFilterState();
        
		if ((value && value.trim() != '') && filter != 0) {
			await this.addFilter(filter, value, type);
        }

        if ((this.state.contentFilter && this.state.contentFilter.length > 0) || (this.state.contentOrder && this.state.contentOrder.length > 0)) {
            await this.getCalleds('', this.state.page);
        }
    }*/

    callSearchEdit = async (filter, value, type = 1) => {
		if ((value && value.trim() != '') && filter != 0) {
			await this.addFilterEdit(filter, value, type);
        }
        if ((this.state.contentFilterEdit && this.state.contentFilterEdit.length > 0) || (this.state.contentOrderEdit && this.state.contentOrderEdit.length > 0)) {
            this.setState({ loading: true });
            if (this.state.editTableCustomDialog && this.state.editTableCustomDialog.id > 0)
                await this.setFilters(this.state.editTableCustomDialog, 'listCustomTableFilter')
            await this.getCalleds('', this.state.page);
            this.setState({ loading: false });
        }
    }

    async clearFields() {
        PapiroConsole.log("entrei aqui no clear fields")
        this.clearFilters();
        PapiroConsole.log(this.state.isArchived)
        PapiroConsole.log(this.state.isFinished)
        PapiroConsole.log(this.state.isArchived)
        if(this.state.isArchived == 0 && this.state.isFinished == 0 && this.state.isCanceled == 0 ){

            await this.getCalleds('', 1);
        }
        else{
            await this.setState({  loading: false })
        }
        

    }

    async clearFilters(){

        localStorage.setItem('newFilter', '');
        localStorage.setItem('newSearch', '');
        localStorage.setItem('newOrderFilter', '');
        localStorage.setItem('newOrderSearch', '');
        localStorage.setItem('calledsPage', '1');
        localStorage.setItem('newFilter2', '');
        localStorage.setItem('newSearch2', '');
        localStorage.setItem('newOrderFilter2', '');
        localStorage.setItem('newOrderSearch2', '');
        PapiroConsole.log("content filter atualizado 4")
        await this.setState({ filterSelected: 0, searchValue: '', page: 1, contentFilter: '', contentOrder: '', loading: true })

    }

    clearFieldsEdit = _ => {
        this.setState({ filterSelectedEdit: 0, searchValueEdit: '', contentFilterEdit: '', contentOrderEdit: '' })
    }

    async getOrganizationsSettings() {
        let infos;
        let id = parseInt(this.organizationId)


        await Api.get(`/organizationsettings/organization/${id}`)
            .then(result => {
                if (result.data.success) {
                    infos = result.data.data;
                }
                this.setCountLoading();

            })

            .catch(err => {
                // console.log("erro organization settings")
                const intl = this.props.intl;
                this.setState({

                    notificationMessage: intl.formatMessage({id:"error"})
                });
                Api.kickoff(err);
                this.setCountLoading();

            });
        return infos;

    }

    /*Inicio carregar campos dos filtros html ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////*/

    changeInputValuesPerFilter = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        if(name == 'requestuserdocument') {
            const mask = this.cpfMask(value);
            this.setState(prevState => ({
                filtersCalled: {
                    ...prevState.filtersCalled,
                    [name]: mask
                }
            }));
            return;
        }

        if(name) {
            this.setState(prevState => ({
                filtersCalled: {
                    ...prevState.filtersCalled,
                    [name]: value
                }
            }));
        }
    }

    changeInputValuesPerFilterTags = (name, value) => {
        this.setState(prevState => ({
            filtersCalled: {
                ...prevState.filtersCalled,
                [name]: value
            }
        }));
    }

    removeLastDuplicateByOrder = (array) => {
        const seen = new Set();
        return array
            .slice()
            .reverse()
            .filter((item) => {
                if (seen.has(item.name)) {
                    return false;
                }
                seen.add(item.name);
                return true;
            })
            .reverse();
    };

    changeValuesPerFilter = (stateName, value, text = '') => {
        if (stateName == "openDate") {
            if(value && !isNaN(Date.parse(value))) {
                this.setState(prevState => ({
                    filtersCalled: {
                        ...prevState.filtersCalled,
                        [stateName]: value
                    }
                }));
            }
            return;
        }

        if (stateName === "statusId" || 
            stateName === "organizationId" || 
            stateName === "categoryId" || 
            stateName === "typeId" || 
            stateName === "statusId" || 
            stateName === "assigneduserId" || 
            stateName === "locationId" || 
            stateName === "originId" || 
            stateName === "deptId" || 
            //stateName === "externalFormsId" || 
            stateName === "techinicalteamId" || 
            stateName === "mailboxaddress" || 
            stateName === "webchat" || 
            stateName === "chatbot"
        ) {
            const newValue = this.removeLastDuplicateByOrder(value);
            // Adicionar o novo valor ao array
            this.setState(prevState => ({
                filtersCalled: {
                    ...prevState.filtersCalled,
                    [stateName]: newValue
                }
            }));
            
        }else{
            this.setState(prevState => ({
                filtersCalled: {
                    ...prevState.filtersCalled,
                    [stateName]: value
                }
            }))
        }
        

        if(stateName == "organizationId") {
            this.setState({ categoriesFilterList: [] });
            this.setState({ locationFilterList: [] });
            this.setState({ deptFilterList: [] });
            this.setState({ customOrganizationFilterFieldsList: [] });
            this.setState(prevState => ({
                filtersCalled: {
                    ...prevState.filtersCalled,
                    ['categoryId']: undefined,
                    ['locationId']: undefined,
                    ['deptId']: undefined,
                    ['customOrganizationFilterFieldsValues']: [],
                    ['customOrganizationFilterFields']: [],
                    ['customOrganizationFilterFieldsList']: []
                }
            }))

            if(value != null && value.length > 0) {
                this.getOrganizationFields(value);   
            }
        }

        
        //this.addFilter(stateName, value.name, 1);
    }


    handleInputChangeCustomFields = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        this.setState(prevState => ({
            customOrganizationFilterFieldsValues: {
            ...prevState.customOrganizationFilterFieldsValues,
                [name]: value
            }
        }));
    }

    changeValuesCustomFields = (stateName, value, text = '') => {
        this.setState(prevState => ({
            customOrganizationFilterFieldsValues: {
                ...prevState.customOrganizationFilterFieldsValues,
                [stateName]: value
            }
        }));
    }

    returnFields() {
        var campoTexto = []
        var arrayselecao = []

        if (this.state.customOrganizationFilterFields.length > 0) {
            this.state.customOrganizationFilterFields.forEach(element => {
                const fieldType = element.organizationfieldtype;

                if (element.organizationfieldoptionsvalues.length > 0) {
                    element.organizationfieldoptionsvalues.forEach(element2 => {
                        if (fieldType == 2 || fieldType == 4 || fieldType == 6) {
                            arrayselecao.push(element2)
                        }
                    });

                    if (fieldType == 2) {
                        campoTexto.push(
                            <Grid item xs={12} style={{ padding: 10 }}>
                                <FormControl required={element.isrequired}>
                                    <FormLabel id="demo-radio-buttons-group-label">{element.name}</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        name="radio-buttons-group"
                                    >
                                        {arrayselecao.map(item =>
                                            <FormControlLabel
                                                name={'ofield-' + element.id}
                                                value={item.name + '\n' + item.id}
                                                stateName={'ofield-' + element.name}
                                                onChange={this.handleInputChangeCustomFields}
                                                control={<Radio />}
                                                label={item.name} />
                                        )}
                                    </RadioGroup>
                                </FormControl>
                            </Grid>)

                        arrayselecao = []
                    }

                    if (fieldType == 4) {
                        campoTexto.push(
                            <Grid item xs={12} style={{ padding: 10 }}>
                                <SimpleAutoComplete
                                    selected={this.state[`ofield-${element.id}`]}
                                    label={element.name}
                                    options={arrayselecao}
                                    stateName={'ofield-' + element.id}
                                    changeSelect={this.changeValuesCustomFields}
                                />
                            </Grid>
                        )

                        arrayselecao = []
                    }

                    if (fieldType == 6) {
                        campoTexto.push(
                            <Grid item xs={12} style={{ padding: 10 }}>
                                <SimpleAutoCompleteMultiple
                                    label={element.name}
                                    options={arrayselecao}
                                    stateName={"ofield-" + element.id}
                                    changeSelect={(stateName, value, text) => {
                                        const valueIds = value?.map(v => v.id).join(",") || [];

                                        this.setState(prevState => ({
                                            customOrganizationFilterFieldsValues: {
                                                ...prevState.customOrganizationFilterFieldsValues,
                                                [stateName]: valueIds
                                            }
                                        }));
                                    }}
                                />
                            </Grid>
                        );

                        arrayselecao = []
                    }
                }

                if (fieldType == 1) {
                    campoTexto.push(
                        <Grid item xs={12} style={{ padding: 10 }}>
                            <TextField
                                autoComplete="fname"
                                name={'ofield-' + element.id}
                                variant="outlined"
                                id={'ofield-' + element.id}
                                label={element.name}
                                fullWidth
                                onChange={this.handleInputChangeCustomFields}
                                inputProps={{ maxLength: element.maxlength ? element.maxlength : 250 }}
                            />
                        </Grid>
                    )
                }

                if (fieldType == 3) {
                    campoTexto.push(
                        <Grid item xs={12} style={{ padding: 10 }}>
                            <SimpleCheckBox
                                selected={(this.state[`ofield-${element.id}`] === 'true')}
                                label={element.name}
                                name={'ofield-' + element.id}
                                stateName={'ofield-' + element.id}
                                changeSelect={this.changeValuesCustomFields}
                            />
                        </Grid>
                    )
                }

                if (fieldType == 5) {
                    campoTexto.push(
                        <Grid item xs={12} style={{ padding: 10 }}>
                            <TextField
                                type="text"
                                autoComplete="off"
                                name={"ofield-" + element.id}
                                variant="outlined"
                                id={"ofield-" + element.id}
                                label={element.name}
                                fullWidth
                                inputProps={{
                                    inputMode: 'numeric',
                                    pattern: '[0-9]*',
                                    maxLength: element.maxlength || 250,
                                }}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const numericValue = value.replace(/\D/g, '');

                                    if (numericValue.length <= (element.maxlength || 250)) {
                                        e.target.value = numericValue;
                                        this.handleInputChangeCustomFields(e);
                                    }
                                }}
                            />
                        </Grid>
                    );
                }

                if (fieldType == 7) {
                    campoTexto.push(
                        <Grid item xs={12} style={{ padding: 10 }}>
                            <TextField
                                autoComplete="fname"
                                name={"ofield-" + element.id}
                                variant="outlined"
                                id={"ofield-" + element.id}
                                label={element.name}
                                fullWidth
                                multiline
                                rows={element.maxlength}
                                onChange={this.handleInputChangeCustomFields}
                            />
                        </Grid>
                    );
                }

                if (fieldType == 8) {
                    campoTexto.push(
                        <Grid item xs={12} style={{ padding: 10 }}>
                            <TextField
                                type="text"
                                autoComplete="off"
                                name={"ofield-" + element.id}
                                variant="outlined"
                                id={"ofield-" + element.id}
                                label={element.name}
                                fullWidth
                                inputProps={{
                                    inputMode: 'decimal',
                                    pattern: '^[0-9]*[.,]?[0-9]*$',
                                    maxLength: element.maxlength || 250
                                }}
                                onChange={(e) => {
                                    let value = e.target.value.replace(',', '.');
                                    const numericValue = value.replace(/[^0-9.]/g, '');

                                    if (numericValue.length <= (element.maxlength || 250)) {
                                        e.target.value = numericValue;
                                        this.handleInputChangeCustomFields(e);
                                    }
                                }}
                            />
                        </Grid>
                    );
                }

                if (fieldType == 9) {
                    campoTexto.push(
                        <Grid item xs={12} style={{ padding: 10 }}>
                            <SimpleDatePickerRequired
                                currentDate={this.state[`ofield-${element.id}`] ? this.state[`ofield-${element.id}`] : null}
                                label={element.name}
                                stateName={"ofield-" + element.id}
                                toolTipTitle={element.name}
                                changeDate={this.changeValuesCustomFields}
                            />
                        </Grid>
                    );
                }

                if (fieldType == 10) {
                    const regex = element.organizationfieldoptionsvalues.length > 0 ? element.organizationfieldoptionsvalues[0].name : '';

                    campoTexto.push(
                        <Grid item xs={12} style={{ padding: 10 }}>
                            <RegexInput
                                id={"ofield-" + element.id}
                                name={"ofield-" + element.id}
                                label={element.name}
                                regex={regex}
                                onChangeValue={this.handleInputChangeCustomFields}
                            />
                        </Grid>
                    );
                }
            });
        }

        this.setState({ customOrganizationFilterFieldsList: campoTexto });
    }

    async getOrganizationFields(organizationId) {
        
        try {

            var finalResult = [];
            for (const organization of organizationId) {
                const result = await CalledOrganizationChecklistService.getActiveOrganizationFieldsByOrganizationAndCategories(organization?.id);
                if (result.success) {
                    finalResult = finalResult.concat(result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data);
                }
            }
            this.setState({ customOrganizationFilterFields: finalResult });
            if(finalResult?.length > 0) {
                finalResult.forEach(element => {
                    if(element.organizationfieldtype == 3){
                        this.setState(prevState => ({
                            customOrganizationFilterFieldsValues: {
                                ...prevState.customOrganizationFilterFieldsValues,
                                ['ofield-' + element.id]: true
                            }
                        }))
                    }
                    else{
                        this.setState(prevState => ({
                            customOrganizationFilterFieldsValues: {
                            ...prevState.customOrganizationFilterFieldsValues,
                                ['ofield-' + element.id]: ""
                            }
                        }))
                    }
                });
    
                this.returnFields();
    
            }
        } catch(err) {
            const intl = this.props.intl;
            this.setState({
              loading: false, 
              openNotification: true, 
              notificationVariant: "error",
              notificationMessage: intl.formatMessage({ id: "process.error" })
            });
        }
        
    };

    showMessageIfDontHaveData = () => {
        this.setState({
            openNotification: true, 
            notificationVariant: "warning",
            notificationMessage: "Não existem dados para esse campo"
        });
    }

    getFilterOrganizations = async () => {

        if(this.state.organizationsFilterList.length > 0 || this.state.loadingOrganizationFilter) {
            return;
        }

        this.setState({ loadingOrganizationFilter: true });

        const { userSession } = this.props;
        
        let orgData = []

        if(userSession && userSession.user && userSession.user.userorganizations && userSession.user.userorganizations.length > 0) {
            orgData = userSession.user.userorganizations;
            const result = await CalledService.getOrganizationsDapper();
            if (result.success){
                orgData = result.data;

                if(result.data?.length == 0){
                    this.showMessageIfDontHaveData();
                }
            }
            else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true, 
                    notificationVariant: "error",
                    notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(result);
            }
        }
    
        if(orgData != null) {
            orgData = orgData.filter(c => c.active == true);
            this.setState({ 
                locationFilterList: [], 
                categoriesFilterList: [], 
                deptFilterList: [], 
                customOrganizationFilterFields: [],
                customOrganizationFilterFieldsValues: [],
                customOrganizationFilterFieldsList: [],
                organizationsFilterList: orgData && orgData.length > 1 ? orgData.sort((a, b) => a.name.localeCompare(b.name)) : orgData 
            });
        } else {
            orgData = []
            this.setState({ organizationsFilterList: orgData && orgData.length > 1 ? orgData.sort((a, b) => a.name.localeCompare(b.name)) : orgData });
        }

        this.setState({ loadingOrganizationFilter: false });
    }

    getFilterCategoriesByOrganization = async () => {

        const organizationId = this.state.filtersCalled?.organizationId;

        if (organizationId == undefined || organizationId == 0 || organizationId == null || organizationId == '' || organizationId.length == 0 || this.state.categoriesFilterList.length > 0 || this.state.loadingCategoryFilter) {
            return;
        }

        this.setState({ loadingCategoryFilter: true });

        try {
            var finalResult = [];
            for (const organization of organizationId) {
                const result = await CalledService.getCategoriesByOrganizationDapper(organization?.id);
                if (result.success) {
                    finalResult = finalResult.concat(result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data);
                }
            }
            if(finalResult?.length == 0){
                this.showMessageIfDontHaveData();
            }
            this.setState({ categoriesFilterList: finalResult });
        } catch(err) {
            const intl = this.props.intl;
            this.setState({
              loading: false, 
              openNotification: true, 
              notificationVariant: "error",
              notificationMessage: intl.formatMessage({ id: "process.error" })
            });
        }

        this.setState({ loadingCategoryFilter: false });
    };

    getFilterLocationByOrganization = async () => {

        const organizationId = this.state.filtersCalled?.organizationId;

        if (organizationId == undefined || organizationId == 0 || organizationId == null || organizationId == '' || organizationId.length == 0 || this.state.locationFilterList.length > 0 || this.state.loadingLocationFilter) {
            return;
        }

        this.setState({ loadingLocationFilter: true });

        try {
            var finalResult = [];
            for (const organization of organizationId) {
                const result = await CalledService.getOrganizationAddresses(organization?.id);
                if (result.success) {
                    finalResult = finalResult.concat(result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data);
                }
            }
            if(finalResult?.length == 0){
                this.showMessageIfDontHaveData();
            }
            this.setState({ locationFilterList: finalResult });
        } catch(err) {
            const intl = this.props.intl;
            this.setState({
              loading: false, 
              openNotification: true, 
              notificationVariant: "error",
              notificationMessage: intl.formatMessage({ id: "process.error" })
            });
        }
        

        this.setState({ loadingLocationFilter: false });
    };

    getFilterDeptByOrganization = async () => {

        const organizationId = this.state.filtersCalled?.organizationId;

        if (organizationId == undefined || organizationId == 0 || organizationId == null || organizationId == '' || organizationId.length == 0 || this.state.deptFilterList.length > 0 || this.state.loadingDeptFilter ) {
            return;
        }

        this.setState({ loadingDeptFilter: true });

        try {
            var finalResult = [];
            for (const organization of organizationId) {
                const result = await CalledService.getOrganizationDepartamentsDapper(organization?.id);
                if (result.success) {
                    finalResult = finalResult.concat(result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data);
                }
            }
            if(finalResult?.length == 0){
                this.showMessageIfDontHaveData();
            }
            this.setState({ deptFilterList: finalResult });
        } catch(err) {
            const intl = this.props.intl;
            this.setState({
              loading: false, 
              openNotification: true, 
              notificationVariant: "error",
              notificationMessage: intl.formatMessage({ id: "process.error" })
            });
        }
        

        this.setState({ loadingDeptFilter: false });
    };

    getFilterStatus = async () => {
        if(this.state.statusFilterList.length > 0 || this.state.loadingStatusFilter) {
            return;
        }

        this.setState({ loadingStatusFilter: true });

        try {
            const result = await CalledService.getStatusDapper();
            if (result.success) {
                this.setState({ statusFilterList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data });
                if(result.data?.length == 0){
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true, notificationVariant: "error",
                    notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(result);
            }
        } catch(err) {
            const intl = this.props.intl;
            this.setState({
              loading: false, 
              openNotification: true, 
              notificationVariant: "error",
              notificationMessage: intl.formatMessage({ id: "process.error" })
            });
        }
        
        this.setState({ loadingStatusFilter: false });
    }

    getFilterType = async () => {
        if(this.state.typeFilterList.length > 0 || this.state.loadingTypeFilter) {
            return;
        }

        this.setState({ loadingTypeFilter: true });

        try {
            const result = await CalledService.getTypesDapper();
            if (result.success) {
                this.setState({ typeFilterList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data });
                if(result.data?.length == 0){
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true, notificationVariant: "error",
                    notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(result);
            }
    
        } catch(err) {
            const intl = this.props.intl;
            this.setState({
              loading: false, 
              openNotification: true, 
              notificationVariant: "error",
              notificationMessage: intl.formatMessage({ id: "process.error" })
            });
        }
        
        this.setState({ loadingTypeFilter: false });
    }

    getFilterClassification = () => {
        return [
            { id: "true", name: "Sim" },
            { id: "false", name: "Não" },
            { id: "0", name: "0" },
            { id: "1", name: "1" },
            { id: "2", name: "2" },
            { id: "3", name: "3" },
            { id: "4", name: "4" },
            { id: "5", name: "5" },
            { id: "6", name: "6" },
            { id: "7", name: "7" },
            { id: "8", name: "8" },
            { id: "9", name: "9" },
            { id: "10", name: "10" },
        ];
    }

    getFilterAssignedUser = async () => {
        if(this.state.assignedUserFilterList.length > 0 || this.state.loadingAssignedUserFilter) {
            return;
        }

        this.setState({ loadingAssignedUserFilter: true });

        try {
            const result = await CalledService.getTechinicalUsersDapper();
            if (result.success) {
                this.setState({ assignedUserFilterList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data });
    
                if(result.data?.length == 0){
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true, notificationVariant: "error",
                    notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(result);
            }
        } catch(err) {
            const intl = this.props.intl;
            this.setState({
              loading: false, 
              openNotification: true, 
              notificationVariant: "error",
              notificationMessage: intl.formatMessage({ id: "process.error" })
            });
        }
        

        this.setState({ loadingAssignedUserFilter: false });
    }

    getFilterOrigin = async () => {
        if(this.state.originFilterList.length > 0 || this.state.loadingOriginFilter) {
            return;
        }

        this.setState({ loadingOriginFilter: true });

        try {
            const result = await CalledService.getOriginRequestsDapper();
            if (result.success) {
                this.setState({ originFilterList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data });
    
                if(result.data?.length == 0){
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true, notificationVariant: "error",
                    notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(result);
            }
        } catch(err) {
            const intl = this.props.intl;
            this.setState({
              loading: false, 
              openNotification: true, 
              notificationVariant: "error",
              notificationMessage: intl.formatMessage({ id: "process.error" })
            });
        }

        this.setState({ loadingOriginFilter: false });
    }

    getFilterTechinicalTeam = async () => {
        if(this.state.techinicalTeamFilterList.length > 0 || this.state.loadingTechinicalTeamFilter) {
            return;
        }

        this.setState({ loadingTechinicalTeamFilter: true });

        try {
            const result = await CalledService.getFilterTechinicalTeamDapper();
            if (result.success) {
                this.setState({ techinicalTeamFilterList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data });
    
                if(result.data?.length == 0){
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true, notificationVariant: "error",
                    notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(result);
            }
        } catch(err) {
            const intl = this.props.intl;
            this.setState({
              loading: false, 
              openNotification: true, 
              notificationVariant: "error",
              notificationMessage: intl.formatMessage({ id: "process.error" })
            });
        }
        

        this.setState({ loadingTechinicalTeamFilter: false });
    }

    getFilterExternalForms = async () => {
        if(this.state.externalFormsFilterList.length > 0 || this.state.loadingExternalFormsFilter) {
            return;
        }

        this.setState({ loadingExternalFormsFilter: true });

        try {
            const result = await CalledService.getExternalForms();
            if (result.success) {
                this.setState({ externalFormsFilterList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.title.localeCompare(b.title)) : result.data });
    
                if(result.data?.length == 0){
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true, notificationVariant: "error",
                    notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(result);
            }
        } catch(err) {
            const intl = this.props.intl;
            this.setState({
              loading: false, 
              openNotification: true, 
              notificationVariant: "error",
              notificationMessage: intl.formatMessage({ id: "process.error" })
            });
        }
        

        this.setState({ loadingExternalFormsFilter: false });
    }

    getFilterMailboxAddress = async () => {
        if(this.state.mailboxAddressFilterList.length > 0 || this.state.loadingMailboxAddressFilter) {
            return;
        }

        this.setState({ loadingMailboxAddressFilter: true });

        try {
            const result = await CalledService.getAllMailboxAddress();
            if (result.success) {
                result.data = result.data.filter(c => c.name != "");
                this.setState({ mailboxAddressFilterList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data });
                
                if(result.data?.length == 0){
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true, notificationVariant: "error",
                    notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(result);
            }
        } catch(err) {
            const intl = this.props.intl;
            this.setState({
              loading: false, 
              openNotification: true, 
              notificationVariant: "error",
              notificationMessage: intl.formatMessage({ id: "process.error" })
            });
        }
        

        this.setState({ loadingMailboxAddressFilter: false });
    }

    getFilterChatbot = async () => {

        if(this.state.chatbotFilterList.length > 0 || this.state.loadingChatbotFilter) {
            return;
        }

        this.setState({ loadingChatbotFilter: true });
        
        try {
            const result = await ChatbotService.getAllPaginate(1);
            if (result.success) {
                this.setState({ chatbotFilterList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data });
                
                if(result.data?.length == 0){
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true, notificationVariant: "error",
                    notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(result);
            }
        } catch(err) {
            const intl = this.props.intl;
            this.setState({
              loading: false, 
              openNotification: true, 
              notificationVariant: "error",
              notificationMessage: intl.formatMessage({ id: "process.error" })
            });
        }
        

        this.setState({ loadingChatbotFilter: false });
    }

    getFilterWebChat = async () => {
        
        if(this.state.webChatFilterList.length > 0 || this.state.loadingWebChatFilter) {
            return;
        }

        this.setState({ loadingWebChatFilter: true });

        try {
            const result = await WebchatService.getAllPaginate(1);
            if (result.success) {
                this.setState({ webChatFilterList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data });
                
                if(result.data?.length == 0){
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true, notificationVariant: "error",
                    notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(result);
            }
        } catch(err) {
            const intl = this.props.intl;
            this.setState({
              loading: false, 
              openNotification: true, 
              notificationVariant: "error",
              notificationMessage: intl.formatMessage({ id: "process.error" })
            });
        }
        

        this.setState({ loadingWebChatFilter: false });
    }

    getFilterRegisteredNumber = async () => {
        if(this.state.registeredNumberFilterList.length > 0 || this.state.loadingRegisteredNumberFilter) {
            return;
        }

        this.setState({ loadingRegisteredNumberFilter: true });

        try {
            const result = await getPhoneNumberList();
            if (result.success) {
                this.setState({ registeredNumberFilterList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data });
                
                if(result.data?.length == 0){
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true, notificationVariant: "error",
                    notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(result);
            }    
        } catch(err) {
            const intl = this.props.intl;
            this.setState({
              loading: false, 
              openNotification: true, 
              notificationVariant: "error",
              notificationMessage: intl.formatMessage({ id: "process.error" })
            });
        }
        
        this.setState({ loadingRegisteredNumberFilter: false });
    }

    onlyCleanFilterState = () => {
        const intl = this.props.intl;
        
        this.setState({
            filtersCalled: {
                calledId: undefined,
                calledTitle: "",
                organizationId: undefined,
                categoryId: undefined,
                statusId: undefined,
                typeId: undefined,
                requestuserId: undefined,
                assigneduserId: undefined,
                openDate: undefined,
                locationId: undefined,
                classification: undefined,
                originId: undefined,
                geolocalization: undefined,
                requestusermailId: undefined,
                requestuserdocument: "",
                externalFormsId: undefined,
                deptId: undefined,
                techinicalteamId: undefined,
                mailboxaddress: undefined,
                registerednumber: undefined,
                customernumber: undefined,
                webchat: undefined,
                chatbot: undefined,
                tagIds: undefined,
            },
            orderFilterSelected: { name: intl.formatMessage({ id: "open.date" }), id: "open" },
            displayNotFound: false,
            orderTypeFilterSelected: 'desc',
            locationFilterList: [],
            deptFilterList: [],
            categoriesFilterList: [],
            customOrganizationFilterFieldsList: [],
        });
    }

    cleanNewFilter = async () => {
        localStorage.setItem("newFilter", "");
        localStorage.setItem("newSearch", "");
        localStorage.setItem('newOrderFilter', "");
        localStorage.setItem('newOrderSearch', "");

        localStorage.setItem("newFilter2", "");
        localStorage.setItem("newSearch2", "");
        localStorage.setItem('newOrderFilter2', "");
        localStorage.setItem('newOrderSearch2', "");

        const intl = this.props.intl;

        this.onlyCleanFilterState();

        this.setState({ loading: true });
        await this.getCalleds();
        this.setState({ loading: false });
    }

    cleanDuplicateFilters = (filterString, searchString) => {
        if (!filterString || !searchString) {
            return { filter: filterString || '', search: searchString || '' };
        }

        const filters = filterString.split('|').filter(f => f);
        const searches = searchString.split('|').filter(s => s);

        // Mapear campos que têm versão com ID
        const fieldsWithId = new Set();
        const fieldPairs = {
            'org': 'orgid',
            'status': 'statusid',
            'type': 'typeid',
            'dept': 'deptid',
            'loc': 'locid',
            'origin': 'originid',
            'requestuser': 'requestuserid',
            'assigneduser': 'assigneduserid',
            'tag': 'tagid',
        };

        // Identificar quais campos ID existem
        filters.forEach(filter => {
            const fieldName = filter.toLowerCase();
            if (Object.values(fieldPairs).includes(fieldName)) {
                // Encontrar o campo base correspondente
                const baseField = Object.keys(fieldPairs).find(
                    key => fieldPairs[key] === fieldName
                );
                if (baseField) {
                    fieldsWithId.add(baseField);
                }
            }
        });

        // Filtrar removendo campos que têm versão ID
        const cleanFilters = [];
        const cleanSearches = [];

        for (let i = 0; i < filters.length && i < searches.length; i++) {
            const fieldName = filters[i].toLowerCase();
            
            // Se este campo tem versão ID e a versão ID existe, pular
            if (fieldsWithId.has(fieldName)) {
                continue;
            }
            
            cleanFilters.push(filters[i]);
            cleanSearches.push(searches[i]);
        }

        return {
            filter: cleanFilters.join('|') + (cleanFilters.length > 0 ? '|' : ''),
            search: cleanSearches.join('|') + (cleanSearches.length > 0 ? '|' : '')
        };
    }

    submitNewFilter = async (saveField = false, extraValues = {}) => {

        const filtersCalled = { ...this.state.filtersCalled, ...extraValues };
        //Preciso transformar no filtro antigo
        let nameField = '';
        let newFilter = '';
        let newSearch = '';
        let noSelectItem = true;

        if(filtersCalled.calledId && filtersCalled.calledId.length > 0) {
            noSelectItem = false;
            filtersCalled.calledId.forEach(element => {
                newFilter += "id|";
                newSearch += element + "|";
                nameField += "id = " + element + "\n";
            });
        }

        if(filtersCalled.calledTitle && filtersCalled.calledTitle != "") {
            noSelectItem = false;
            newFilter += "title|";
            newSearch += filtersCalled.calledTitle + "|";
            nameField += "title = " + filtersCalled.calledTitle + "\n";
        }
        //FILTRO AQUI
        if(filtersCalled.organizationId && filtersCalled.organizationId?.length > 0) {
            noSelectItem = false;
            filtersCalled.organizationId.forEach(element => {
                newFilter += "org|";
                newSearch += element.name + "|";
                nameField += "org = " + element.name + "\n";

                if ((this.hirerId != 1011 && this.hirerId != 1016) || this.userId == 1){
                    newFilter += "orgid|";
                    newSearch += element.id + "|";
                    nameField += "orgid = " + element.id + "\n";
                }
            });
        }

        if(filtersCalled.categoryId && filtersCalled.categoryId?.length > 0) {
            noSelectItem = false;
            filtersCalled.categoryId.forEach(element => {
                newFilter += "categoryId|";
                newSearch += element.id + "|";
                nameField += "categoryId = " + element.id + "\n";
            });
        }

        if(filtersCalled.statusId && filtersCalled.statusId?.length > 0) {
            noSelectItem = false;
            filtersCalled.statusId.forEach(element => {
                newFilter += "status|";
                newSearch += element.name + "|";
                nameField += "status = " + element.name + "\n";

                if(!element.isLegacy) {
                    if ((this.hirerId != 1011 && this.hirerId != 1016) || this.userId == 1){
                        newFilter += "statusid|";
                        newSearch += element.id + "|";
                        nameField += "statusid = " + element.id + "\n";
                    }
                }
            });
        }

        if(filtersCalled.typeId && filtersCalled.typeId?.length > 0) {
            noSelectItem = false;
            filtersCalled.typeId.forEach(element => {
                newFilter += "type|";
                newSearch += element.name + "|";
                nameField += "type = " + element.name + "\n";

                if(!element.isLegacy) {
                    if ((this.hirerId != 1011 && this.hirerId != 1016) || this.userId == 1){
                        newFilter += "typeid|";
                        newSearch += element.id + "|";
                        nameField += "typeid = " + element.id + "\n";
                    }
                }
            });
        }

        if(filtersCalled.requestuserId && filtersCalled.requestuserId?.id > 0) {
            noSelectItem = false;
            newFilter += "requestuser|";
            newSearch += filtersCalled.requestuserId?.name + "|";
            nameField += "requestuser = " + filtersCalled.requestuserId?.name + "\n";

            if ((this.hirerId != 1011 && this.hirerId != 1016) || this.userId == 1) {
                newFilter += "requestuserid|";
                newSearch += filtersCalled.requestuserId?.id + "|";
                nameField += "requestuserid = " + filtersCalled.requestuserId?.id + "\n";
            }
        }

        if(filtersCalled.assigneduserId && filtersCalled.assigneduserId.length > 0) {
            noSelectItem = false;
            filtersCalled.assigneduserId.forEach(element => {
                newFilter += "assigneduser|";
                newSearch += element.name + "|";
                nameField += "assigneduser = " + element.name + "\n";

                if(!element.isLegacy) {
                    if ((this.hirerId != 1011 && this.hirerId != 1016) || this.userId == 1) {
                        newFilter += "assigneduserid|";
                        newSearch += element.id + "|";
                        nameField += "assigneduserid = " + element.id + "\n";
                    }
                }
            });
        }

        if(filtersCalled.openDate) {
            noSelectItem = false;
            const date = new Date(filtersCalled.openDate);
            const formattedDate = date.toLocaleDateString('en-CA').replace(/-/g, '/');
            newFilter += "open|";
            newSearch += formattedDate + "|";
            nameField += "open = " + formattedDate + "\n";
        }

        if(filtersCalled.locationId && filtersCalled.locationId?.length > 0) {
            noSelectItem = false;
            filtersCalled.locationId.forEach(element => {
                newFilter += "loc|";
                newSearch += element.name + "|";
                nameField += "loc = " + element.name + "\n";

                if(!element.isLegacy) {
                    if ((this.hirerId != 1011 && this.hirerId != 1016) || this.userId == 1) {
                        newFilter += "locid|";
                        newSearch += element.id + "|";
                        nameField += "locid = " + element.id + "\n";
                    }
                }
            });
        }

        if(filtersCalled.classification) {
            noSelectItem = false;
            newFilter += "classification|";
            newSearch += filtersCalled.classification?.id + "|";
            nameField += "classification = " + filtersCalled.classification?.id + "\n";
        }

        if(filtersCalled.originId && filtersCalled.originId?.length > 0) {
            noSelectItem = false;
            filtersCalled.originId.forEach(element => {
                newFilter += "origin|";
                newSearch += element.name + "|";
                nameField += "origin = " + element.name + "\n";
                
                if(!element.isLegacy) {
                    if ((this.hirerId != 1011 && this.hirerId != 1016) || this.userId == 1) {
                        newFilter += "originid|";
                        newSearch += element.id + "|";
                        nameField += "originid = " + element.id + "\n";
                    }
                }
            });
        }

        if(filtersCalled.geolocalization) {
            noSelectItem = false;
            newFilter += "geolocalization|";
            newSearch += filtersCalled.geolocalization?.id + "|";
            nameField += "geolocalization = " + filtersCalled.geolocalization?.id + "\n";
        }

        if(filtersCalled.requestUserEmail) {
            noSelectItem = false;
            newFilter += "requestusermail|";
            newSearch += filtersCalled.requestUserEmail + "|";
            nameField += "requestusermail = " + filtersCalled.requestusermailId + "\n";
        }
        
        if(filtersCalled.requestuserdocument) {
            noSelectItem = false;
            newFilter += "requestuserdocument|";
            newSearch += filtersCalled.requestuserdocument + "|";
            nameField += "requestuserdocument = " + filtersCalled.requestuserdocument + "\n";
        }

        if(filtersCalled.expiredcall) {
            noSelectItem = false;
            newFilter += "expiredcall|";
            newSearch += filtersCalled.expiredcall + "|";
            nameField += "expiredcall = " + filtersCalled.expiredcall + "\n";
        }

        if(filtersCalled.deptId && filtersCalled.deptId?.length > 0) {
            noSelectItem = false;
            filtersCalled.deptId.forEach(element => {
                newFilter += "dept|";
                newSearch += element.name + "|";
                nameField += "dept = " + element.name + "\n";

                if(!element.isLegacy) {
                    if ((this.hirerId != 1011 && this.hirerId != 1016) || this.userId == 1) {
                        newFilter += "deptid|";
                        newSearch += element.id + "|";
                        nameField += "deptid = " + element.id + "\n";
                    }
                }
            });
        }

        if(filtersCalled.techinicalteamId && filtersCalled.techinicalteamId?.length > 0) {
            noSelectItem = false;
            filtersCalled.techinicalteamId.forEach(element => {
                newFilter += "techinicalteam|";
                newSearch += element.name + "|";
                nameField += "techinicalteam = " + element.name + "\n";
                if(!element.isLegacy) {
                    if ((this.hirerId != 1011 && this.hirerId != 1016) || this.userId == 1) {
                        newFilter += "techinicalteamid|";
                        newSearch += element.id + "|";
                        nameField += "techinicalteamid = " + element.id + "\n";
                    }
                }
            });
        }

        if(filtersCalled.mailboxaddress && filtersCalled.mailboxaddress?.length > 0) {
            noSelectItem = false;
            filtersCalled.mailboxaddress.forEach(element => {
                newFilter += "mailboxaddress|";
                newSearch += element.name + "|";
                nameField += "mailboxaddress = " + element.name + "\n";
            });
        }

        if(filtersCalled.registerednumber && filtersCalled.registerednumber?.length > 0) {
            filtersCalled.registerednumber.forEach(element => {
                newFilter += "registerednumber|";
                newSearch += element.name + "|";
                nameField += "registerednumber = " + element.name + "\n";
            });
        }

        if(filtersCalled.customernumber && filtersCalled.customernumber?.name) {
            noSelectItem = false;
            newFilter += "requestuser|";
            newSearch += filtersCalled.customernumber?.name + "|";
            nameField += "requestuser = " + filtersCalled.customernumber?.name + "\n";
            
            if ((this.hirerId != 1011 && this.hirerId != 1016) || this.userId == 1) {
                newFilter += "requestuserid|";
                newSearch += filtersCalled.customernumber?.id + "|";
                nameField += "requestuserid = " + filtersCalled.customernumber?.id + "\n";
            }
        }

        if(filtersCalled.webchat && filtersCalled.webchat?.length > 0) {
            noSelectItem = false;
            filtersCalled.webchat.forEach(element => {
                newFilter += "webchat|";
                newSearch += element.name + "|";
                nameField += "webchat = " + element.name + "\n";

                if ((this.hirerId != 1011 && this.hirerId != 1016) || this.userId == 1) {
                    newFilter += "webchatid|";
                    newSearch += element.id + "|";
                    nameField += "webchatid = " + element.id + "\n";
                }
            });
        }
        
        if(filtersCalled.chatbot && filtersCalled.chatbot?.length > 0) {
            noSelectItem = false;
            filtersCalled.chatbot.forEach(element => {
                newFilter += "chatbot|";
                newSearch += element.name + "|";
                nameField += "chatbot = " + element.name + "\n";

                if ((this.hirerId != 1011 && this.hirerId != 1016) || this.userId == 1) {
                    newFilter += "chatbotid|";
                    newSearch += element.id + "|";
                    nameField += "chatbotid = " + element.id + "\n";
                }
            });
        }

        if(filtersCalled.externalFormsId && filtersCalled.externalFormsId?.length > 0) {
            noSelectItem = false;
            filtersCalled.externalFormsId.forEach(element => {
                newFilter += "calledservicesettings|";
                newSearch += element.title + "|";
                nameField += "calledservicesettings = " + element.title + "\n";
            });
        }

        if(filtersCalled.tagIds && filtersCalled.tagIds?.length > 0) {
            noSelectItem = false;
            filtersCalled.tagIds.forEach(element => {
                newFilter += "tag|";
                newSearch += element.name + "|";
                nameField += "tag = " + element.name + "\n";
                newFilter += "tagid|";
                newSearch += element.id + "|";
            });
        }

        if(this.state.customOrganizationFilterFieldsValues != []) {
            const customFieldValuesSet = new Set(Object.values(this.state.customOrganizationFilterFieldsValues));
            Object.values(this.state.customOrganizationFilterFields).forEach((value, index) => {
                
                if (value != null && value != '') {
                    noSelectItem = false;
                    
                    if(value?.organizationfieldtype == 1 && value != null) {
                        const valueToSearch = Array.from(customFieldValuesSet)[index];
                        
                        if(valueToSearch != null && valueToSearch != '') {
                            newFilter += 'customfield' + "|";
                            //newSearch += value.name+"/"+valueToSearch + "|";
                            newSearch += valueToSearch + "|";
                        }
                    } else {
                        value?.organizationfieldoptionsvalues.forEach(fieldvalue => {
                            if (customFieldValuesSet.has(fieldvalue.id)) {

                                console.log(fieldvalue.id, customFieldValuesSet, "customOrganizationFilterFieldsValues");

                                newFilter += 'customfield' + "|";
                                //newSearch += value.name +"/"+fieldvalue.id+ "|";
                                newSearch += fieldvalue.id + "|";
                                
                                if ((this.hirerId != 1011 && this.hirerId != 1016) || this.userId == 1) {
                                    newFilter += "customfieldid|";
                                    newSearch += fieldvalue.id + "|";
                                }

                            } 
                            else if (Array.from(customFieldValuesSet).some(text => isNaN(text) && text?.includes(fieldvalue?.id?.toString()))) 
                            {
                                newFilter += 'customfield' + "|";
                                //newSearch += value.name +"/"+fieldvalue.id+ "|";
                                //newSearch += value.name + "|";
                                newSearch += fieldvalue.name + "|";

                                if ((this.hirerId != 1011 && this.hirerId != 1016) || this.userId == 1) {
                                    newFilter += "customfieldid|";
                                    newSearch += fieldvalue.id + "|";
                                }
                            }
                        });
                    }
                }
            });
        }

        localStorage.setItem("newFilter", newFilter);
        localStorage.setItem("newSearch", newSearch);

        localStorage.setItem("newFilter2", newFilter);
        localStorage.setItem("newSearch2", newSearch);

        if(this.state.orderFilterSelected && this.state.orderFilterSelected != null && this.state.orderFilterSelected != '') {
            noSelectItem = false;
            localStorage.setItem('newOrderFilter', this.state.orderFilterSelected?.id + "|");
            localStorage.setItem('newOrderSearch', this.state.orderTypeFilterSelected == "cresc" ? 1 + "|" : 2 + "|");

            localStorage.setItem('newOrderFilter2', this.state.orderFilterSelected?.id + "|");
            localStorage.setItem('newOrderSearch2', this.state.orderTypeFilterSelected == "cresc" ? 1 + "|" : 2 + "|");
        }

        if(!noSelectItem){
            this.setState({ 
                contentFilter: nameField
            });
    
            if(!saveField) {
                this.setState({ loading: true, orderCurrent: null });
                await this.getCalleds();
                this.setState({ loading: false });
            } else {
                this.openCreateTableCustomDialog();
            }
        }
        //search=cmtech|Em Andamento|&field=org|status|&isfinished=0&isarchived=0&iscanceled=0

    }

    //Fim carregar campos dos filtros ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    async getOrganizations() {
        const { userSession } = this.props
        if(userSession.user && userSession.user.userorganizations && userSession.user.userorganizations.length > 0) {
            //this.setState({ OrganizationList: userSession.user.userorganizations })
			let fommatedList = userSession.user.userorganizations.map(item => {
				return {
                    id: item.id,
                    name: item.name,
                    organizationsettings: item.organizationsettings ? {
                        ...item.organizationsettings,
                        organization: null,
                        originrequest: null,
                        status: null,
                        type: null
                    } : {}
                }
			})

			this.userOrganizations = fommatedList;
        } else {
            var result = await Service.getOrganizations(0);
            if (result.success) {
                //this.setState({ OrganizationList: result.data });
				let fommatedList = result.data.map(item => {
					return {
						id: item.id,
						name: item.name
					}
				})
				this.userOrganizations = fommatedList;


            } else {
                // console.log("erro get organizations")
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        result.response && result.response.data && result.response.data.errors
                            ? result.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(result);

            }
        }

          
    }

    async addFilter(filter, value, type = 1) {
        const intl = this.props.intl;

        if (value.trim() == '' && filter == 0) {
            this.setState({
                openNotification: true, notificationVariant: "error",
                notificationMessage: intl.formatMessage({id:"caled.list.notification.select.one.filter.option"})
            });
        } else {
            PapiroConsole.log("=== addFilter -> 1 ===")
            let newFilter = localStorage.getItem('newFilter');
            let newSearch = localStorage.getItem('newSearch');
            let newOrderFilter = localStorage.getItem('newOrderFilter');
            let newOrderSearch = localStorage.getItem('newOrderSearch');

            if (value != '' && filter != 0) {
                if (filter === "open") {
                    if (type == 1) {
                        let date = value.split("/");
                        if (date.length === 3) {
                            date = `${date[2]}-${date[1]}-${date[0]}`
                        }
                        newFilter += filter + "|";
                        newSearch += date + "|";
                    } else {
                        newOrderFilter += filter + "|";
                        newOrderSearch += value + "|";
                    }

                    let nameField;
                    for (let i = 0; i < this.state.filters.length; i++) {

                        if (this.state.filters[i].id === filter) {
                            nameField = this.state.filters[i].name;
                        }
                    }

                    if (type == 1) {
                        PapiroConsole.log("content filter atualizado 5")
                        this.setState({
                            contentFilter: `${this.state.contentFilter}${nameField} = ${value}\n`
                        });
                    } else {
                        let filterOrderConditional = value == "1" ? `${intl.formatMessage({id:"order.filter.ascending"})}` : `${intl.formatMessage({id:"order.filter.descending"})}`

                        await this.setState({
                            contentOrder: `${this.state.contentOrder}${nameField} ${intl.formatMessage({id:"order.filter"})}: ${filterOrderConditional}\n`
                        });
                    }

                } else {
                    PapiroConsole.log("=== addFilter -> 1.1.2 ===")
                    if (type == 1) {
                        newFilter += filter + "|";
                        newSearch += value + "|";
                    } else {
                        newOrderFilter += filter + "|";
                        newOrderSearch += value + "|";
                    }

                    let nameField;
                    
                    for (let i = 0; i < this.state.filters.length; i++) {
                        
                        if (this.state.filters[i].id === filter) {
                            nameField = this.state.filters[i].name;
                        }

                       
                    }
                   
                    if(nameField == undefined && filter == "calledcards"){
                        nameField = intl.formatMessage({ id: "called.report.header" })
                        
                    }

                    if (type == 1) {
                        this.setState({
                            contentFilter: `${this.state.contentFilter}${nameField} = ${value}\n`
                        });
                    } else {
                        let filterOrderConditional = value == "1" ? `${intl.formatMessage({id:"order.filter.ascending"})}` : `${intl.formatMessage({id:"order.filter.descending"})}`

                        await this.setState({
                            contentOrder: `${this.state.contentOrder}${nameField} ${intl.formatMessage({id:"order.filter"})}: ${filterOrderConditional}\n`
                        });
                    }
                }

                localStorage.setItem("newFilter", newFilter);
                localStorage.setItem("newSearch", newSearch);
                localStorage.setItem('newOrderFilter', newOrderFilter);
                localStorage.setItem('newOrderSearch', newOrderSearch);

                localStorage.setItem("newFilter2", newFilter);
                localStorage.setItem("newSearch2", newSearch);
                localStorage.setItem('newOrderFilter2', newOrderFilter);
                localStorage.setItem('newOrderSearch2', newOrderSearch);

                const orderSelected = this.state.orderNewFields.filter(f => f.id == newOrderFilter);
                const selec = orderSelected.length > 0 ? orderSelected[0] : { name: intl.formatMessage({ id: "open.date" }), id: "open" };
                this.setState({ searchValue: '', filterSelected: 0, orderFilterSelected: selec, orderTypeFilterSelected: 'desc' });
            }
        }

        PapiroConsole.log("=== this.state.contentFilter ===");
        PapiroConsole.log(this.state.contentOrder);

    }

    addFilterEdit(filter, value, type = 1) {
        const { intl } = this.props;
        if (value.trim() == '' && filter == 0) {
            this.setState({
                openNotification: true, notificationVariant: "error",
                notificationMessage: intl.formatMessage({id:"caled.list.notification.select.one.filter.option"})
            });
        } else {
            let newFilter = ''
            let newSearch = ''
            let newOrderFilter = ''
            let newOrderSearch = ''
            if (value != '' && filter != 0) {
                if (filter === "open") {
                    if (type == 1) {
                        let date = value.split("/");
                        if (date.length === 3) {
                            date = `${date[2]}-${date[1]}-${date[0]}`
                        }

                        newFilter += filter + "|";
                        newSearch += date + "|";
                    } else {
                        newOrderFilter += filter + "|";
                        newOrderSearch += value + "|";
                    }

                    let nameField;
                    for (let i = 0; i < this.state.filters.length; i++) {
                        if (this.state.filters[i].id === filter) {
                            nameField = this.state.filters[i].name;
                        }
                    }

                    if (type == 1) {
                        this.setState({
                            contentFilterEdit: `${this.state.contentFilterEdit}${nameField} = ${value}\n`
                        });
                    } else {
                        let filterOrderConditional = value == "1" ? `${intl.formatMessage({id:"order.filter.ascending"})}` : `${intl.formatMessage({id:"order.filter.descending"})}`

                        this.setState({
                            contentOrderEdit: `${this.state.contentOrderEdit}${nameField} ${intl.formatMessage({id:"order.filter"})}: ${filterOrderConditional}\n`
                        });
                    } 

                } else {
                    if (type == 1) {
                        newFilter += filter + "|";
                        newSearch += value + "|";
                    } else {
                        newOrderFilter += filter + "|";
                        newOrderSearch += value + "|";
                    }

                    let nameField;
                    for (let i = 0; i < this.state.filters.length; i++) {
                        if (this.state.filters[i].id === filter) {
                            nameField = this.state.filters[i].name;
                        }
                    }

                    if (type == 1) {
                        this.setState({
                            contentFilterEdit: `${this.state.contentFilterEdit}${nameField} = ${value}\n`
                        });
                    } else {
                        let filterOrderConditional = value == "1" ? `${intl.formatMessage({id:"order.filter.ascending"})}` : `${intl.formatMessage({id:"order.filter.descending"})}`

                        this.setState({
                            contentOrderEdit: `${this.state.contentOrderEdit}${nameField} ${intl.formatMessage({id:"order.filter"})}: ${filterOrderConditional}\n`
                        });
                    }
                }
                localStorage.setItem("newFilter", newFilter);
                localStorage.setItem("newSearch", newSearch);
                localStorage.setItem('newOrderFilter', newOrderFilter);
                localStorage.setItem('newOrderSearch', newOrderSearch);

                localStorage.setItem("newFilter2", newFilter);
                localStorage.setItem("newSearch2", newSearch);
                localStorage.setItem('newOrderFilter2', newOrderFilter);
                localStorage.setItem('newOrderSearch2', newOrderSearch);
            }
        }
    }

    addValuesInNewFilter = async (newFilter, newSearch, callById) => {
        if(newFilter != null && newFilter.length > 0 && newSearch != null && newSearch.length > 0) {
            
            this.setState({ contentFilter: '' });
            var field = newFilter.split('|');
            var value = newSearch.split('|');

            if(field && field.length > 0 && value && value.length > 0) {

                if (this.state.organizationsFilterList.length == 0) {
                    await this.getFilterOrganizations();
                }
                
                for(let i = 0; i < field.length; i++) {
                    if(field[i].length > 0) {
                        let ignoreSet = true;
                        let nameField = field[i];
                        let valueField = value;

                        if(field[i] == null || value[i] == null || field[i] == "" || value[i] == "" || field[i] == undefined || value[i] == undefined || field[i].trim() == "" || value[i].trim() == "") {
                            continue;
                        }

                        let filterName = this.state.filters.filter(f => f.id === field[i])
                        if(filterName && filterName.length > 0){
                            nameField = filterName[0].id;
                        }
                        switch (nameField) {
                            case "status":
                                nameField = "statusId";
                                if (this.state.filtersCalled.statusId?.length > 0) {
                                    const lastId = this.state.filtersCalled.statusId.length + 1;
                                    valueField = this.state.filtersCalled.statusId;
                                    valueField.push({ id: lastId, name: value[i], isLegacy: true });
                                } else {
                                    valueField = [{ id: 1, name: value[i], isLegacy: true }];
                                }
                                break;
                            case "org":
                                nameField = "organizationId";
                                if(this.state.organizationsFilterList.length > 0) {
                                    const org = this.state.organizationsFilterList.filter(f => f.name.toLowerCase() == value[i]?.toLowerCase());
                                    if(org.length > 0) {
                                        if (this.state.filtersCalled.organizationId?.length > 0) {
                                            valueField = this.state.filtersCalled.organizationId;
                                            valueField.push({ id: org[0].id, name: org[0].name });
                                        }else{
                                            valueField = [{ id: org[0].id, name: org[0].name }];
                                        }
                                    }
                                }
                                break;
                            case "categoryId":
                                if (this.state.filtersCalled.categoryId?.length > 0) {
                                    const lastId = this.state.filtersCalled.categoryId.length + 1;
                                    valueField = this.state.filtersCalled.categoryId;
                                    valueField.push({ id: lastId, name: value[i] });
                                } else {
                                    valueField = [{ id: 1, name: value[i] }];
                                }
                                break
                            case "type":
                                nameField = "typeId";
                                if (this.state.filtersCalled.typeId?.length > 0) {
                                    const lastId = this.state.filtersCalled.typeId.length + 1;
                                    valueField = this.state.filtersCalled.typeId;
                                    valueField.push({ id: lastId, name: value[i], isLegacy: true });
                                } else {
                                    valueField = [{ id: 1, name: value[i], isLegacy: true }];
                                }
                                break;
                        
                            case "assigneduser":
                                nameField = "assigneduserId";
                                if (this.state.filtersCalled.assigneduserId?.length > 0) {
                                    const lastId = this.state.filtersCalled.assigneduserId.length + 1;
                                    valueField = this.state.filtersCalled.assigneduserId;
                                    valueField.push({ id: lastId, name: value[i], isLegacy: true });
                                } else {
                                    valueField = [{ id: 1, name: value[i], isLegacy: true }];
                                }
                                break;
                        
                            case "loc":
                                nameField = "locationId";
                                if (this.state.filtersCalled.locationId?.length > 0) {
                                    const lastId = this.state.filtersCalled.locationId.length + 1;
                                    valueField = this.state.filtersCalled.locationId;
                                    valueField.push({ id: lastId, name: value[i], isLegacy: true });
                                } else {
                                    valueField = [{ id: 1, name: value[i], isLegacy: true }];
                                }
                                break;
                        
                            case "origin":
                                nameField = "originId";
                                if (this.state.filtersCalled.originId?.length > 0) {
                                    const lastId = this.state.filtersCalled.originId.length + 1;
                                    valueField = this.state.filtersCalled.originId;
                                    valueField.push({ id: lastId, name: value[i], isLegacy: true });
                                } else {
                                    valueField = [{ id: 1, name: value[i], isLegacy: true }];
                                }
                                break;
                        
                            case "dept":
                                nameField = "deptId";
                                if (this.state.filtersCalled.deptId?.length > 0) {
                                    const lastId = this.state.filtersCalled.deptId.length + 1;
                                    valueField = this.state.filtersCalled.deptId;
                                    valueField.push({ id: lastId, name: value[i], isLegacy: true });
                                } else {
                                    valueField = [{ id: 1, name: value[i], isLegacy: true }];
                                }
                                break;
                        
                            case "techinicalteam":
                                nameField = "techinicalteamId";
                                if (this.state.filtersCalled.techinicalteamId?.length > 0) {
                                    const lastId = this.state.filtersCalled.techinicalteamId.length + 1;
                                    valueField = this.state.filtersCalled.techinicalteamId;
                                    valueField.push({ id: lastId, name: value[i], isLegacy: true });
                                } else {
                                    valueField = [{ id: 1, name: value[i], isLegacy: true }];
                                }
                                break;
                        
                            case "mailboxaddress":
                                nameField = "mailboxaddress";
                                if (this.state.filtersCalled.mailboxaddress?.length > 0) {
                                    const lastId = this.state.filtersCalled.mailboxaddress.length + 1;
                                    valueField = this.state.filtersCalled.mailboxaddress;
                                    valueField.push({ id: lastId, name: value[i], isLegacy: true });
                                } else {
                                    valueField = [{ id: 1, name: value[i], isLegacy: true }];
                                }
                                break;
                        
                            case "webchat":
                                nameField = "webchat";
                                if (this.state.filtersCalled.webchat?.length > 0) {
                                    const lastId = this.state.filtersCalled.webchat.length + 1;
                                    valueField = this.state.filtersCalled.webchat;
                                    valueField.push({ id: lastId, name: value[i] });
                                } else {
                                    valueField = [{ id: 1, name: value[i] }];
                                }
                                break;
                        
                            case "chatbot":
                                nameField = "chatbot";
                                if (this.state.filtersCalled.chatbot?.length > 0) {
                                    const lastId = this.state.filtersCalled.chatbot.length + 1;
                                    valueField = this.state.filtersCalled.chatbot;
                                    valueField.push({ id: lastId, name: value[i] });
                                } else {
                                    valueField = [{ id: 1, name: value[i] }];
                                }
                                break;
                            case "calledservicesettings":
                                nameField = "externalFormsId";
                                if (this.state.filtersCalled.externalFormsId?.length > 0) {
                                    const lastId = this.state.filtersCalled.externalFormsId.length + 1;
                                    valueField = this.state.filtersCalled.externalFormsId;
                                    valueField.push({ id: lastId, name: value[i] });
                                } else {
                                    valueField = [{ id: 1, name: value[i] }];
                                }
                                break;
                            case "tag":
                                nameField = "tagIds";
                                {
                                    const pairedId = field[i + 1] === 'tagid' ? (parseInt(value[i + 1]) || null) : null;
                                    const tagEntry = pairedId ? { id: pairedId, name: value[i] } : { id: value[i], name: value[i], isLegacy: true };
                                    if (this.state.filtersCalled.tagIds?.length > 0) {
                                        valueField = this.state.filtersCalled.tagIds;
                                        valueField.push(tagEntry);
                                    } else {
                                        valueField = [tagEntry];
                                    }
                                }
                                break;
                            case "tagid":
                                if (field[i - 1] === 'tag') {
                                    // Already handled by the paired "tag" case above
                                    ignoreSet = false;
                                } else {
                                    // Old cache without paired name — fall back to showing id
                                    nameField = "tagIds";
                                    if (this.state.filtersCalled.tagIds?.length > 0) {
                                        valueField = this.state.filtersCalled.tagIds;
                                        valueField.push({ id: parseInt(value[i]) || value[i], name: value[i] });
                                    } else {
                                        valueField = [{ id: parseInt(value[i]) || value[i], name: value[i] }];
                                    }
                                }
                                break;
                            case "title":
                                nameField = "calledTitle";
                                valueField = value[i];
                                break;
                        
                            case "requestuser":
                                nameField = "requestuserId";
                                valueField = value[i];
                                break;
                        
                            case "requestusermail":
                                nameField = "requestUserEmail";
                                valueField = value[i];
                                break;
                        
                            case "requestuserdocument":
                                nameField = "requestuserdocument";
                                valueField = value[i];
                                break;
                        
                            case "registerednumber":
                                nameField = "registerednumber";
                                valueField = value[i];
                                break;
                        
                            case "expiredcall":
                                nameField = "expiredcall";
                                valueField = value[i];
                                break;
                        
                            case "id":
                                nameField = "calledId";
                                if (this.state.filtersCalled.calledId?.length > 0) {
                                    const newT = this.state.filtersCalled.calledId;
                                    newT.push(value[i]);
                                    valueField = newT;
                                } else {
                                    valueField = [value[i]];
                                }
                                break;
                        
                            case "open":
                                nameField = "openDate";
                                valueField = value[i];
                                break;
                        
                            default:
                                ignoreSet = false;
                                break;
                        }   

                        //Remover valores em branco
                        
                        if(ignoreSet){
                            if (Array.isArray(valueField) && valueField.every(item => item.hasOwnProperty('name'))) {
                                const seenNames = new Set();
                                valueField = valueField.filter((item) => {
                                    if (item.name != null && item.name.trim() !== '' && item.name !== undefined) {
                                        if (seenNames.has(item.name)) {
                                            return false; // Remove itens com nomes repetidos
                                        }
                                        seenNames.add(item.name);
                                        return true;
                                    }
                                    return false;
                                });
                            }
                            this.setState(prevState => ({
                                filtersCalled: {
                                    ...prevState.filtersCalled,
                                    [nameField]: valueField
                                }
                            }));
                        }
                    }
                }

                if(this.state.filtersCalled.organizationId && this.state.filtersCalled.organizationId.length > 0) {
                    this.getOrganizationFields(this.state.filtersCalled.organizationId);
                }

                if(this.state.filtersCalled.categoryId && this.state.filtersCalled.categoryId.length > 0) {
                    if(this.state.categoriesFilterList.length == 0) {
                        await this.getFilterCategoriesByOrganization();
                    }
                    
                    const oldCategory = this.state.filtersCalled.categoryId;

                    this.setState({
                        filtersCalled: {
                            ...this.state.filtersCalled,
                            categoryId: undefined
                        }
                    });

                    let newestCategory = [];
                    oldCategory.forEach(element => {
                        const newCategory = this.state.categoriesFilterList.filter(f => f.id == element.name);
                        if(newCategory && newCategory.length > 0) {
                            newestCategory.push(newCategory[0]);
                        }
                    });

                    //Remover duplicadas
                    const seenNames = new Set();
                    newestCategory = newestCategory.filter((item) => {
                        if (item.name != null && item.name.trim() !== '' && item.name !== undefined) {
                            if (seenNames.has(item.name)) {
                                return false; // Remove itens com nomes repetidos
                            }
                            seenNames.add(item.name);
                            return true;
                        }
                        return false;
                    });

                    if(newestCategory && newestCategory.length > 0) {
                        this.setState({
                            filtersCalled: {
                                ...this.state.filtersCalled,
                                categoryId: newestCategory
                            }
                        });
                    }

                }

                setTimeout(() => {
                    if(this.state.openDrawerFilterMenu == false){
                        this.toggleDrawer();
                    }
                }, 500);
            }
        }

    }

    addFilterOnComponentDidMount = async (intl) => {
        
        let newFilter = localStorage.getItem('newFilter');
        let newSearch = localStorage.getItem('newSearch');
        let newOrderFilter = localStorage.getItem('newOrderFilter');
        let newOrderSearch = localStorage.getItem('newOrderSearch');

        if (newOrderFilter != null && newOrderFilter.length > 0 && newOrderSearch != null && newOrderSearch.length > 0) {
            this.setState({ contentOrder: '' });

            let field = newOrderFilter.split('|')
            let value = newOrderSearch.split('|')

            if(field && field.length > 0 && value && value.length > 0) {
                for(let i = 0; i < field.length; i++) {
                    if(field[i].length > 0) {
                        let nameField = field[i]
                        let filterName = this.state.filters.filter(f => f.id === field[i]);
                        
                        if(filterName && filterName.length > 0)
                            nameField = filterName[0].name

                        const orderSelected = this.state.orderNewFields.filter(f => f.id == field[i]);
                        const selec = orderSelected.length > 0 ? orderSelected[0] : { name: intl.formatMessage({ id: "open.date" }), id: "open" };

                        this.setState({
                            contentOrder: `${this.state.contentOrder}${nameField} ${intl.formatMessage({id:"order.filter"})}: ${value[i] == 1 ? intl.formatMessage({id:"order.filter.ascending"}) : intl.formatMessage({id:"order.filter.descending"})}\n`,
                            orderFilterSelected: selec,
                            orderTypeFilterSelected: value[i] == 1 ? "cresc" : "desc"
                        });
                    }
                }
            }
        }

        if(newFilter != null && newFilter.length > 0 && newSearch != null && newSearch.length > 0) {
            
            this.setState({ contentFilter: '' });
            var field = newFilter.split('|')
            var value = newSearch.split('|')
            if(field && field.length > 0 && value && value.length > 0) {
                for(let i = 0; i < field.length; i++) {
                    if(field[i].length > 0) {
                        // Skip "tagid" — its display is covered by the paired "tag" field entry
                        if (field[i] === 'tagid') continue;

                        let nameField = field[i]
                        let filterName = this.state.filters.filter(f => f.id === field[i])
                        if(filterName && filterName.length > 0)
                            nameField = filterName[0].name

                        if(nameField == "calledcards"){
                            nameField = intl.formatMessage({ id: "called.report.header" })
                        }

                        var contentFilterTest = '' + nameField + " = " + value[i] + "\n"
                        if(!(this.state.contentFilter.includes(contentFilterTest)) ){
                            await this.setState({
                                contentFilter: this.state.contentFilter + nameField + " = " + value[i] + "\n"
                            });
                        }

                    }
                }
            }
        }

        this.addValuesInNewFilter(newFilter, newSearch);
        let calledListPersistFilter = localStorage.getItem('calledListPersistFilter')
        if (calledListPersistFilter && calledListPersistFilter == 'true') {
            localStorage.setItem('calledListPersistFilter', '');
        } else if ((newOrderFilter != null && newOrderSearch != null && newOrderFilter.length == 0 && newOrderSearch.length == 0) && (newFilter != null && newSearch != null && newFilter.length == 0 && newSearch.length == 0)) {
            await this.getDefaultFilter()
        }
    }

    listTableCustomFilters = async (modal = false) => {
        const intl = this.props.intl;

        this.setState({ listTableCustomDialogLoading: true })
        const { userSession } = this.props
        let userId = userSession && userSession.user && userSession.user.id

        let result = await TableCustomFilterService.getAllByUserIdAndTableName(userId, "calleds")
        if(result && result.success) {
            if(result.data != null) {
                let formattedList = result.data.map(item => {
                    return {
                        ...item,
                        isfavorite: item.tablecustomfilterfavorite != null ? true : false,
                        filterCreatorName: item.user? item.user.name : '' ,
                        isDefault: item.tablecustomfilterdefault != null ? true : false,
                        exhibitionName: item.exhibitionname != null ? item.exhibitionname : '',
                        displayFilterInCalledList : item.tablecustomfilterappearincalledlist ? this.props.intl.formatMessage({id:"yes"}) : this.props.intl.formatMessage({id:"no"}),
                        deleteId: { id: item.id, user: item.userid == userId ? true : false },
                        editId: { id: item.id, user: item.userid == userId ? true : false },
                        isPrivateText: item.isprivate ? this.props.intl.formatMessage({id:"yes"}) : this.props.intl.formatMessage({id:"no"}),
                        data: item
                    }
                })
                this.setState({
                    listTableCustomDialogLoading: false,
                    listTableCustomDialogList: formattedList,
                    editTableCustomFilterStep: 1,
                    customFilters: intl.formatMessage({id:"custom.filters"}),
                    contentFilterEdit: '',
                    contentOrderEdit: ''
                })
            }
        } else {
            const intl = this.props.intl
            this.setState({
              listTableCustomDialogLoading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
            })
            Api.kickoff(result)
        }
    }
    ShowFilter() {
        const openFilterMenu = Boolean(this.state.filterMenuAnchorEl);
        PapiroConsole.log('this.state.dateOptions')
        PapiroConsole.log(this.state.dateOptions)

        const intl = this.props.intl
            return (
                <Grid container spacing={6}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Card className="background-title-search">
                            <CardContent>
                            
                                {(this.state.contentFilter || this.state.contentOrder) &&
                                    <Grid container spacing={6}>
                                        <Grid item xs={12} sm={12}>
                                            
                                                    <Grid container spacing={1} alignItems="flex-end">
                                                        <Grid item xs={8} md={6}>
                                                            <Typography component={'span'} variant="h5">
                                                                {intl.formatMessage({id:"filters"})}:
                                                        </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <strong>
                                                                {this.state.contentFilter && this.state.contentFilter.length > 0 && this.state.contentFilter.split("\n").map((i, key) => {
                                                                    if (i.trim() != "") {
                                                                        return <Chip
                                                                            key={key}
                                                                            label={i}
                                                                            onDelete={() => this.handleDelete(key)}
                                                                            color="primary"
                                                                            variant="outlined"
                                                                        />
                                                                    }
                                                                })}
                                                                {this.state.contentOrder && this.state.contentOrder.length > 0 && this.state.contentOrder.split("\n").map((i, key) => {
                                                                    if (i.trim() != "") {
                                                                        return <Chip
                                                                            key={key}
                                                                            label={i}
                                                                            onDelete={() => this.handleOrderDelete(key)}
                                                                            color="primary"
                                                                            variant="outlined"
                                                                        />
                                                                    }
                                                                })}
                                                            </strong>
                                                        </Grid>
                                                    </Grid>
                                            
                                        
                                        </Grid>
                                    </Grid>
                                    }
                                
                            
                                <Grid container spacing={1} justify="space-between" alignItems="center">
                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <Typography component={'span'} variant="h5">
                                            {<FormattedMessage id="called.header" />}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={10} lg={10}>
                                        <Grid container spacing={1} direction="row" alignItems="center">
                                            <SearchBar
                                                field={this.state.filterSelected}
                                                filterValue={this.state.searchValue}
                                                filterName={"searchValue"}
                                                filters={this.state.filters}
                                                addFilterEdit={this.addFilter} 
                                                clearFieldsEdit={this.clearFields}
                                                callSearch={this.callSearch}
                                                orderFields={this.state.orderFields}
                                                handleChangeFieldValue={this.handleChangeFieldValue}
                                                selectedStartDate={this.state.dateStart}
                                                selectedEndDate={this.state.dateEnd}
                                                dateOptions={this.state.dateOptions}
                                                dateOptionSelected={this.state.dateOptionSelected}
                                                handleChangeValue={this.handleChangeValue}
                                                {...this.props} />
                                            <Grid item xs={1} sm={1} md={1} lg={1}>
                                                <IconButton
                                                    color='primary'
                                                    aria-label='filters'
                                                    component='span'
                                                    id="filter-menu"
                                                    aria-controls={ openFilterMenu ? 'filter-menu' : undefined }
                                                    aria-haspopup="true"
                                                    aria-expanded={ openFilterMenu ? 'true' : undefined }
                                                    onClick={this.handleClickFilterMenu} >
                                                    <MoreVert />
                                                </IconButton>
                                                <Menu
                                                    id="filter-menu"
                                                    aria-labelledby="filter-menu"
                                                    anchorEl={this.state.filterMenuAnchorEl}
                                                    open={openFilterMenu}
                                                    onClose={this.handleCloseFilterMenu}
                                                    anchorOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'left'
                                                    }}
                                                    transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'left'
                                                    }} >
                                                        <MenuItem onClick={this.openCreateTableCustomDialog} disabled={ (this.state.contentFilter == null || this.state.contentFilter == '') && (this.state.contentOrder == null || this.state.contentOrder == '') }>
                                                            <ListItemIcon style={{ minWidth: 25 }}>
                                                                <SaveIcon style={{ fontColor: "#3f51b4", fill: "#3f51b4" }} />
                                                            </ListItemIcon>
                                                            {intl.formatMessage({id:"save"})}
                                                        </MenuItem>
                                                        <Divider />
                                                        <MenuItem disabled={true}>{intl.formatMessage({id:"custom.filters"})}</MenuItem>
                                                        { this.state.filterFavorite && this.state.filterFavorite.map((item, idx) => {
                                                            return <MenuItem key={idx} onClick={() => this.setFilters(item)}>
                                                                {item.tablecustomfilterfavorite != null && (
                                                                <ListItemIcon style={{ minWidth: 25 }}>
                                                                    <StarRateIcon style={{ fontColor: "#ffb400", fill: "#ffb400" }} />
                                                                </ListItemIcon>
                                                                )}
                                                                {item.name}
                                                            </MenuItem>
                                                        })}
                                                        { (this.state.countFavorite > 0 || this.admGlobal) &&
                                                        (<Divider />)}
                                                        { (this.state.countFavorite > 0 || this.admGlobal) &&
                                                        (<MenuItem onClick={this.openListTableCustomDialog} >
                                                            <ListItemIcon style={{ minWidth: 25 }}>
                                                                <FormatListBulletedIcon style={{ fontColor: "#3f51b4", fill: "#3f51b4" }} />
                                                            </ListItemIcon>
                                                            {intl.formatMessage({id:"called.report.config.organization.field.block.list.all"})}
                                                        </MenuItem>)}
                                                        <Divider />
                                                        <MenuItem onClick={this.handleClickExportToCSV} >
                                                            <ListItemIcon style={{ minWidth: 25 }}>
                                                                <ExitToAppIcon style={{ fontColor: "#3f51b4", fill: "#3f51b4" }} />
                                                            </ListItemIcon>
                                                            {intl.formatMessage({id:"called.list.export"})}
                                                        </MenuItem>
                                                </Menu>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                    </Grid>

                </Grid>
              
            )
       
    }

    getFavoritesAndCountByUserIdAndTableName = async _ => {
        this.setState({ loading: true })

        const { userSession } = this.props
        let userId = userSession && userSession.user && userSession.user.id

        let result = await TableCustomFilterService.getFavoritesAndCountByUserIdAndTableName(userId, "calleds")
        if(result && result.success) {
            if(result.data != null) {
                this.setState({
                    filterFavorite: result.data.favorites,
                    countFavorite: result.data.totalcount,
                })
            }
        } else {
            const intl = this.props.intl
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
            })
            Api.kickoff(result)
        }
    }

    getFiltersByFlagDisplayFilterInCalledList = async _ => {
        this.setState({ loading: true })

        const { userSession } = this.props
        let userId = userSession && userSession.user && userSession.user.id

        let result = await TableCustomFilterService.showfiltersincalledlistbyflag(userId, "calleds")
        PapiroConsole.log(result)
        PapiroConsole.log("result de filtros aqui ")
        if(result && result.success) {
            if(result.data != null) {
                this.setState({
                    filtersByFlag : result.data,
                    

                   /* filtersByFlag: result.data.favorites,
                    countFiltersByFlag: result.data.totalcount,*/
                })
            }
        } else {
            const intl = this.props.intl
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
            })
            Api.kickoff(result)
        }
    }


    getFiltersByFlagDisplayFilterInCalledListNew = async _ => {
        
        this.setState({ loading: true })
        const { userSession } = this.props
        let userId = userSession && userSession.user && userSession.user.id
        let url = `tablecustomfilter/showfiltersincalledlistbyflag?userid=${userId}&isfinished=${this.state.isFinished}&isarchived=${this.state.isArchived}&iscanceled=${this.state.isCanceled}&type=0`;

        await Api.get(url)
          .then(result => {

                PapiroConsole.log(result)
                PapiroConsole.log("result endpoint reformulado")
                if (result.data.success) {
                    if(result.data.data != null){

                        this.setState({
                            filtersByFlag : result.data.data,
                        })

                    }
                    
                }
                else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true, notificationVariant: "error",
                    notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                }
          })
          .catch(err => {
            const intl = this.props.intl;
            this.setState({
              openNotification: true, notificationVariant: "error",
              notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
            });
          });
    
    
        // this.setState({ loading:false })
    }

    

    getFavoritesByUserIdAndTableName = async _ => {
        this.setState({ loading: true })

        const { userSession } = this.props
        let userId = userSession && userSession.user && userSession.user.id

        let result = await TableCustomFilterService.getFavoritesByUserIdAndTableName(userId, "calleds")
        if(result && result.success) {
            if(result.data != null)
                this.setState({ filterFavorite: result.data })
        } else {
            const intl = this.props.intl
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
            })
            Api.kickoff(result)
        }
    }

    getCountByUserIdAndTableName = async _ => {

        const { userSession } = this.props
        let userId = userSession && userSession.user && userSession.user.id

        let result = await TableCustomFilterService.getCountByUserIdAndTableName(userId, "calleds")
        if(result && result.success) {
            if(result.data != null)
                this.setState({ countFavorite: result.data })
        } else {
            const intl = this.props.intl
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
            })
            Api.kickoff(result)
        }

        this.setState({ loading: false })
    }

    deleteTableCustomFilter = async _ => {
        this.setState({ loading: true })
        if(this.state.tableCustomFilterToDeleteId && this.state.tableCustomFilterToDeleteId != 0) {
            var result = await TableCustomFilterService.deleteItem(this.state.tableCustomFilterToDeleteId)
            if(result && result.success) {
                const intl = this.props.intl
                this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'success',
                notificationMessage: intl.formatMessage({ id: "delete.sucess" })
                }, () => {
                    this.closeConfirmDeleteTableCustomFilterDialog()
                    this.closeListTableCustomDialog()
                    this.getFavoritesAndCountByUserIdAndTableName()
                    //this.getFavoritesByUserIdAndTableName()
                    //this.getCountByUserIdAndTableName()
                })
            } else {
                const intl = this.props.intl
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(result)
            }
        }
        this.setState({ loading: false })
    }

    editTableCustomFilter = async _ => {
        this.setState({ loading: true })
        const { editTableCustomDialog } = this.state

        
        if (!this.admGlobal && (this.isAdmOrg || this.isCoordenator) && !editTableCustomDialog.isPrivate && (editTableCustomDialog.tableCustomFilterOrganizationIds == null || (editTableCustomDialog.tableCustomFilterOrganizationIds && editTableCustomDialog.tableCustomFilterOrganizationIds.length == 0))) {
            this.setState({
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: "Para criar um filtro público, o campo 'Organização' é obrigatório"
            })
        }else if(editTableCustomDialog.exhibitionName == null || editTableCustomDialog.exhibitionName == "" ){

            this.setState({
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: "Para criar um filtro é necessário colocar um nome de exibição do filtro "
            })

        }
         else {
            let fields = ''
            let operators = ''
            let values = ''

            let valueAtual = this.state.contentFilterEdit.split("\n")
            valueAtual.map(item => {
                if (item != "") {
                    let itemSplit = item.split(" = ")
                    if(itemSplit && itemSplit[0] && itemSplit[1]) {
                        let idField = itemSplit[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplit[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplit[1] + '|'
                        operators += '2|'
                    }
                    let itemSplitEquals = item.split(" == ")
                    if(itemSplitEquals && itemSplitEquals[0] && itemSplitEquals[1]) {
                        let idField = itemSplitEquals[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplitEquals[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplitEquals[1] + '|'
                        operators += '1|'
                    }
                    let itemSplitStartsWith = item.split(" s= ")
                    if(itemSplitStartsWith && itemSplitStartsWith[0] && itemSplitStartsWith[1]) {
                        let idField = itemSplitStartsWith[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplitStartsWith[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplitStartsWith[1] + '|'
                        operators += '3|'
                    }
                    let itemSplitEndsWith = item.split(" f= ")
                    if(itemSplitEndsWith && itemSplitEndsWith[0] && itemSplitEndsWith[1]) {
                        let idField = itemSplitEndsWith[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplitEndsWith[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplitEndsWith[1] + '|'
                        operators += '4|'
                    }
                    let itemSplitIsEmpty = item.split(" e= ")
                    if(itemSplitIsEmpty && itemSplitIsEmpty[0] && itemSplitIsEmpty[1]) {
                        let idField = itemSplitIsEmpty[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplitIsEmpty[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplitIsEmpty[1] + '|'
                        operators += '5|'
                    }
                    let itemSplitIsNotEmpty = item.split(" !e= ")
                    if(itemSplitIsNotEmpty && itemSplitIsNotEmpty[0] && itemSplitIsNotEmpty[1]) {
                        let idField = itemSplitIsNotEmpty[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplitIsNotEmpty[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplitIsNotEmpty[1] + '|'
                        operators += '6|'
                    }
                    let itemSplitBiggerThen = item.split(" > ")
                    if(itemSplitBiggerThen && itemSplitBiggerThen[0] && itemSplitBiggerThen[1]) {
                        let idField = itemSplitBiggerThen[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplitBiggerThen[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplitBiggerThen[1] + '|'
                        operators += '7|'
                    }
                    let itemSplitLessThan = item.split(" < ")
                    if(itemSplitLessThan && itemSplitLessThan[0] && itemSplitLessThan[1]) {
                        let idField = itemSplitLessThan[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplitLessThan[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplitLessThan[1] + '|'
                        operators += '8|'
                    }
                    let itemSplitBiggerOrEqual = item.split(" >= ")
                    if(itemSplitBiggerOrEqual && itemSplitBiggerOrEqual[0] && itemSplitBiggerOrEqual[1]) {
                        let idField = itemSplitBiggerOrEqual[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplitBiggerOrEqual[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplitBiggerOrEqual[1] + '|'
                        operators += '9|'
                    }
                    let itemSplitLessOrEqual = item.split(" <= ")
                    if(itemSplitLessOrEqual && itemSplitLessOrEqual[0] && itemSplitLessOrEqual[1]) {
                        let idField = itemSplitLessOrEqual[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplitLessOrEqual[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplitLessOrEqual[1] + '|'
                        operators += '10|'
                    }
                }
            })

            let { intl } = this.props
            let orderValues = this.state.contentOrderEdit.split("\n")
            orderValues.map(item => {
                if (item != "") {
                    let itemSplit = item.split(` ${intl.formatMessage({id:"order.filter"})}: `)
                    if(itemSplit && itemSplit[0] && itemSplit[1]) {
                        let idField = itemSplit[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplit[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id

                        let convertValue = itemSplit[1] == `${intl.formatMessage({id:"order.filter.ascending"})}` ? 1 : 2
                        fields += idField + '|'
                        values += convertValue + '|'
                        operators += '11|'
                    }
                }
            })

            let formData = new FormData();
            formData.append("id", editTableCustomDialog.id)
            formData.append("userid", editTableCustomDialog.userId)
            formData.append("name", editTableCustomDialog.name)
            formData.append("table", "calleds")
            formData.append("isprivate", editTableCustomDialog.isPrivate)
            formData.append("isfavorite", editTableCustomDialog.isFavorite)
            formData.append("isDefault", editTableCustomDialog.isDefault)

            formData.append("isfinished", this.state.isFinished)

            formData.append("isarchived", this.state.isArchived)

            formData.append("iscanceled", this.state.isCanceled)

            formData.append("ExhibitionName", editTableCustomDialog.exhibitionName)
            formData.append("DisplayFilterInCalledlist", editTableCustomDialog.displayFilterInCalledList)

            formData.append("DisplayFilterInCreatorCalledList", editTableCustomDialog.displayFilterInCreatorCalledList)

            

           
            
            formData.append("fields", fields)
            formData.append("operators", operators)
            formData.append("values", values)
            formData.append("updatedat", editTableCustomDialog.updatedAt)
            formData.append("updateduser", editTableCustomDialog.updatedUser)

            let tableCustomFilterOrganizationIds = ""
            editTableCustomDialog.tableCustomFilterOrganizationIds.forEach(item => {
                tableCustomFilterOrganizationIds += `${item.id},`
            })

            formData.append("tableCustomFilterOrganizationIds", tableCustomFilterOrganizationIds)

            var result = await TableCustomFilterService.editItem(formData)
            if(result && result.success) {
                const intl = this.props.intl
                this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'success',
                notificationMessage: intl.formatMessage({ id: "edit.success" }),
                editTableCustomDialog: this.editTableCustomDialogInitialState
                }, () => {
                    this.closeListTableCustomDialog()
                    this.getFavoritesAndCountByUserIdAndTableName()
                    this.getFiltersByFlagDisplayFilterInCalledListNew()
                    //this.getFavoritesByUserIdAndTableName()
                    //this.getCountByUserIdAndTableName()
                })
            } else {
                const intl = this.props.intl
                this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: result && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(result)
            }
        }
        this.setState({ loading: false })
    }

    cpfMask = value => {
        return value
            .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
            .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d{1,2})/, '$1-$2')
            .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
    }

    saveTableCustomFilter = async _ => {
        this.setState({ loading: true })
        
        const { userSession } = this.props
        const { createTableCustomDialog } = this.state
        if (!this.admGlobal && (this.isAdmOrg || this.isCoordenator) && !createTableCustomDialog.isPrivate && (createTableCustomDialog.tableCustomFilterOrganizationIds == null || (createTableCustomDialog.tableCustomFilterOrganizationIds && createTableCustomDialog.tableCustomFilterOrganizationIds.length == 0))) {
            this.setState({
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: "Para criar um filtro público, o campo 'Organização' é obrigatório"
            })
        } 
        else if(createTableCustomDialog.exhibitionName == null || createTableCustomDialog.exhibitionName == "" ){

            this.setState({
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: "O campo Nome de exibição do filtro é obrigatório "
            })

        }else {
            let userId = userSession && userSession.user && userSession.user.id

            let fields = ''
            let operators = ''
            let values = ''

            let valueAtual = this.state.contentFilter.split("\n")
            valueAtual.map(item => {
                if (item != "") {
                    let itemSplit = item.split(" = ")
                    if(itemSplit && itemSplit[0] && itemSplit[1]) {
                        let idField = itemSplit[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplit[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplit[1] + '|'
                        operators += '2|'
                    }
                    let itemSplitEquals = item.split(" == ")
                    if(itemSplitEquals && itemSplitEquals[0] && itemSplitEquals[1]) {
                        let idField = itemSplitEquals[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplitEquals[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplitEquals[1] + '|'
                        operators += '1|'
                    }
                    let itemSplitStartsWith = item.split(" s= ")
                    if(itemSplitStartsWith && itemSplitStartsWith[0] && itemSplitStartsWith[1]) {
                        let idField = itemSplitStartsWith[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplitStartsWith[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplitStartsWith[1] + '|'
                        operators += '3|'
                    }
                    let itemSplitEndsWith = item.split(" f= ")
                    if(itemSplitEndsWith && itemSplitEndsWith[0] && itemSplitEndsWith[1]) {
                        let idField = itemSplitEndsWith[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplitEndsWith[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplitEndsWith[1] + '|'
                        operators += '4|'
                    }
                    let itemSplitIsEmpty = item.split(" e= ")
                    if(itemSplitIsEmpty && itemSplitIsEmpty[0] && itemSplitIsEmpty[1]) {
                        let idField = itemSplitIsEmpty[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplitIsEmpty[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplitIsEmpty[1] + '|'
                        operators += '5|'
                    }
                    let itemSplitIsNotEmpty = item.split(" !e= ")
                    if(itemSplitIsNotEmpty && itemSplitIsNotEmpty[0] && itemSplitIsNotEmpty[1]) {
                        let idField = itemSplitIsNotEmpty[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplitIsNotEmpty[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplitIsNotEmpty[1] + '|'
                        operators += '6|'
                    }
                    let itemSplitBiggerThen = item.split(" > ")
                    if(itemSplitBiggerThen && itemSplitBiggerThen[0] && itemSplitBiggerThen[1]) {
                        let idField = itemSplitBiggerThen[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplitBiggerThen[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplitBiggerThen[1] + '|'
                        operators += '7|'
                    }
                    let itemSplitLessThan = item.split(" < ")
                    if(itemSplitLessThan && itemSplitLessThan[0] && itemSplitLessThan[1]) {
                        let idField = itemSplitLessThan[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplitLessThan[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplitLessThan[1] + '|'
                        operators += '8|'
                    }
                    let itemSplitBiggerOrEqual = item.split(" >= ")
                    if(itemSplitBiggerOrEqual && itemSplitBiggerOrEqual[0] && itemSplitBiggerOrEqual[1]) {
                        let idField = itemSplitBiggerOrEqual[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplitBiggerOrEqual[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplitBiggerOrEqual[1] + '|'
                        operators += '9|'
                    }
                    let itemSplitLessOrEqual = item.split(" <= ")
                    if(itemSplitLessOrEqual && itemSplitLessOrEqual[0] && itemSplitLessOrEqual[1]) {
                        let idField = itemSplitLessOrEqual[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplitLessOrEqual[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id
                        fields += idField + '|'
                        values += itemSplitLessOrEqual[1] + '|'
                        operators += '10|'
                    }
                }
            })

            let { intl } = this.props
            let valueOrder = this.state.contentOrder.split("\n")
            valueOrder.map(item => {
                if (item != "") {
                    let itemSplit = item.split(` ${intl.formatMessage({id:"order.filter"})}: `)
                    if(itemSplit && itemSplit[0] && itemSplit[1]) {
                        let idField = itemSplit[0]
                        let idFieldFilter = this.state.filters.filter(f => f.name == itemSplit[0])
                        if(idFieldFilter && idFieldFilter.length > 0)
                            idField = idFieldFilter[0].id

                        let convertValue = itemSplit[1] == `${intl.formatMessage({id:"order.filter.ascending"})}` ? 1 : 2
                        fields += idField + '|'
                        values += convertValue + '|'
                        operators += '11|'
                    }
                }
            })

            let formData = new FormData();
            formData.append("userid", userId)
            formData.append("name", createTableCustomDialog.name)
            formData.append("table", "calleds")
            formData.append("isprivate", createTableCustomDialog.isPrivate)
            formData.append("isfavorite", createTableCustomDialog.isFavorite)
            formData.append("isDefault", createTableCustomDialog.isDefault)
            formData.append("ExhibitionName", createTableCustomDialog.exhibitionName)
            formData.append("DisplayFilterInCalledlist", createTableCustomDialog.displayFilterInCalledList)
            formData.append("fields", fields)
            formData.append("operators", operators)
            formData.append("values", values)
            formData.append("createdat", createTableCustomDialog.createdAt)
            formData.append("createduser", createTableCustomDialog.createdUser)

            let tableCustomFilterOrganizationIds = ""
            createTableCustomDialog.tableCustomFilterOrganizationIds.forEach(item => {
                tableCustomFilterOrganizationIds += `${item.id},`
            })

            formData.append("tableCustomFilterOrganizationIds", tableCustomFilterOrganizationIds)

            formData.append("isfinished", this.state.isFinished)

            formData.append("isarchived", this.state.isArchived)

            formData.append("iscanceled", this.state.isCanceled)

            var result = await TableCustomFilterService.addItem(formData)
            PapiroConsole.log(result)
            PapiroConsole.log("result do post aqui")
            if(result && result.success) {
                const intl = this.props.intl
                this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'success',
                notificationMessage: intl.formatMessage({ id: "add.success" }),
                createTableCustomDialog: this.createTableCustomDialogInitialState
                }, () => {
                    this.closeCreateTableCustomDialog()
                    this.getFavoritesAndCountByUserIdAndTableName()
                    this.getFiltersByFlagDisplayFilterInCalledListNew()
                    //this.getFavoritesByUserIdAndTableName()
                    //this.getCountByUserIdAndTableName()
                })
            } else {
                const intl = this.props.intl
                this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: result && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(result)
            }
        }
        this.setState({ loading: false })
    }

    async changeValues(stateName, value, text = '') {
        this.setState({ filterSelected: value });
    }

    changeValuesFilterType = (stateName, value, text = '') => {
        localStorage.setItem('newTypeFilter', `${value}`)
        this.setState({ filterType: value });
    }

    changeValuesEdit = (stateName, value, text = '') => {
        this.setState({ filterSelectedEdit: value });
    }

    changeValuesCreateTableCustomDialog = async (stateName, value, text = '') => {
        await this.setState(prevState => ({
            createTableCustomDialog: {
                ...prevState.createTableCustomDialog,
                [stateName]: value
            }
        }))
    }

    changeValuesEditTableCustomDialog = async (stateName, value, text = '') => {
        await this.setState(prevState => ({
            editTableCustomDialog: {
                ...prevState.editTableCustomDialog,
                [stateName]: value
            }
        }))
    }

    changeValuesCheckEmail = async (stateName, value, text = '') => {
        
        await this.setState({ organizationCheckEmail: value });
    }

    changeValuesPopulateCalledsSize = async (stateName, value, text = '') => {
        await this.setState({ populateCalledsSize: value });
    }

    openCheckEmail = () => {
        this.setState({ openCheckEmail: true });
    }

    closeCheckEmail = () => {
        this.setState({ openCheckEmail: false });
    }

    deleteItem(data, resolve) {
        const intl = this.props.intl;

        //console.log("DEL");
        let abl = this.context.can('Delete', 'Called');
        //console.log(abl);
        if (abl == false) {
            this.setState({ loading: false, openNotification: true, notificationVariant: 'error', notificationMessage: this.props.intl.formatMessage({id:"operation.notAllowed"}) });
            resolve(); return false;
        }
        Api.delete(`/calleds/${data.id}`)

            .then(async result => {
                if (result.data.success) {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'success',
                        notificationMessage: intl.formatMessage({id:"called.list.notification.delete.success"}),
                        resultList: []
                    });

                    await this.getCalleds('', 1);
                }
                else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: 'error',
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({id:"process.error"})
                    });
                    Api.kickoff(result);
                }
                resolve();
            })
            .catch(err => {
                resolve();
                this.setState({
                    loading: false, openNotification: true, notificationVariant: 'error',
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : this.props.intl.formatMessage({id:"process.error"})
                });
                Api.kickoff(err);
            });


    };

    setCountLoading() {


        this.setState({ countLoading: this.state.countLoading + 1, });

        if (this.state.countLoading >= 1) {
            this.setState({
                loading: false,
            });

        }

    }

    async componentDidMount() {
        // Registrar função global para remover chamado da lista
        window.__removeCalledFromList = this.removeCalledFromList;
        console.log("=== componentDidMount - Função registrada no window ===");
        console.log("window.__removeCalledFromList:", typeof window.__removeCalledFromList);

        PapiroConsole.log("entrei no did mount teste ------------------")
        const { userSession } = this.props
        
        localStorage.setItem('notificationMenuRefreshed_'+userSession.user.id,false);


        const intl = this.props.intl;

        await this.addFilter2InFilter1();
        await this.addFilterOnComponentDidMount(intl);
        console.log(localStorage, "localStorage");
        var userId = userSession && userSession.user && userSession.user.id

        let getAccordionDefault = localStorage.getItem(`openaccordionfilter${userId}`) ? localStorage.getItem(`openaccordionfilter${userId}`) : false

       
		PapiroConsole.log(getAccordionDefault)
        PapiroConsole.log("getAccordionDefault")
        this.setState({
            loading: true,
            openAccordionFilter : getAccordionDefault,
        });

        PapiroConsole.log(this.state.loading)
        PapiroConsole.log("loading aqui")

        if(this.props.location && this.props.location.state && this.props.location.state.origin ){

            this.getFiltersByFlagDisplayFilterInCalledListNew()
           


            if(this.props.location.state.origin == 'dashboardcards'){

                PapiroConsole.log(this.state.loading)
                PapiroConsole.log("loading aqui")
                //cards fixos
                if(this.props.location.state.field =="calledcards" && this.props.location.state.search){
                    if(this.props.location.state.search == intl.formatMessage({id:"expired.calleds.total.filter"})){
                        this.callSearch("calledcards", intl.formatMessage({id:"expired.calleds.total.filter"}), 1) 
    
                    }
                    else if (this.props.location.state.search == intl.formatMessage({id:"expired.calleds.today.filter"}) ){
                        this.callSearch("calledcards", intl.formatMessage({id:"expired.calleds.today.filter"}), 1)
    
                    }
                    else if(this.props.location.state.search == intl.formatMessage({id:"general.open.calleds"})){
                        this.callSearch("calledcards", intl.formatMessage({id:"general.open.calleds"}), 1)
                    }
                    else if(this.props.location.state.search == intl.formatMessage({id:"today.pending.calleds"})){
                        this.callSearch("calledcards", intl.formatMessage({id:"today.pending.calleds"}), 1)
                    }
                    else if(this.props.location.state.search == intl.formatMessage({id:"calleds.without.assigned"})){
                        this.callSearch("calledcards", intl.formatMessage({id:"calleds.without.assigned"}), 1)
                    }
                    else if(this.props.location.state.search == intl.formatMessage({id:"today.open.calleds"})){
                        PapiroConsole.log("segundo papiro ")
                        PapiroConsole.log("this.props.location.state.search")
                        this.callSearch("calledcards", intl.formatMessage({id:"today.open.calleds"}), 1)
                    }
                    else{
                        PapiroConsole.log("entrei aqui")
                        this.callSearch(this.props.location.state.field , this.props.location.state.search, 1)
                    }
    
                    

                    
                }

                

            }
            else if(this.props.location.state.origin == 'dashboardcardscreatedbyusers'){
                
                PapiroConsole.log("filtros aqui ")
                PapiroConsole.log(this.props.location.state.filters)
                this.props.location.state.filters.forEach(element => {

                    this.callSearch(element.field, element.value, 1) 
                    
                  });
            }

            if(!this.isClient){
                await this.getCalledsToCard(); 
                
            }

            
            
        }

        else{
                /*const { pathname } = this.props.location;
                let pathnameSplit = pathname.split('/')
                PapiroConsole.log(pathname)
                if (pathnameSplit && pathnameSplit.length > 0) {
                    PapiroConsole.log(pathnameSplit)
                    let routePage = pathnameSplit[pathnameSplit.length - 1]
                    if (routePage != null) {
                        PapiroConsole.log(routePage)
                        localStorage.removeItem('calledListPage')
                        localStorage.setItem('calledListPage', `${routePage}`)
                    }
                }*/

                let sessionPage = localStorage.getItem('calledsPage')
                if(sessionPage == null) {
                    sessionPage = 1
                    localStorage.setItem('calledsPage', '1')
                }
                if(!isNaN(sessionPage) && typeof sessionPage === 'string')
                    sessionPage = parseInt(sessionPage)


                PapiroConsole.log("entrada aqui 1 ")
                
                this.setState({ page: sessionPage })

                const { userSession } = this.props

                //if ((this.admGlobal && (userSession && userSession.user && (userSession.user.email == 'suporte@papiro.ai' || userSession.user.email == 'suporte@mexx.ai' || userSession.user.email == 'eduardo.lima@cmtech.com.br' || userSession.user.email == 'tpporto@gmail.com'))))
                //    this.getCalledCostCount()
                    
                await this.VertexIsAvaliable();
                this.getOrganizations();

                if (this.canStartCallCenter && !this.isClient && !this.state.checkMailAndVideoCallInsert) {
                    var itemCallCenter =
                        <Can I="Open" a="Called">
                            <Button
                                color="secondary"
                                size="large"
                                style={{ marginBottom: "5px" }}
                                onClick={this.videoCallClick}
                                startIcon={<VideoCallIcon />}
                                disabled={this.state.disabledvertex}
                            >
                                {intl.formatMessage({id:"video.call"})}
                            </Button>
                        </Can>;
                        if (this.state.itemsTree && !this.state.itemsTree.includes(itemCallCenter)) {
                        this.state.itemsTree.push(itemCallCenter);
                        }

                }
                if (this.isCheckEmail && !this.isClient && !this.state.checkMailAndVideoCallInsert) {
                    var itemEmail =
                        <Can I="Open" a="Called">
                            <Button
                                color="secondary"
                                size="large"
                                style={{ marginBottom: "5px" }}
                                onClick={this.openCheckEmail}
                                startIcon={<EmailIcon />}
                            >
                                {intl.formatMessage({id:"check.email"})}
                        </Button>
                        </Can>;
                    if (this.state.itemsTree && !this.state.itemsTree.includes(itemEmail)) {
                        this.state.itemsTree.push(itemEmail);
                    }

                }

                if (!this.isClient && !this.state.checkMailAndVideoCallInsert) {
                    var itemMassMove =
                        <Can I="Open" a="Called">
                            <Button
                                color="secondary"
                                size="large"
                                style={{ marginBottom: "5px" }}
                                onClick={this.openMassMoveCalledModal}
                                startIcon={<SwapHorizIcon />}
                            >
                                {intl.formatMessage({id:"mass.move.menu.item"})}
                            </Button>
                        </Can>;
                    if (this.state.itemsTree && !this.state.itemsTree.includes(itemMassMove)) {
                        this.state.itemsTree.push(itemMassMove);
                    }
                }

                this.getFiltersByFlagDisplayFilterInCalledListNew()
                this.getFavoritesAndCountByUserIdAndTableName()
                
                this.setState({ checkMailAndVideoCallInsert: true })

                //if (this.props.match && this.props.match.params && this.props.match.params.lang && this.props.match.url  && this.props.match.url == `${this.props.match.params.lang}/archived-calleds`) {
                
                if (this.props.match && this.props.match.params && this.props.match.params.lang && this.props.match.url && this.props.match.url == `/${this.props.match.params.lang}/archived-calleds`) {
                    if(this.props.userSession && this.props.userSession.user && this.props.userSession.user && this.props.userSession.user.canuserviewarchivedcalleds == true )
                    {
                        PapiroConsole.log("entrei aqui")
                        
                        
                        await this.setState({ loading: false, isArchived: 1,isFinished:0, isCanceled: 0, emptySearchArchived : true, emptySearchFinishCalleds : false, emptySearchCanceled : false,  emptyArray : true, dataFilter: false })
                    // await this.getCalleds("archivedcallleds",  parseInt(sessionPage) );
                    
                        this.setState({ locationState: 'archivedcallleds' })
                    }
                    else{
                        this.props.history.push(`/${this.props.match.params.lang}/calleds`)
                        await this.getCalleds(this.props.location.state, parseInt(sessionPage));
                    }
                    
                }
                else if (this.props.match && this.props.match.params && this.props.match.params.lang && this.props.match.url && this.props.match.url == `/${this.props.match.params.lang}/canceled-calleds`) {
                   
                    
                        PapiroConsole.log("entrei aqui")
                        
                        
                        await this.setState({ loading: false, isCanceled: 1, isArchived: 0,isFinished:0, emptySearchCanceled : true, emptySearchArchived : false, emptySearchFinishCalleds : false, emptyArray : true, dataFilter: false })
                    // await this.getCalleds("archivedcallleds",  parseInt(sessionPage) );
                    
                        this.setState({ locationState: 'canceledcalleds' })
                    
                    
                    
                }
                else if (this.props.match && this.props.match.params && this.props.match.params.lang && this.props.match.url && this.props.match.url == `/${this.props.match.params.lang}/finishedCalleds`) {
                    
                    PapiroConsole.log("entrei aqui")
                    
                    
                    await this.setState({ loading: false, isArchived: 0,isFinished:1, isCanceled: 0, emptySearchFinishCalleds : true, emptySearchArchived : false,emptySearchCanceled : false, emptyArray : true, dataFilter: false })
                // await this.getCalleds("archivedcallleds",  parseInt(sessionPage) );
                
                    this.setState({ locationState: 'finishedCalleds' })
                
                
                
                }
                
                else{
                    await this.getCalleds(this.props.location.state, parseInt(sessionPage));
                }

                if(!this.isClient){
                    await this.getCalledsToCard(); 
                }

            
                

                //console.error('componentDidMount'); 
        }

        const datePickerElement = document.getElementsByClassName('date-picker-inline')[0];
        if (datePickerElement) {
            datePickerElement.style.background = 'white';
        }
        
        await this.getLastCalledsQueueByUserId(userSession.user.id)
    }
    async componentWillReceiveProps(nextProps) {


        PapiroConsole.log("willreceiveprops")
        PapiroConsole.log("nextProps")
        PapiroConsole.log(nextProps)
        var refresh = localStorage.getItem('notificationMenuRefreshed_'+nextProps.userSession.user.id);
        PapiroConsole.log("refresh")
        PapiroConsole.log(refresh)
        if (refresh === true || refresh === "true"  ) {
            PapiroConsole.log(" entrei no refresh")
            localStorage.setItem('notificationMenuRefreshed_'+nextProps.userSession.user.id,false);
            //this.setState({ loading: false  })
            return false;

        }


        else if (nextProps && nextProps.location && nextProps.location.state != undefined)
        {
            
            
            /*const { pathname } = this.props.location;
            let pathnameSplit = pathname.split('/')
            PapiroConsole.log(pathname)
            if (pathnameSplit && pathnameSplit.length > 0) {
                PapiroConsole.log(pathnameSplit)
                let routePage = pathnameSplit[pathnameSplit.length - 1]
                if (routePage != null) {
                    PapiroConsole.log(routePage)
                    localStorage.removeItem('calledListPage')
                    localStorage.setItem('calledListPage', `${routePage}`)
                }
            }*/
    
            this.setState({ countLoading: 0, });
            await this.setState({ filterSelected: 0, searchValue: '', page: 1, contentFilter: '', contentOrder: '' });
            let sessionPage = localStorage.getItem('calledsPage')
            if(sessionPage == null) {
                sessionPage = 1
                localStorage.setItem('calledsPage', '1')
            }
            if(!isNaN(sessionPage) && typeof sessionPage === 'string')
                sessionPage = parseInt(sessionPage)
            this.setState({ page: sessionPage })
            PapiroConsole.log("entrada aqui 2 ")
            if (nextProps.location.state === "calleds") {
                console.log("CHAMOU AQUI? 123");
                await this.addFilterOnComponentDidMount(this.props.intl)
                await this.setState({ loading: true, isFinished: 0,isArchived:0, isCanceled:0 })
                await this.getCalleds('', this.state.locationState === 'calleds' ? parseInt(sessionPage) : 1);
                
    
                await this.getFiltersByFlagDisplayFilterInCalledListNew()
    
                this.setState({ locationState: 'calleds', loading: false})
            }
            else if (nextProps.location.state === "assignedcalleds") {
                this.setState({ loading: true, isFinished: 0,isArchived:0, isCanceled:0 })
                await this.getCalleds(nextProps.location.state, this.state.locationState === 'assignedcalleds' ? parseInt(sessionPage) : 1)
                this.setState({ locationState: 'assignedcalleds'})
    
                
            }
            else if (nextProps.location.state === "finishedCalleds" ) {
                await this.setState({ loading: false, isFinished: 1, isArchived:0, isCanceled:0 })
                
                //await this.getCalleds(nextProps.location.state, this.state.locationState === 'finishedCalleds' ? parseInt(sessionPage) : 1);
                
                
                await this.getFiltersByFlagDisplayFilterInCalledListNew()
    
                this.setState({ loading: false, locationState: 'finishedCalleds', emptySearchFinishCalleds: true, emptySearchArchived : false, emptySearchCanceled : false, emptyArray : true, dataFilter: false, calledsList:[]})
                
            }
            else if (nextProps.location.state === "archivedcallleds") {
                PapiroConsole.log("entrei aqui")
                if(this.props.userSession && this.props.userSession.user && this.props.userSession.user && this.props.userSession.user.canuserviewarchivedcalleds == true ){
                    
                    
                    await this.setState({ loading: false, isArchived: 1,isFinished: 0, isCanceled:0 , emptySearchCanceled : false, emptySearchArchived : true, emptySearchFinishCalleds : false, emptyArray : true, dataFilter: false, calledsList:[]})
                    //await this.getCalleds(nextProps.location.state, this.state.locationState === 'archivedcallleds' ? parseInt(sessionPage) : 1);
                   
                    
    
                    await this.getFiltersByFlagDisplayFilterInCalledListNew()
    
                    this.setState({ locationState: 'archivedcallleds', loading: false })
                }
                else{
                    this.props.history.push(`/${this.props.match.params.lang}/calleds`)
                    await this.getCalleds('', this.state.locationState === 'calleds' ? parseInt(sessionPage) : 1);
                    
    
                    await this.getFiltersByFlagDisplayFilterInCalledListNew()
    
                    this.setState({ locationState: 'calleds', loading: false})
                     
                }
                
            }  
            else if (nextProps.location.state === "canceledcalleds") {
                
                
                    await this.setState({ loading: false, isArchived: 0,isFinished: 0, isCanceled:1 , emptySearchCanceled : true ,emptySearchArchived : false, emptySearchFinishCalleds : false, emptyArray : true, dataFilter: false, calledsList:[]})
                    
                    await this.getFiltersByFlagDisplayFilterInCalledListNew()
    
                    this.setState({ locationState: 'canceledcalleds', loading: false })
                
                
                
            }  
            /*else if (nextProps.location.state == "" ) {
    
                if(nextProps.location.pathname == `/${this.props.match.params.lang}/archived-calleds`){
                    await this.setState({ loading: false, isArchived: 1,isFinished: 0, })
                }
                else if(nextProps.location.pathname == `/${this.props.match.params.lang}/finishedCalleds`){
                    
                    await this.setState({ loading: false, isFinished: 1,isArchived: 0})
                }
                
            }*/
            else if (nextProps.headerMenu.refresh === true) {
                PapiroConsole.log("entrei aqui teste")
                this.props.reload(false);
                await this.getCalleds('', parseInt(sessionPage));
                if(!this.isClient){
                    await this.getCalledsToCard(); 
                  }
                
            }
        }
        
        
    }

    getLastCalledsQueueByUserId = async userId => {
        if (this.props.lastCalledsQueue == null || (this.props.lastCalledsQueue != null && (this.props.lastCalledsQueue.items == null || (this.props.lastCalledsQueue.items != null && Object.keys(this.props.lastCalledsQueue.items).length === 0 && this.props.lastCalledsQueue.items.constructor === Object)))) {
            let response = await getLastCalledsQueueByUserId(userId)
            if (response != null && response.success != null && response.success && response.data != null) {
            if (Array.isArray(response.data)) {
                response.data.forEach(item => {
                if (item.id != null && item.title != null)
                    this.props.equeuelastCalledsQueue({ id: item.id, title: item.title })
                })
            }
            } else {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: false,
                notificationVariant: 'error',
                notificationMessage: response && response.response && response.response.data && response.response.data.errors && response.response.data.errors[0] ? response.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
            })
            Api.kickoff(response)
            }
        }
    }

    getDefaultFilter = async () => {

        const { userSession, intl } = this.props
        let userId = userSession && userSession.user && userSession.user.id
        PapiroConsole.log("entrei nesse endpoint x vezes")
        let result = await TableCustomFilterService.getDefaultByUserIdAndTableName(userId, "calleds")
        if(result && result.success) {
            if(result.data && result.data.length > 0) {
                if(result.data[0].tablecustomfilter && result.data[0].tablecustomfilter.tablecustomfilterfields) {
                    let field = ''
                    let search = ''
                    let ofield = ''
                    let osearch = ''
                    result.data[0].tablecustomfilter.tablecustomfilterfields.map(item => {
                        let operator = ''
                        switch(item.operator) {
                            case 1:
                                operator = ' == '
                                break
                            case 2:
                                operator = ' = '
                                break
                            case 3:
                                operator = ' STARTS WITH '
                                break
                            case 4:
                                operator = ' ENDS WITH '
                                break
                            case 5:
                                operator = ' IS EMPTY '
                                break
                            case 6:
                                operator = ' IS NOT EMPTY '
                                break
                            case 7:
                                operator = ' BIGGER THEN '
                                break
                            case 8:
                                operator = ' LESS THAN '
                                break
                            case 9:
                                operator = ' BIGGER OR EQUAL '
                                break
                            case 10:
                                operator = ' LESS OR EQUAL '
                                break
                            case 11:
                                operator = ` ${intl.formatMessage({id:"order.filter"})}: `
                                break
                        }

                        if (item.operator != 11) {
                            field += `${item.field}|`
                            search += `${item.value}|`
                        } else {
                            ofield += `${item.field}|`
                            osearch += `${item.value}|`
                        }

                        let nameField = item.field
                        let filterName = this.state.filters.filter(f => f.id === item.field)
                        if(filterName && filterName.length > 0)
                            nameField = filterName[0].name

                        if (item.operator != 11) {
                            PapiroConsole.log("content filter atualizado 10")
                            this.setState({
                                contentFilter: `${this.state.contentFilter}${nameField}${operator}${item.value.trim()}\n`
                            });
                        } else {
                            this.setState({
                                contentOrder: `${this.state.contentOrder}${nameField}${operator}${item.value.trim() == 1 ? `${intl.formatMessage({id:"order.filter.ascending"})}` : `${intl.formatMessage({id:"order.filter.descending"})}`}\n`
                            });
                        }
                    })
                    localStorage.setItem('newFilter', field)
                    localStorage.setItem('newSearch', search)
                    localStorage.setItem('newOrderFilter', ofield)
                    localStorage.setItem('newOrderSearch', osearch)

                    localStorage.setItem('newFilter2', field)
                    localStorage.setItem('newSearch2', search)
                    localStorage.setItem('newOrderFilter2', ofield)
                    localStorage.setItem('newOrderSearch2', osearch)
                }
            }
        } else {
            const intl = this.props.intl
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
            })
            Api.kickoff(result)
        }
    }

    calledListDataFormmat = (data) => {
      let selected = []

      if (!this.state.selectedColumnns.includes('calledid') && data.calledid === true)
        selected.push('calledid')
      if (!this.state.selectedColumnns.includes('calledorganization') && data.calledorganization === true)
        selected.push('calledorganization')
      if (!this.state.selectedColumnns.includes('calledtitle') && data.calledtitle === true)
        selected.push('calledtitle')
      if (!this.state.selectedColumnns.includes('calledcategory') && data.calledcategory === true)
        selected.push('calledcategory')
      if (!this.state.selectedColumnns.includes('calledtype') && data.calledtype === true)
        selected.push('calledtype')
      if (!this.state.selectedColumnns.includes('calleddepartament') && data.calleddepartament === true)
        selected.push('calleddepartament')
      if (!this.state.selectedColumnns.includes('calledslaservice') && data.calledslaservice === true)
        selected.push('calledslaservice')
      if (!this.state.selectedColumnns.includes('calledslasolution') && data.calledslasolution === true)
        selected.push('calledslasolution')
      if (!this.state.selectedColumnns.includes('calledstatus') && data.calledstatus === true)
        selected.push('calledstatus')
      if (!this.state.selectedColumnns.includes('calledchangestatus') && data.calledchangestatus === true)
        selected.push('calledchangestatus')
      if (!this.state.selectedColumnns.includes('calledrequester') && data.calledrequester === true)
        selected.push('calledrequester')
      if (!this.state.selectedColumnns.includes('calledassigner') && data.calledassigner === true)
        selected.push('calledassigner')
      if (!this.state.selectedColumnns.includes('calledaddress') && data.calledaddress === true)
        selected.push('calledaddress')
      if (!this.state.selectedColumnns.includes('calledclassification') && data.calledclassification === true)
        selected.push('calledclassification')
      if (!this.state.selectedColumnns.includes('calledopendate') && data.calledopendate === true)
        selected.push('calledopendate')
      if (!this.state.selectedColumnns.includes('calledduedate') && data.calledduedate === true)
        selected.push('calledduedate')
      if (!this.state.selectedColumnns.includes('calledslaserviceexpired') && data.calledslaserviceexpired === true)
        selected.push('calledslaserviceexpired')
      if (!this.state.selectedColumnns.includes('calledmenu') && data.calledmenu === true)
        selected.push('calledmenu')
      if (!this.state.selectedColumnns.includes('calledchangeassign') && data.calledchangeassign === true)
        selected.push('calledchangeassign')
/* 
 POSSIVEL CRIME!!!! POSSIVEL CRIME!!!! POSSIVEL CRIME!!!! POSSIVEL CRIME!!!!

      this.setState(prevState => ({
          selectedColumnns: [
              ...prevState.selectedColumnns,
              ...selected,
          ]
        }))
*/

		return selected;
    }
	arrayUnique(array) {
		var a = array.concat();
		for(var i=0; i<a.length; ++i) {
			for(var j=i+1; j<a.length; ++j) {
				if(a[i] === a[j])
					a.splice(j--, 1);
			}
		}
	
		return a;
	}

    async getCalleds(filter = '', page = 1) {

        const intl = this.props.intl
        const { userSession } = this.props

        // Garante as definições de SLA por prioridade antes de calcular os percentuais
        await ensureSlaPrioritiesLoaded()

        this.emptySearchArchived = false
        this.emptySearchFinishCalleds = false
        this.emptySearchCanceledCalleds = false
        
        let url = `/calleds/paginate?page=${page}`;

        let newFilter = localStorage.getItem('newFilter');
        let newSearch = localStorage.getItem('newSearch');
        let newOrderFilter = localStorage.getItem('newOrderFilter');
        let newOrderSearch = localStorage.getItem('newOrderSearch');

        if(newFilter == null || newFilter == undefined || newFilter?.trim() == '' || newFilter?.trim() == 'null') {
            newFilter = '';
        }

        if(newSearch == null || newSearch == undefined || newSearch?.trim() == '' || newSearch?.trim() == 'null') {
            newSearch = '';
        }

        if(newOrderFilter == null || newOrderFilter == undefined || newOrderFilter?.trim() == '' || newOrderFilter?.trim() == 'null') {
            newOrderFilter = '';
        }

        if(newOrderSearch == null || newOrderSearch == undefined || newOrderSearch?.trim() == '' || newOrderSearch?.trim() == 'null') {
            newOrderSearch = '';
        }

        if (newFilter != '') {
            if (newFilter.indexOf('calledservicesettings') > -1 && newFilter.indexOf('webchat') > -1) {
                const error = intl.formatMessage({id:"filter.combination.error"}) + intl.formatMessage({id:"menu.called.service.settings"}) + " + Webchat"
                this.setState({
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: error
                })
                return
            }
            else if (newFilter.indexOf('calledservicesettings') > -1 && newFilter.indexOf('chatbot') > -1){
                const error = intl.formatMessage({id:"filter.combination.error"}) + intl.formatMessage({id:"menu.called.service.settings"}) + " + Chatbot"
                this.setState({
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: error
                })
                return
            }
            else if (newFilter.indexOf('calledservicesettings') > -1 && newFilter.indexOf('registerednumber') > -1){
                const error = intl.formatMessage({id:"filter.combination.error"}) + intl.formatMessage({id:"menu.called.service.settings"}) + " + " + intl.formatMessage({id:"registered.number"})
                this.setState({
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: error
                })
                return
            }
            else if (newFilter.indexOf('calledservicesettings') > -1 && newFilter.indexOf('customernumber') > -1){
                const error = intl.formatMessage({id:"filter.combination.error"}) + intl.formatMessage({id:"menu.called.service.settings"}) + " + " + intl.formatMessage({id:"customer.number"})
                this.setState({
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: error
                })
                return
            }
            else if (newFilter.indexOf('webchat') > -1 && newFilter.indexOf('registerednumber') > -1){
                const error = intl.formatMessage({id:"filter.combination.error"}) + ": Webchat" + " + " + intl.formatMessage({id:"registered.number"})
                this.setState({
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: error
                })
                return
            }
            else if (newFilter.indexOf('webchat') > -1 && newFilter.indexOf('customernumber') > -1) {
                const error = intl.formatMessage({id:"filter.combination.error"}) + ": Webchat" + intl.formatMessage({id:"and"}) + " " + intl.formatMessage({id:"customer.number"})
                this.setState({
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: error
                })
                return
            }
        }
        if (this.isClient) {
            url = `/calleds/org/paginate/${this.state.organizationId}?page=${page}`;
        }
        url += `&type=0`;

        const { filter: cleanedFilter, search: cleanedSearch } = this.cleanDuplicateFilters(newFilter, newSearch);

        if (cleanedFilter != '' && cleanedSearch != '') {

            url += `&search=${cleanedSearch}&field=${cleanedFilter}`;
            this.setState({ dataFilter: true });
        }
        if (newOrderFilter != '' && newOrderSearch != '') {
            url += `&osearch=${newOrderSearch}&ofield=${newOrderFilter}`
        }
        if (filter != '') {
            url = url + '&filter=' + filter;
        }

        url += `&isfinished=${this.state.isFinished}`;

        url += `&isarchived=${this.state.isArchived}`;

        url += `&iscanceled=${this.state.isCanceled}`;

        var formattedList = null

        this.setState({ selectedColumnns: [] })

        PapiroConsole.log(url)
        PapiroConsole.log("url aqui")

         await Api.get(url)
            .then(async result =>  {
                if (result.data.success) {
                    if (result.data.data.length === 0) {
                        if(page  <= 1){
                            this.emptyArray = true
                            this.setState({ emptySearchArchived: false, emptySearchFinishCalleds:false,emptySearchCanceled : false, emptyArray: true});
                        }
                    }
                    else {
                        //this.emptyArray = false
                        this.setState({ emptySearchArchived: false, emptySearchFinishCalleds:false,emptySearchCanceled : false, emptyArray: false});
                    }

                    this.arrayConteudo = []

                    let count = result.data.count;

                   
                    
					let setCat = false
					let setType = false
					let tableTitles = []
                    PapiroConsole.log(result.data.data)
                    PapiroConsole.log("result.data.data CONSOLE AQUI")
					formattedList=result.data.data;
					let issetDepartamentsInList = false
					let canclientselectpatrimonyincalled = false
					let canclientviewslametricsincalled = false
					let selectedCols = []
                    formattedList = result.data.data.map(item => {
                        let times = "";
                        let cardItem ="";
                        let DepartamentName = ""
                        if(item && item.organizationdepartament && item.organizationdepartament.name) {
                            DepartamentName = item.organizationdepartament.name
                        }
                        let orgCat = item.organizationcategory.parentname ? item.organizationcategory.parentname : item.organizationcategory.name

                        if (item.organization && item.organization.organizationsettings && item.organization.organizationsettings.canclientselecttypeincalled === true) {
                            setType = true
                            
                        }
                        if (item.organization && item.organization.organizationsettings && item.organization.organizationsettings.roleclientcanselectcategory === 1 || (item.organization.organizationsettings.canclientselecttypeincalled === false 
							&& item.organization.organizationsettings.roleclientcanselectcategory === 0)) {
                            setCat = true
                           
                        }


                        let onlyType = setType ? item.type.name : '---'
                        let onlyCategory = setCat ? item.organizationcategory.parentname ? item.organizationcategory.parentname : item.organizationcategory.name : '---'
                        let categoryAndType = `${onlyCategory} / ${onlyType}`

                        if (setType === true && setCat === false)
                            orgCat = this.state.categorySetting ? categoryAndType : onlyType
                        else if (setType === true && setCat === true)
                            orgCat = categoryAndType
                        else
                            orgCat = this.state.typeSetting ? categoryAndType : onlyCategory;

                        if(item && item.techinicalteam && item.techinicalteam.name && item.techinicalteam.name.length > 0) {
                            times = item.techinicalteam.name
                        } else if (item.organizationcategory.techinicalteamorganizationcategories != null) {
                            item.organizationcategory.techinicalteamorganizationcategories.map(item2 => {
                                times = times + item2.techinicalteam.name + ","
                            });
                            times = times.substring(0, times.length - 1);
                        }

                        let CallDueDate = <Tooltip title={<h5>{intl.formatMessage({id:"attended.sla"})}</h5>}><AccessTimeIcon style={{ color: '#43a047', fill: '#43a047' }} /></Tooltip>

						let service = getSlaAtendimento(item, this.props.userSession)
					    let solution = getSlaSolucao(item, this.props.userSession)

                        service = service ? service.toFixed(2) : 0
                        solution = solution ? solution.toFixed(2) : 0

                    

                        

                        // Com SLA por prioridade definido para o chamado, o cálculo do front
                        // (ciente da prioridade) tem precedência sobre o snapshot do backend
                        // (tb_called_cost); sem definição, o snapshot vale como sempre valeu.
                        // No paginate o calledstatus não é carregado e o cálculo do front zera,
                        // então o snapshot é reescalado do tempo padrão para o tempo da prioridade
                        let priorityTimes = resolveSlaPriorityTimes(item)
                        let prioritySnapshot = getSlaSnapshotWithPriority(item)

                        let slaSolutionN = (priorityTimes.solutiontime == null && item.slasolution) ? item.slasolution.toFixed(2)
                            : (solution && solution > 0) ? solution
                            : (prioritySnapshot.slasolution ? prioritySnapshot.slasolution.toFixed(2) : solution)
                        let slaServiceN = (priorityTimes.servicetime == null && item.slaservice) ? item.slaservice.toFixed(2)
                            : (service && service > 0) ? service
                            : (prioritySnapshot.slaservice ? prioritySnapshot.slaservice.toFixed(2) : service)

                        let slaSolution = slaSolutionN + "%"
                        let slaService = slaServiceN + "%"
                        
                        if(item && item.organization && item.organization.organizationsettings && item.organization.organizationsettings.canclientviewslametricsincalled 
							&& item.organization.organizationsettings.canclientviewslametricsincalled === true) {
                            let slaSol = ""
                        } else {
                            if(this.isClient) {
                                slaSolution = "----"
                                slaService = "----"
                            }
                        }


                        if(service && service >= 100)
                        	CallDueDate =<Tooltip title={<h5>{intl.formatMessage({id:"expired"})}</h5>}><AccessTimeIcon style={{ color: '#CC1717', fill: '#CC1717' }} /></ Tooltip>;

						if(item && item.organizationdepartament && item.organizationdepartament.name){
							issetDepartamentsInList = true;
						}

						if(item && item.organization && item.organization.organizationsettings && item.organization.organizationsettings.canclientselectpatrimonyincalled && item.organization.organizationsettings.canclientselectpatrimonyincalled === true)
						  canclientselectpatrimonyincalled = true;

						if(item && item.organization && item.organization.organizationsettings && item.organization.organizationsettings.canclientviewslametricsincalled && item.organization.organizationsettings.canclientviewslametricsincalled === true)
						  canclientviewslametricsincalled = true;

						  const patrimonyList = item.calledorganizationpatrimonies;

						  let patrimonies = '';
						  if (patrimonyList) {
							  patrimonyList.forEach(item => {
								  if (item.organizationpatrimony) {
									  patrimonies = patrimonies + `${item.organizationpatrimony.tipping}(${item.organizationpatrimony.serialnumber}), `;
									 
								  }
							  });
							  patrimonies = patrimonies.slice(0, -2);
						  }
						  if (item && item.calledlistdata != null){
  						     let cols = this.calledListDataFormmat(item.calledlistdata);
 							 selectedCols = this.arrayUnique(selectedCols.concat(cols)); 

						  }

                         /*

						*/

						let newitem={
							...item,

							statusName: item.status.name,
                            patrimonies,
                            OrganizationCategory: item.organizationcategory.parentname ? item.organizationcategory.parentname : item.organizationcategory.name,
                            Organization: item.organization.name,
                            slaAtendimento: slaService,
                            slaSolucao: slaSolution,
                            service: slaServiceN,
                            solution: slaSolutionN,
                            assignedUser: item.assigneduser ? item.assigneduser.name : "",
                            requestingUser: item.requestinguser ? item.requestinguser.name : "",
                            time: times,
                            addressname: item.address.name,
                            opening: moment(item.openingdate).format("DD/MM/YYYY"),
                            openingHour: moment(item.openingdate).format("HH:mm"),
                            dueDt: moment(item.duedate).format("DD/MM/YYYY"),
                            dueHour: moment(item.duedate).format("HH:mm"),
                            solutionDt: item.solutiondate != null ? moment(item.solutiondate).format("DD/MM/YYYY") : null,
                            solutionHour: item.solutiondate != null ? moment(item.solutiondate).format("HH:mm") : null,
                            DateCreatedAt: moment(item.openingdate).format("DD/MM/YYYY HH:mm"),
                            classification: item.calledclassification ? <Rating name="read-only" value={item.calledclassification.noteassigned} readOnly /> : 'N/A',
                            typeName: item.type.name,
                            originRequestName: item.originrequest.name,
                            cardItem: cardItem,
                            orgCat: orgCat,
                            DepartamentName: DepartamentName,
                            CallDueDate: CallDueDate,
							calledlistdata: item.calledlistdata
						}

						let popupData =[];
						if(this.isClient){
							popupData = this.popupColumnsClient.map(({ title, field }) => {
								return { title, value: newitem[field] }
							});
	
						}
						else{
							popupData = this.popupColumns.map(({ title, field }) => {
								return { title, value: newitem[field] }
							});
						}
                        
                        return {
                            ...newitem,
							
							/*
							statusName: "",
                            patrimonies: "",
                            OrganizationCategory: "",
                            Organization: "",
                            slaAtendimento:"",
                            slaSolucao: "",
                            assignedUser: "",
                            requestingUser: "",
                            time: "",
                            addressname: "",
                            opening: "",
                            DateCreatedAt: "",
                            classification:  'N/A',
                            typeName: "",
                            originRequestName: "",
                            cardItem: "",
                            orgCat: "",
                            DepartamentName: "",
                            CallDueDate: "",
							*/
							//address: null,
							//assigneduser: null,
							//calledhistorychecks: null,
							//calledstatus: null,
							//organization: null,
							//organizationcalendarevents: null,
							//organizationcategory: null,
							//originrequest: null,
							//priority: null,
							//requestinguser: null,
							//status: null,
							//type: null,
							actions: this.isClient ? null :  <div style={{display:'flex', flexDirection:'row'}}>
										<IconButton
											size="small"
											onClick={() =>  this.goToCalled(newitem, true)}
											>
											<CallMade />
										</IconButton>
										<IconButton size="small">
											<TablePopup data={popupData} />
										</IconButton>
										<IconButton
											size="small"
											onClick={() =>  this.openConfirmAssignCalledDialog(newitem)}
											>
											<PanToolIcon style={{ color: '#58595B', fill: '#58595B' }} />
										</IconButton>

							</div>,
							onlyId: <LinkA component="button"
							onClick={() => {
								let abl = this.context.can('Answer', 'Called');
								let abl2 = this.context.can('Edit', 'Called');
								if (abl == false && abl2 == false) {
									
									this.showMessage( true, 'error', intl.formatMessage({id:"called.list.message.unallowed.task"}));
									return false;
								}
								if (newitem.assigneduser != null) {
									if (newitem.assigneduser.id != userSession.user.id) {
										if (newitem.organization.organizationsettings.canviewcalledfromothertechnical == false && this.isAdm == false) {
											this.showMessage( true, 'error', intl.formatMessage({id:"caled.list.message.unallowed.user"}));
											return false;
										}
									}
								}
			
								this.goToCalled(newitem, false)
							}
							} variant="body2">
							{newitem.id}
						  </LinkA>


                        }
                    });

					

                    // formattedList=result.data.data;

                    if(result.data.data.length == 0){
                        formattedList = [];
                    }
                    
					TableTitles = tableTitles;
					tableTitles = []; // foi necessário zerar o state tableTitles pois com ele carregado já com algum valor e chamando a funcao abaixo "setColumnTitles"
					// que já carrega ele novamente estava travando o sistema no container(POD KUBE) estourando a memoria do javascript no cliente(navegador)
					// Analisamos a lógica e vimos que não precisava trabalhar essa variável aqui, tendo em vista que sempre os titulos serão setados em "setColumnTitles"

					var pagination = this.setPagination(count, page, 10);
					//console.log("selectedCols");
					//console.log(selectedCols);

				

                    await this.setState({loading: false, displayNotFound: true, typeSetting: setType, count: count,categorySetting: setCat,tableTitles: tableTitles ,calledsList: formattedList
						, pageStart: pagination.pageStart, pageEnd: pagination.pageEnd, totalPages: pagination.totalPages, page: pagination.page
					, selectedColumnns: selectedCols});

                    this.setCountLoading();
                    TableTitles = await this.setColumnTitles();
					

                } else {
                    // console.log("erro this.getcalleds")
                    this.setState({
                        openNotification: true, notificationVariant: 'error',
                        //notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({id:"process.error"})
                    });
                    Api.kickoff(result);
                    this.setCountLoading();

                }
            })
            .catch(err => {
                console.error(err);
                this.setState({
                    openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({id:"process.error"})
                });
                Api.kickoff(err);
                this.setCountLoading();

            });
    };

    setColumnTitles = async () => {
        const { intl, userSession } = this.props
        let listTitles = []

        let issetDepartamentsInList = false
        this.state.calledsList.filter(item => {
            if(item && item.organizationdepartament && item.organizationdepartament.name)
                issetDepartamentsInList = true
        })

        if (this.isAdm) {
            
            if (this.state.selectedColumnns.length > 0) {
                if (this.state.selectedColumnns.includes('calledslaserviceexpired'))
                    listTitles.push({ title: intl.formatMessage({id:"situation"}), field: 'CallDueDate' })
                if (this.state.selectedColumnns.includes('calledid'))
                    listTitles.push({ title: intl.formatMessage({ id: "id" }), field: 'id' })
                if (this.state.selectedColumnns.includes('calledorganization'))
                    listTitles.push({ title: intl.formatMessage({ id: "organization" }), field: 'Organization' })
                if (this.state.selectedColumnns.includes('calledtitle'))
                    listTitles.push({ title: intl.formatMessage({ id: "title" }), field: 'title' })
                if (this.state.selectedColumnns.includes('calledcategory'))
                    listTitles.push({ title: intl.formatMessage({ id: "category" }), field: 'OrganizationCategory' })
                if (this.state.selectedColumnns.includes('calledtype'))
                    listTitles.push({ title: intl.formatMessage({ id: "type" }), field: 'typeName' })
                if (this.state.selectedColumnns.includes('calleddepartament') && issetDepartamentsInList)
                    listTitles.push({ title: intl.formatMessage({ id: "departament" }), field: 'DepartamentName' })
                if (this.state.selectedColumnns.includes('calledslaservice'))
                    listTitles.push({ title: intl.formatMessage({ id: "sla.service" }), field: 'slaAtendimento' })
                if (this.state.selectedColumnns.includes('calledslasolution'))
                    listTitles.push({ title: intl.formatMessage({ id: "sla.solution" }), field: 'slaSolucao' })
                if (this.state.selectedColumnns.includes('calledstatus'))
                    listTitles.push({ title: intl.formatMessage({ id: "menu.statuses" }), field: 'statusName', })
                if (this.state.selectedColumnns.includes('calledrequester'))
                    listTitles.push({ title: intl.formatMessage({ id: "requestuser" }), field: 'requestingUser' })
                if (this.state.selectedColumnns.includes('calledassigner'))
                    listTitles.push({ title: intl.formatMessage({id:"assigned"}), field: 'assignedUser' })
                if (this.state.selectedColumnns.includes('calledaddress'))
                    listTitles.push({ title: intl.formatMessage({ id: "location" }), field: 'addressname' })
                if (this.state.selectedColumnns.includes('calledclassification'))
                    listTitles.push({ title: intl.formatMessage({ id: "classification" }), field: 'classification' })
                if (this.state.selectedColumnns.includes('calledopendate'))
                    listTitles.push({ title: intl.formatMessage({ id: "creation.date" }), field: 'DateCreatedAt' })
                if (this.state.selectedColumnns.includes('calledduedate'))
                    listTitles.push({ title: intl.formatMessage({ id: "estimated.solution.date" }), field: 'DateCreatedAt' })

                //console.log(listTitles)
            } else {
                listTitles.push(
                    { title: intl.formatMessage({id:"situation"}), field: 'CallDueDate' },
                    { title: intl.formatMessage({ id: "id" }), field: 'id' },
                    { title: intl.formatMessage({ id: "organization" }), field: 'Organization' },
                    { title: intl.formatMessage({ id: "title" }), field: 'title' },
                    { title: intl.formatMessage({ id: "category" }), field: 'OrganizationCategory' }
                )

                if(issetDepartamentsInList) {
                    listTitles.push({ title: intl.formatMessage({ id: "departament" }), field: 'DepartamentName' })
                }

                listTitles.push(
                    { title: intl.formatMessage({ id: "sla.service" }), field: 'slaAtendimento' },
                    { title: intl.formatMessage({ id: "sla.solution" }), field: 'slaSolucao' },
                    { title: intl.formatMessage({ id: "menu.statuses" }), field: 'statusName', },
                    { title: intl.formatMessage({ id: "requestuser" }), field: 'requestingUser' },
                    { title: intl.formatMessage({ id: "location" }), field: 'addressname' },
                    { title: intl.formatMessage({id:"classification"}), field: 'classification' },
                    { title: intl.formatMessage({ id: "creation.date" }), field: 'DateCreatedAt' },
                    { title: intl.formatMessage({id:"assigned"}), field: 'assignedUser' }
                )
            }
			listTitles.splice( 0,0 , { title: intl.formatMessage({id:"actions"}), field: 'actions' },);
		} else if (this.isAdm == false && this.isClient) {
            if (this.state.selectedColumnns.length > 0) {
                if (this.state.selectedColumnns.includes('calledslaserviceexpired'))
                    listTitles.push({ title: intl.formatMessage({id:"situation"}), field: 'CallDueDate' })
                if (this.state.selectedColumnns.includes('calledid'))
                    listTitles.push({ title: intl.formatMessage({ id: "id" }), field: 'id' })
                if (this.state.selectedColumnns.includes('calledorganization'))
                    listTitles.push({ title: intl.formatMessage({ id: "organization" }), field: 'Organization' })
                if (this.state.selectedColumnns.includes('calledtitle'))
                    listTitles.push({ title: intl.formatMessage({ id: "title" }), field: 'title' })
                if (this.state.selectedColumnns.includes('calledcategory'))
                    listTitles.push({ title: intl.formatMessage({ id: "category" }), field: 'OrganizationCategory' })
                if (this.state.selectedColumnns.includes('calledtype'))
                    listTitles.push({ title: intl.formatMessage({ id: "type" }), field: 'typeName' })
                if (this.state.selectedColumnns.includes('calleddepartament') && issetDepartamentsInList)
                    listTitles.push({ title: intl.formatMessage({ id: "departament" }), field: 'DepartamentName' })
                if (this.state.selectedColumnns.includes('calledslaservice'))
                    listTitles.push({ title: intl.formatMessage({ id: "sla.service" }), field: 'slaAtendimento' })
                if (this.state.selectedColumnns.includes('calledslasolution'))
                    listTitles.push({ title: intl.formatMessage({ id: "sla.solution" }), field: 'slaSolucao' })
                if (this.state.selectedColumnns.includes('calledstatus'))
                    listTitles.push({ title: intl.formatMessage({ id: "menu.statuses" }), field: 'statusName', })
                if (this.state.selectedColumnns.includes('calledrequester'))
                    listTitles.push({ title: intl.formatMessage({ id: "requestuser" }), field: 'requestingUser' })
                if (this.state.selectedColumnns.includes('calledassigner'))
                    listTitles.push({ title: intl.formatMessage({id:"assigned"}), field: 'assignedUser' })
                if (this.state.selectedColumnns.includes('calledaddress'))
                    listTitles.push({ title: intl.formatMessage({ id: "location" }), field: 'addressname' })
                if (this.state.selectedColumnns.includes('calledclassification'))
                    listTitles.push({ title: intl.formatMessage({id:"classification"}), field: 'classification' })
                if (this.state.selectedColumnns.includes('calledopendate'))
                    listTitles.push({ title: intl.formatMessage({ id: "creation.date" }), field: 'DateCreatedAt' })
                if (this.state.selectedColumnns.includes('calledduedate'))
                    listTitles.push({ title: intl.formatMessage({id:"estimated.solution.date"}), field: 'DateCreatedAt' })
            } else {
                listTitles = [
                    { title: intl.formatMessage({ id: "id" }), field: 'id' },
                ]

                if(userSession && userSession.user && userSession.user.organizationusers && userSession.user.organizationusers.length > 1) {
                    listTitles.push({ title: intl.formatMessage({ id: "organization" }), field: 'Organization' })
                }

                listTitles.push(
                    { title: intl.formatMessage({id:"title"}), field: 'title' },
                    { title: (this.state.categorySetting && this.state.typeSetting) ? intl.formatMessage({ id: "category.and.type" }) : (!this.state.categorySetting && this.state.typeSetting) ? intl.formatMessage({ id: "type" }) : intl.formatMessage({ id: "category" }), field: 'orgCat' },
                )

                let canclientselectpatrimonyincalled = false
                let canclientviewslametricsincalled = false

                let listFilter = this.state.calledsList.filter(item => {
                    if(item && item.organization && item.organization.organizationsettings && item.organization.organizationsettings.canclientselectpatrimonyincalled && item.organization.organizationsettings.canclientselectpatrimonyincalled === true)
                        canclientselectpatrimonyincalled = true
                    if(item && item.organization && item.organization.organizationsettings && item.organization.organizationsettings.canclientviewslametricsincalled && item.organization.organizationsettings.canclientviewslametricsincalled === true)
                        canclientviewslametricsincalled = true
                })

                if(canclientselectpatrimonyincalled) {
                    listTitles.push({ title: intl.formatMessage({id:"menu.organizationpatrimonies"}), field: 'patrimonies' })
                }

                listTitles.push({ title: intl.formatMessage({ id: "menu.statuses" }), field: 'statusName' })

                if(canclientviewslametricsincalled) {
                    listTitles.push(
                        { title: intl.formatMessage({ id: "sla.service" }), field: 'slaAtendimento' },
                        { title: intl.formatMessage({ id: "sla.solution" }), field: 'slaSolucao' }
                    )
                }

                listTitles.push(
                    { title: intl.formatMessage({ id: "requestuser" }), field: 'requestingUser' },
                    { title: intl.formatMessage({id:"assigned"}), field: 'assignedUser' }
                )
            }
        } else {
            if (this.state.selectedColumnns.length > 0) {
                if (this.state.selectedColumnns.includes('calledslaserviceexpired'))
                    listTitles.push({ title: intl.formatMessage({id:"situation"}), field: 'CallDueDate' })
                if (this.state.selectedColumnns.includes('calledid'))
                    listTitles.push({ title: intl.formatMessage({ id: "id" }), field: 'id' })
                if (this.state.selectedColumnns.includes('calledorganization'))
                    listTitles.push({ title: intl.formatMessage({ id: "organization" }), field: 'Organization' })
                if (this.state.selectedColumnns.includes('calledtitle'))
                    listTitles.push({ title: intl.formatMessage({ id: "title" }), field: 'title' })
                if (this.state.selectedColumnns.includes('calledcategory'))
                    listTitles.push({ title: intl.formatMessage({ id: "category" }), field: 'OrganizationCategory' })
                if (this.state.selectedColumnns.includes('calledtype'))
                    listTitles.push({ title: intl.formatMessage({ id: "type" }), field: 'typeName' })
                if (this.state.selectedColumnns.includes('calleddepartament') && issetDepartamentsInList)
                    listTitles.push({ title: intl.formatMessage({ id: "departament" }), field: 'DepartamentName' })
                if (this.state.selectedColumnns.includes('calledslaservice'))
                    listTitles.push({ title: intl.formatMessage({ id: "sla.service" }), field: 'slaAtendimento' })
                if (this.state.selectedColumnns.includes('calledslasolution'))
                    listTitles.push({ title: intl.formatMessage({ id: "sla.solution" }), field: 'slaSolucao' })
                if (this.state.selectedColumnns.includes('calledstatus'))
                    listTitles.push({ title: intl.formatMessage({ id: "menu.statuses" }), field: 'statusName', })
                if (this.state.selectedColumnns.includes('calledrequester'))
                    listTitles.push({ title: intl.formatMessage({ id: "requestuser" }), field: 'requestingUser' })
                if (this.state.selectedColumnns.includes('calledassigner'))
                    listTitles.push({ title: intl.formatMessage({id:"assigned"}), field: 'assignedUser' })
                if (this.state.selectedColumnns.includes('calledaddress'))
                    listTitles.push({ title: intl.formatMessage({ id: "location" }), field: 'addressname' })
                if (this.state.selectedColumnns.includes('calledclassification'))
                    listTitles.push({ title: intl.formatMessage({id:"classification"}), field: 'classification' })
                if (this.state.selectedColumnns.includes('calledopendate'))
                    listTitles.push({ title: intl.formatMessage({ id: "creation.date" }), field: 'DateCreatedAt' })
                if (this.state.selectedColumnns.includes('calledduedate'))
                    listTitles.push({ title: intl.formatMessage({id:"estimated.solution.date"}), field: 'DateCreatedAt' })
            } else {
                listTitles = [
                    //
                    { title: intl.formatMessage({id:"situation"}), field: 'CallDueDate' },
                    //
                    { title: intl.formatMessage({ id: "id" }), field: 'id' },
                    { title: intl.formatMessage({ id: "organization" }), field: 'Organization' },
                    { title: intl.formatMessage({id:"title"}), field: 'title' },
                    { title: intl.formatMessage({ id: "category" }), field: 'OrganizationCategory' },
                    { title: intl.formatMessage({id:"menu.organizationpatrimonies"}), field: 'patrimonies' },
                    { title: intl.formatMessage({ id: "menu.statuses" }), field: 'statusName' },
                    { title: intl.formatMessage({ id: "sla.service" }), field: 'slaAtendimento' },
                    { title: intl.formatMessage({ id: "sla.solution" }), field: 'slaSolucao' },
                    { title: intl.formatMessage({ id: "location" }), field: 'addressname' },
                    { title: intl.formatMessage({ id: "requestuser" }), field: 'requestingUser' },
                    { title: intl.formatMessage({id:"assigned"}), field: 'assignedUser' }
                ]
            }
			listTitles.splice( 0,0 , { title: intl.formatMessage({id:"actions"}), field: 'actions' },);
		}

        this.setState({ tableTitles: listTitles })
		return listTitles;
    }

    populateAllCalleds = async _ => {
        const intl = this.props.intl;

        this.setState({ loading: true });
        PapiroConsole.log("=== populateAllCalleds ===")
        PapiroConsole.log(this.state.populateCalledsSize)
        if(this.state.calledCountNotTimeData > 0 && this.state.populateCalledsSize && this.state.populateCalledsSize > 0) {
            Api.get(`/calleds/papulateCalledTime/statustype/5/hastimedata/false/size/${this.state.populateCalledsSize}`)
            .then(async result => {
                if (result && result.data && result.data.success) {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'success',
                        notificationMessage: 'Métricas de tempo dos chamados salvas com sucesso'
                    });
                    if(result.data.data != null) {
                        this.setState({
                            calledCountNotTimeData: result.data.data.calledtimecount
                        });
                    }
                    this.closePopulateCalledsDialog()
                }
            }).catch((err) => {
                
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        err.response &&
                        err.response.data &&
                        err.response.data.errors &&
                        err.response.data.errors[0]
                        ? err.response.data.errors[0]
                        : intl.formatMessage({ id: "process.error" }),
                    });
                    Api.kickoff(err);
                });
        } else if (this.state.calledCountNotTimeData == 0) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'info',
                notificationMessage: 'Métricas de tempo dos chamados já foram populadas'
            });
            this.closePopulateCalledsDialog()
        } else {
            this.setState({ loading: false })
        }
    }

    getCalledCostCount = async _ => {
        this.setState({ loading: true });

        Api.get(`/calleds/count/statustype/5/hastimedata/false`)
        .then(async result => {
            if (result && result.data && result.data.success) {
                if(result.data.data != null) {
                    this.setState({
                        calledCountNotTimeData: result.data.data.calledtimecount
                    });
                }
            }
        }).catch((err) => {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage:
                    err.response &&
                    err.response.data &&
                    err.response.data.errors &&
                    err.response.data.errors[0]
                    ? err.response.data.errors[0]
                    : intl.formatMessage({ id: "process.error" }),
            });
            Api.kickoff(err);
        });
    }

    assignCalled = async () => {
        let calledToAssign = this.state.calledToAssign
        if(calledToAssign != null) {
            const { userSession } = this.props;
            this.loading(true);

            let data = new FormData()
            data.append("calledid", calledToAssign.id)
            data.append("userid", userSession.user.id)

            await Api.post(`/calleds/canassignuser/team`, data)
                .then(async result => {
                    if (result.data.success) {
                        const intl = this.props.intl;
                        this.setState({
                            loading: false,
                            openNotification: true,
                            notificationVariant: "success",
                            notificationMessage: intl.formatMessage({id:"called.list.notification.called.taken"}),
                        });

                        this.goToCalled(calledToAssign)
                    }
                    this.componentDidMount()
                })
                .catch((err) => {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage:
                            err.response &&
                                err.response.data &&
                                err.response.data.errors &&
                                err.response.data.errors[0]
                                ? err.response.data.errors[0]
                                : intl.formatMessage({ id: "process.error" }),
                    });
                    if (err.response && err.response.data && err.response.data.errors && err.response.data.errors[1] && err.response.data.errors[1] === "Called_Assigned_By_Other_User") {
                        let calledToAssignId = calledToAssign.id
                        let calledList = this.state.calledsList
                        let calledListItemById = calledList.find(item => item.id === calledToAssignId)
                        calledListItemById.canAssign = false
                        let otherCalledListItems = calledList.filter(item => item.id !== calledToAssignId)
                        calledList = [...otherCalledListItems, calledListItemById]
                        calledList = calledList.sort((a, b) => a.id - b.id)

                        this.setState({ calledList: calledList })
                    }
                    Api.kickoff(err);
                });
            this.loading(false);
            this.setState({ confirmAssignCalledDialogOpen: false, calledToAssign: null })
        }
    }

    goToCalled = async (rowData, newTab = false) => {
        
        this.setState({ loading: true })
        let newassigned = rowData.assigneduser;
		this.setState({ loading: true})
        if(rowData.assigneduser){
            
            if(rowData.assigneduser.email == null || (rowData.assigneduser.email && (rowData.assigneduser.email.length ===  0 || rowData.assigneduser.email.length === 'undefined'))) {
               
                newassigned.name = `${rowData.assigneduser.name}`
            } else {
                
                newassigned.name = `${rowData.assigneduser.name} - ${rowData.assigneduser.email}`
            }
        }

        rowData.assigneduser = newassigned

		// COMENTADO POIS FOI RETIRADO DA API OS INCLUDES, O REDUX VEM SEM NENHUM DADO DE INCLUDE, COM AS LINHAS COMENTADAS, A PAGINA DE EDICAO BUSCA TODOS OS DADOS
        await this.props.addCurrentCalled(rowData);
        await this.props.addCalled(rowData);

        await this.props.addAccompanimentsList([]);

        await this.props.addAccompanimentsListInCalled([], rowData.id);
        if (!this.isClient && rowData.status.id == 3) { // validacao de rejeicao
           
            this.props.history.push(`/${this.props.match.params.lang}/called-rejection-edit`);
            //this.loading(false);
        } else {
            
            const _currentListPage = this.props.match.url.split('/').pop();
            localStorage.setItem('calledListPage', _currentListPage);

            if (newTab == false) {

                this.props.history.push(`/${this.props.match.params.lang}/called-accompaniment/${rowData.id}`);
                //this.loading(false);
            } else {

                let urlRedirect = "/" + this.props.match.params.lang + "/called-accompaniment/" + rowData.id;

                 setTimeout(() => {
                    window.open(urlRedirect, "_blank");
                    this.setState({ loading: false })
                }, 1000);
            }
        }
    }

    async getById(id, newTab = false) {
        let url = `/calleds/calledInfoPaginate/${id}`;
        let data = {}


        this.loading(true);

        Api.get(url)
            .then(async result => {
                if (result.data.success) {
                    let item = result.data.data
                    let times = "";
                    let newassigned = item.assigneduser;

                    if(item.assigneduser){
                        newassigned.name = item.assigneduser.name + " - " + item.assigneduser.email;
                    }

                    data = {
                        ...item,
                        typeName: item.type.name,
                        originRequestName: item.originrequest.name,
                        requestingUser: item.requestinguser ? item.requestinguser.name : "",
                        time: times,
                        opening: moment(item.openingdate).format("DD/MM/YYYY"),
                        assigneduser: newassigned
                    }

                    await this.props.addCurrentCalled(data);

                    PapiroConsole.log("entrei nesses dados aqui")
                    await this.props.addAccompanimentsList(data.accompaniments ? data.accompaniments : null);

                    await this.props.addCalled(data);
                    await this.props.addAccompanimentsListInCalled(data.accompaniments ? data.accompaniments : [], data.id);

                    if (!this.isClient && item.status.id == 3) { // validacao de rejeicao
                        this.props.history.push(`/${this.props.match.params.lang}/called-rejection-edit`);
                        this.loading(false);
                    }
                    else {
                        const _currentListPage = this.props.match.url.split('/').pop();
                        localStorage.setItem('calledListPage', _currentListPage);

                        if (newTab == false) {
                            this.props.history.push(`/${this.props.match.params.lang}/called-accompaniment/${data.id}`);
                            this.loading(false);
                        } else {
                            let urlRedirect = "/" + this.props.match.params.lang + "/called-accompaniment/" + data.id;

                            await setTimeout(() => {
                                window.open(urlRedirect, "_blank");
                                this.setState({ loading: false })
                            }, 3000);
                        }
                    }
                }
                else {
                    // console.log("Aqui 3");
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: 'error',
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({id:"process.error"})
                    });
                    // console.log(result);
                    Api.kickoff(result);
                }
            })
            .catch((err) => {
                
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        err.response &&
                            err.response.data &&
                            err.response.data.errors &&
                            err.response.data.errors[0]
                            ? err.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(err);
            });
    };

    setAccordion(){

        const { userSession } = this.props

        var userId = userSession && userSession.user && userSession.user.id

        this.fetchTheGetStatisticsCalledsByDueDate();

        this.setState({ openAccordionFilter: !this.state.openAccordionFilter })
        localStorage.setItem(`openaccordionfilter${userId}`, !this.state.openAccordionFilter  )
        
    }

    async checkEmail() {
        this.setState({ loading: true });
        
        await Api.get('/emails/organization/' + this.state.organizationCheckEmail).then(result => {

            if (result.data.success) {
                const intl = this.props.intl;
                if (result.data.data > 1) {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'success',
                        notificationMessage: intl.formatMessage({id:"called.list.notification.was.created"}) + result.data.data + intl.formatMessage({id:"called.list.notification.called.with.success"}),
                        resultList: []
                    });
                } else if (result.data.data == 1) {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'success',
                        notificationMessage: intl.formatMessage({id:"called.list.notification.was.created.plural"}) + result.data.data + intl.formatMessage({id:"called.list.notification.called.with.success.plural"}),
                        resultList: []
                    });
                } else {

                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: intl.formatMessage({id:"called.list.notification.empty.mailbox"}),
                        resultList: []
                    });
                    Api.kickoff(result);
                }

                this.componentDidMount();
            }
        }).catch(err => {
            const intl = this.props.intl;
            // console.log(err);
            this.setState({
                loading: false, openNotification: true, notificationVariant: "error",
                notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({id:"process.error"})
            });
            Api.kickoff(err);

        });;

        this.setState({ loading: false });
    }

    closeNotification() {
        this.setState({ openNotification: false });
    }

      toggleDrawer = () => {
        if (this.state.openDrawerFilterMenu) {
            this.setState({ drawerAnimationClass: 'filter-drawer-exit'}, () => {
                setTimeout(() => {
                    this.setState({ openDrawerFilterMenu: false, drawerAnimationClass: ''});
                }, 500);
            });
  
            setTimeout(() => {
                this.setState({ valueSpacingGrid: 10});
            }, 100);

            setTimeout(() => {
                this.setState({ valueSpacingGrid: 11});
            }, 200);

            setTimeout(() => {
                this.setState({ valueSpacingGrid: 12});
            }, 300);

        } else {
          this.setState({ openDrawerFilterMenu: true, drawerAnimationClass: 'filter-drawer-enter', drawerGridAnimationClass: 'filter-grid-drawer-enter' }, () => {
            setTimeout(() => {
              this.setState({ drawerAnimationClass: '', drawerGridAnimationClass: '' });
            }, 500);
          });

          setTimeout(() => {
                this.setState({ valueSpacingGrid: 11});
            }, 100);

            setTimeout(() => {
                this.setState({ valueSpacingGrid: 10});
            }, 200);

            setTimeout(() => {
                this.setState({ valueSpacingGrid: 9});
            }, 300);
        }
      };

    createUi = () => {
        const intl = this.props.intl;
    
        return this.state.categoryChildrens.map((el, i) =>
          <Grid key={i} item xs={4} sm={4}>
            { i > 0 ?
            (<Grid container spacing={4}>
              <Grid item xs={1} sm={1} style={{ display: 'flex', alignItems: 'center', fontSize: '2em' }}>&gt;</Grid>
              <Grid item xs={10} sm={10}>
                <SimpleAutoCompleteByName
                  intl={intl}
                  label=""
                  options={this.state.categoryLists[i] || []}
                  stateName={`lcat-${i}`}
                  name={`lcat-${i}`}
                  changeSelect={this.handleChangeCategoryChildrens.bind(this, i)}
                  selected={el}
                />
              </Grid>
            </Grid>)
            :
            (
                <SimpleAutoCompleteByName
                    intl={intl}
                    label=""
                    options={this.state.categoryLists[i] || []}
                    stateName={`lcat-${i}`}
                    name={`lcat-${i}`}
                    changeSelect={this.handleChangeCategoryChildrens.bind(this, i)}
                    selected={el}
                />
            )}
          </Grid>
        )
    }

    handleDelete(chipToDelete) {
        const intl = this.props.intl;
        let valueAtual = this.state.contentFilter.split("\n")
        let newvalue = "";
        let newFilter = ""
        let newSearch = ""
        PapiroConsole.log(valueAtual)
        PapiroConsole.log("valueAtual")
        valueAtual.map(item => {
            if (item != "" && item != valueAtual[chipToDelete]) {
                newvalue = newvalue + item + " \n"
                let itemSplit = item.split(" = ")
                PapiroConsole.log("itemSplit")
                PapiroConsole.log(itemSplit)
                
                if(itemSplit && itemSplit[0] && itemSplit[1]) {
                    let nameField = itemSplit[0]
                    let filterName = this.state.filters.filter(f => f.name === itemSplit[0])
                    PapiroConsole.log("nameField")
                    PapiroConsole.log("filterName")
                    PapiroConsole.log(nameField)
                    PapiroConsole.log(filterName)
                    
                    if(filterName && filterName.length > 0){
                        nameField = filterName[0].id
                        PapiroConsole.log("nameField")
                        PapiroConsole.log(nameField)
                    }
                    else if (nameField == intl.formatMessage({ id: "called.report.header" }) ){
                        nameField = "calledcards"
                    }
                        
                    
                    
                    newFilter += nameField + '|'
                    newSearch += itemSplit[1] + '|'
                }
            }
        })
        PapiroConsole.log("content filter atualizado 11")
        this.setState({
            contentFilter: newvalue
        });
        localStorage.setItem("newFilter", newFilter);
        localStorage.setItem("newSearch", newSearch);
        localStorage.setItem("newFilter2", newFilter);
        localStorage.setItem("newSearch2", newSearch);
        PapiroConsole.log("variaveis de filtro")
        PapiroConsole.log(this.state.isArchived)
        PapiroConsole.log(this.state.isFinished)
        PapiroConsole.log(this.state.isCanceled)
        
        if(this.state.isArchived == 0 && this.state.isFinished == 0 && this.state.isCanceled == 0  ){
            PapiroConsole.log("entrei nesse if de teste")
            PapiroConsole.log(newvalue)
            PapiroConsole.log(this.state.contentOrder)
            if (newvalue == "" && this.state.contentOrder == "") {
                this.clearFields()
            } else {    
                    this.callSearch()  
            }

        }
        
    };

    handleOrderDelete(chipToDelete) {
        let valueAtual = this.state.contentOrder.split("\n")
        let newvalue = "";
        let newFilter = ""
        let newSearch = ""
        valueAtual.map(item => {
            if (item != "" && item != valueAtual[chipToDelete]) {
                newvalue = newvalue + item + " \n"
                let itemSplit = item.split(" = ")
                if(itemSplit && itemSplit[0] && itemSplit[1]) {
                    let nameField = itemSplit[0]
                    let filterName = this.state.filters.filter(f => f.name === itemSplit[0])
                    if(filterName && filterName.length > 0)
                        nameField = filterName[0].id
                    newFilter += nameField + '|'
                    newSearch += itemSplit[1] + '|'
                }
            }
        })

        this.setState({
            contentOrder: newvalue
        });

        localStorage.setItem("newOrderFilter", newFilter);
        localStorage.setItem("newOrderSearch", newSearch);

        if (newvalue == "" && this.state.contentFilter == "") {
            this.clearFields()
        } else {
            this.callSearch()
        }

    };

    handleDeleteFilterEdit = (chipToDelete) => {
        let currentvalue = this.state.contentFilterEdit.split("\n")
        var newvalue = "";
        let newFilter = ""
        let newSearch = ""
        currentvalue.map(item => {
            if (item != "" && item != currentvalue[chipToDelete]) {
                newvalue = newvalue + item + " \n"
                let itemSplit = item.split(" = ")
                if(itemSplit && itemSplit[0] && itemSplit[1]) {
                    let nameField = itemSplit[0]
                    let filterName = this.state.filters.filter(f => f.name === itemSplit[0])
                    if(filterName && filterName.length > 0)
                        nameField = filterName[0].id
                    newFilter += nameField + '|'
                    newSearch += itemSplit[1] + '|'
                }
            }
        })
        this.setState({
            contentFilterEdit: newvalue
        });
    }

    handleDeleteOrderEdit = (chipToDelete) => {
        let valueAtual = this.state.contentOrderEdit.split("\n")
        let newvalue = "";
        let newFilter = ""
        let newSearch = ""
        valueAtual.map(item => {
            if (item != "" && item != valueAtual[chipToDelete]) {
                newvalue = newvalue + item + " \n"
                let itemSplit = item.split(" = ")
                if(itemSplit && itemSplit[0] && itemSplit[1]) {
                    let nameField = itemSplit[0]
                    let filterName = this.state.filters.filter(f => f.name === itemSplit[0])
                    if(filterName && filterName.length > 0)
                        nameField = filterName[0].id
                    newFilter += nameField + '|'
                    newSearch += itemSplit[1] + '|'
                }
            }
        })

        this.setState({
            contentOrderEdit: newvalue
        });
    }

    setCurrentPopupData(calledId, columnsArray) {
        
        if (!this.state.calledsList || this.state.calledsList.length === 0) return null;
        const called = this.state.calledsList.find(i => i.id === calledId)

        const popupData = columnsArray.map(({ title, field }) => {
            return { title, value: called[field] }
        });
        if (popupData && popupData.length > 0) {
            this.setState({ currentPopupData: popupData })
        } else {
            this.setState({ currentPopupData: null })
        }
    }

    consultCalled = async (calledId) => {
		
        this.setState({ loading: true });
        let response = await searchById(calledId);
        if (
            response != null &&
            response.success != null &&
            response.success &&
            response.data != null &&
            response.data
        ) {
            this.setState({ loading: false });
            this.props.history.push(
                `/${this.props.match.params.lang}/called-view/${calledId}`
            );
        } else {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage:
                    response &&
                        response.response &&
                        response.response.data &&
                        response.response.data.errors &&
                        response.response.data.errors[0]
                        ? response.response.data.errors[0]
                        : intl.formatMessage({ id: "process.error" }),
            });
            Api.kickoff(response);
        }
    }

    handleInputChange = (e, origin) => {
        const name = e.target.name
        const value = e.target.value

        if(origin === 'createTableCustomDialog') {
            this.setState(prevState => ({
                createTableCustomDialog: {
                    ...prevState.createTableCustomDialog,
                    [name]: value
                }
            }))
        } else if(origin === 'editTableCustomDialog') {
            this.setState(prevState => ({
                editTableCustomDialog: {
                    ...prevState.editTableCustomDialog,
                    [name]: value
                }
            }))
        }
    }

    setShowButton = (showButton) => {
        this.setState({
            openDrawerFilterMenu: showButton,
        })
    }

    render() {
        const { classes, userSession, headerMenu, actionsHeaderMenu, calleds } = this.props;
        const { createTableCustomDialog, editTableCustomDialog } = this.state
        PapiroConsole.log("userSession na listagem ")
        PapiroConsole.log(userSession)
        PapiroConsole.log("this.state.editTableCustomDialog here ")
        PapiroConsole.log(this.state.editTableCustomDialog)
        PapiroConsole.log(this.admGlobal)
        
       
        
        var link = `/${this.props.match.params.lang}/called-registration`;
        if (this.isClient) {
            link = `/${this.props.match.params.lang}/called-registration-client`;
        }
        const intl = this.props.intl;

        if (Api == null) {
            var l = this.props.match.params.lang;
            document.location.href = `/${l}/unavailable`
        }

        const openFilterMenu = Boolean(this.state.filterMenuAnchorEl);
        const openOrderMenu = Boolean(this.state.orderCurrent);
// -------------------------------- --------------------------------------------------------------------------------------------------------------------------------------------------------------
        

        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main
                    className={clsx(classes.content, {
                        [classes.contentShift]: headerMenu.open,
                    }, classes.actionsContent, {
                        [classes.actionscontentShift]: actionsHeaderMenu.open,
                    })}
                >
                    <div className={classes.drawerHeader} />

                    <Container component='main' maxWidth={false} style={{ paddingLeft: 0, marginLeft: 0 }}>
                        {(!this.state.emptyArray || this.state.dataFilter) ? (
                            <div>
								<CssBaseline />

                                {this.state.modalopen && (
                                    <ModalVideoCall
                                        onClose={() => this.closeModal()}
                                        requestUser={userSession.user}
                                        orgSettings={this.state.orgSettings}
                                        calledStart={() => this.componentDidMount()}

                                    />
                                )}

                                {this.state.openCheckEmail && (
                                    <Dialog open={this.state.openCheckEmail} onClose={this.closeCheckEmail} >
                                        <DialogTitle id="form-dialog-title">{intl.formatMessage({id:"check.email"})}</DialogTitle>
                                        <DialogContent style={{minWidth: "600px"}}>
                                            <SimpleAutoComplete
                                                label={intl.formatMessage({ id: 'organization' })}
                                                options={this.userOrganizations}
                                                stateName='organizationCheckEmail'
                                                name='organizationCheckEmail'
                                                changeSelect={this.changeValuesCheckEmail}
                                                style={{minWidth: "400px"}}
                                                selected={this.state.organizationCheckEmail}
                                            />
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={this.closeCheckEmail} color="primary">
                                                {intl.formatMessage({id:"close"})}
                                            </Button>
                                            <Button onClick={this.checkEmail} color="primary">
                                                {intl.formatMessage({id:"confirm"})}
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                )}

                                <Dialog open={this.state.populateCalledsDialogOpen} onClose={this.closePopulateCalledsDialog} >
                                    <DialogTitle id="form-dialog-title">Popular chamados (Métricas de tempo)</DialogTitle>
                                    <DialogContent style={{minWidth: "600px", padding: 50}}>
                                        <SimpleSelect
                                            label="Número de chamados a serem populados"
                                            options={[ { id: 100, name: '100'}, { id: 1000, name: '1000'}, { id: 5000, name: '5000'}, { id: 10000, name: '10000'}, { id: 25000, name: '25000'}, { id: 50000, name: '50000'}, { id: 100000, name: '100000'}, { id: 250000, name: '250000'}]}
                                            stateName='populateCalledsSize'
                                            name='populateCalledsSize'
                                            changeSelect={this.changeValuesPopulateCalledsSize}
                                            style={{minWidth: "400px"}}
                                            selected={this.state.populateCalledsSize}
                                        />
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={this.closePopulateCalledsDialog} color="primary">
                                            {intl.formatMessage({id:"close"})}
                                        </Button>
                                        <Button onClick={this.populateAllCalleds} color="primary">
                                            {intl.formatMessage({id:"confirm"})}
                                        </Button>
                                    </DialogActions>
                                </Dialog>

                                <Dialog
                                    open={this.state.canAssignCalledDialogOpen}
                                    onClose={this.closeCanAssignCalledDialog}
                                    aria-labelledby="dialog-can-assign-called"
                                    maxWidth="md"
                                    fullWidth={false} >
                                    <DialogTitle id="dialog-can-assign-called">
                                        Iniciar atendimento?
                                        <ClearIcon onClick={this.closeCanAssignCalledDialog} style={{ float: 'right', cursor: 'pointer' }} />
                                    </DialogTitle>
                                    <DialogContent>
                                        <DialogContentText>
                                            O sistema identificou que o chamado não está em atendimento. Deseja iniciar o atendimento? <br /> <br />Clique em "Sim" para iniciar o atendimento agora ou "Não" para apenas acessar o chamado.
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={this.closeCanAssignCalledDialog} color="primary">
                                                {intl.formatMessage({id:"cancel"})}
                                        </Button>
                                        <Button onClick={this.negativeCanAssignCalledDialog} color="primary">
                                            {intl.formatMessage({id:"no"})}
                                        </Button>
                                        <Button onClick={this.confirmCanAssignCalledDialog} color="primary" variant="contained">
                                            {intl.formatMessage({id:"yes"})}
                                        </Button>
                                    </DialogActions>
                                </Dialog>

                                <Dialog
                                    open={this.state.confirmAssignCalledDialogOpen}
                                    onClose={this.closeConfirmAssignCalledDialog}
                                    aria-labelledby="form-delete-filter"
                                    maxWidth="md"
                                    fullWidth={false}
                                    style={{ overflow: 'hidden' }}
                                    scroll="body" >
                                    <DialogTitle id="form-delete-filter">{intl.formatMessage({id:"assume.called"})}</DialogTitle>
                                    <DialogContent style={{minWidth: "400px"}}>
                                        {intl.formatMessage({id:"called.list.dialog.called.assigned.in.progress"})}
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={this.closeConfirmAssignCalledDialog} color="primary">
                                            {intl.formatMessage({id:"cancel"})}
                                        </Button>
                                        <Button onClick={this.assignCalled} color="primary" variant="contained">
                                            {intl.formatMessage({id:"confirm"})}
                                        </Button>
                                    </DialogActions>
                                </Dialog>

                                <Dialog
                                    open={this.state.confirmTreatCalledDialogOpen}
                                    onClose={this.closeConfirmTreatCalledDialog}
                                    aria-labelledby="confirm-treat-called-dialog"
                                    maxWidth="md"
                                    fullWidth={false}
                                    style={{ overflow: 'hidden' }}
                                    scroll="body" >
                                    <DialogTitle id="confirm-treat-called-dialog">Tratamento Rápido de Chamado</DialogTitle>
                                    <DialogContent style={{minWidth: "400px"}}>
                                        <br />Deseja iniciar o tratamento deste chamado agora?
                                        <br /><br />{intl.formatMessage({id:"called.list.dialog.called.assigned.in.progress"})}
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={this.closeConfirmTreatCalledDialog} color="primary">
                                            {intl.formatMessage({id:"cancel"})}
                                        </Button>
                                        <Button onClick={this.confirmTreatCalled} color="primary" variant="contained">
                                            {intl.formatMessage({id:"confirm"})}
                                        </Button>
                                    </DialogActions>
                                </Dialog>

                                <TreatCalledModal
                                    open={this.state.treatCalledModalOpen}
                                    onClose={this.closeTreatCalledModal}
                                    onAssignCalled={this.assignCalledForTreatment}
                                    onShowNotification={this.showNotification}
                                    onCalledClosed={this.removeCalledFromList}
                                    /* Retomada de tratamento: o chamado já é do usuário logado, então
                                       não há o que atribuir — evita reassumir um chamado já atribuído. */
                                    skipAssignment={this.isCalledAssignedToLoggedUser(this.state.calledToTreat)}
                                />
                                
                                {this.state.massMoveCalledModalOpen && (
                                    <MassMoveCalledModal
                                        open={this.state.massMoveCalledModalOpen}
                                        onClose={this.closeMassMoveCalledModal}
                                        onShowNotification={this.showNotification}
                                        lang={this.props.match && this.props.match.params && this.props.match.params.lang}
                                    />
                                )}

                                <Dialog
                                    open={this.state.confirmDeleteTableCustomFilterDialogOpen}
                                    onClose={this.closeConfirmDeleteTableCustomFilterDialog}
                                    aria-labelledby="form-delete-filter"
                                    maxWidth="md"
                                    fullWidth={true}
                                    style={{ overflow: 'hidden' }}
                                    scroll="body" >
                                    <DialogTitle id="form-delete-filter">Filtro personalizado</DialogTitle>
                                    <DialogContent style={{width: "600px"}}>
                                        {intl.formatMessage({id:"called.list.dialog.confirm.delete.filter"})}
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={this.closeConfirmDeleteTableCustomFilterDialog} color="primary">
                                            {intl.formatMessage({id:"close"})}
                                        </Button>
                                        <Button onClick={this.deleteTableCustomFilter} color="primary">
                                            {intl.formatMessage({id:"confirm"})}
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                                <Dialog
                                    open={this.state.createTableCustomDialogOpen}
                                    onClose={this.closeCreateTableCustomDialog}
                                    aria-labelledby="form-dialog-title"
                                    maxWidth="md"
                                    fullWidth={true}
                                    style={{ overflow: 'hidden' }}
                                    scroll="body">
                                    <DialogTitle id="form-dialog-title">
                                        {intl.formatMessage({id:"called.list.dialog.save.custom.filter"})}
                                        <ClearIcon onClick={this.closeCreateTableCustomDialog} style={{ float: 'right', cursor: 'pointer' }} />
                                    </DialogTitle>
                                    <DialogContent style={{ padding: 24 }}>
                                        <Grid container spacing={4}>
                                            <Grid item xs={12} sm={12}>
                                                <TextField
                                                    inputProps={{ maxLength: 255 }}
                                                    fullWidth
                                                    label={intl.formatMessage({id:"name"})}
                                                    autoComplete='fname'
                                                    variant='outlined'
                                                    name='name'
                                                    onChange={(e) => this.handleInputChange(e, 'createTableCustomDialog')}
                                                    value={createTableCustomDialog ? createTableCustomDialog.name : ""}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <TextField
                                                    inputProps={{ maxLength: 15 }}
                                                    fullWidth
                                                    label={intl.formatMessage({id:"exhibition.name"})}
                                                    autoComplete='fname'
                                                    variant='outlined'
                                                    name='exhibitionName'
                                                    onChange={(e) => this.handleInputChange(e, 'createTableCustomDialog')}
                                                    value={createTableCustomDialog ? createTableCustomDialog.exhibitionName : ""}
                                                    required 
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <SimpleAutoCompleteMultiple
                                                    label={`${intl.formatMessage({ id: 'organization' })}${(!this.admGlobal && (this.isAdmOrg || this.isCoordenator) && !createTableCustomDialog.isPrivate) ? '*' : ''}`}
                                                    options={this.state.tableCustomFilterOrganizationList}
                                                    stateName='tableCustomFilterOrganizationIds'
                                                    name='tableCustomFilterOrganizationIds'
                                                    changeSelect={this.changeValuesCreateTableCustomDialog}
                                                    style={{minWidth: "400px"}}
                                                    selected={createTableCustomDialog.tableCustomFilterOrganizationIds}
                                                />
                                            </Grid>
                                            <Grid item xs={10} sm={5}>
                                                <SimpleCheckBox
                                                    label={intl.formatMessage({id:"private"})}
                                                    name='isPrivate'
                                                    stateName='isPrivate'
                                                    changeSelect={this.changeValuesCreateTableCustomDialog}
                                                    selected={createTableCustomDialog ? createTableCustomDialog.isPrivate : false}
                                                    disabled={ (this.isClient) || (this.isTechnical && !this.isAdm && !this.admGlobal) } />
                                            </Grid>
                                            <Grid item xs={2} sm={7} style={{ textAlign: 'right', alignSelf: 'stretch' }}>
                                                <Tooltip title={intl.formatMessage({id:"called.list.tooltip.turns.custom.filter.private"})}>
                                                    <HelpIcon />
                                                </Tooltip>
                                            </Grid>
                                            <Grid item xs={10} sm={5}>
                                                <SimpleCheckBox
                                                    label={intl.formatMessage({id:"save.as.favorite"})}
                                                    name='isFavorite'
                                                    stateName='isFavorite'
                                                    changeSelect={this.changeValuesCreateTableCustomDialog}
                                                    selected={createTableCustomDialog ? createTableCustomDialog.isFavorite : false} />
                                            </Grid>
                                            <Grid item xs={2} sm={7} style={{ textAlign: 'right', alignSelf: 'stretch' }}>
                                                <Tooltip title={intl.formatMessage({id:"called.list.tooltip.saves.filter.as.favorite"})}>
                                                    <HelpIcon />
                                                </Tooltip>
                                            </Grid>
                                            <Grid item xs={10} sm={5}>
                                                <SimpleCheckBox
                                                    label= {intl.formatMessage({id:"standard.filter"})}
                                                    name='isDefault'
                                                    stateName='isDefault'
                                                    changeSelect={this.changeValuesCreateTableCustomDialog}
                                                    selected={createTableCustomDialog ? createTableCustomDialog.isDefault : false} />
                                            </Grid>
                                            <Grid item xs={2} sm={7} style={{ textAlign: 'right', alignSelf: 'stretch' }}>
                                                <Tooltip title={intl.formatMessage({id:"called.list.tooltip.saves.filter.as.standard"})}>
                                                    <HelpIcon />
                                                </Tooltip>
                                            </Grid>
                                            <Grid item xs={10} sm={5}>
                                                <SimpleCheckBox
                                                    label= {intl.formatMessage({id:"display.filter.in.called.list"})}
                                                    name='displayFilterInCalledList'
                                                    stateName='displayFilterInCalledList'
                                                    changeSelect={this.changeValuesCreateTableCustomDialog}
                                                    selected={createTableCustomDialog ? createTableCustomDialog.displayFilterInCalledList : false} />
                                            </Grid>
                                            <Grid item xs={2} sm={7} style={{ textAlign: 'right', alignSelf: 'stretch' }}>
                                                <Tooltip title={intl.formatMessage({id:"display.filter.in.called.list.tooltip"})}>
                                                    <HelpIcon />
                                                </Tooltip>
                                            </Grid>
                                        </Grid>
                                    </DialogContent>
                                    <DialogActions justify="flex-end" style={{marginBottom:'10px'}} >
                                        <Grid container spacing={4} justifyContent="flex-end">
                                            <Grid item xs={12} sm={4}>
                                                <Button
                                                    variant='contained'
                                                    type="button"
                                                    onClick={this.closeCreateTableCustomDialog}
                                                    fullWidth >
                                                    {intl.formatMessage({id:"cancel"})}
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <Button
                                                    type='submit'
                                                    fullWidth
                                                    variant='contained'
                                                    color='primary'
                                                    onClick={this.saveTableCustomFilter} >
                                                    {<FormattedMessage id="save" />}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </DialogActions>
                                </Dialog>
                                <SavedFiltersModal
                                  open={this.state.listTableCustomDialogOpen}
                                  step={this.state.editTableCustomFilterStep}
                                  loading={this.state.listTableCustomDialogLoading}
                                  onClose={this.closeListTableCustomDialog}
                                  filters={this.state.listTableCustomDialogList}
                                  searchValue={this.state.searchValueListTableCustomField}
                                  onSearchChange={(value) => this.setState({ searchValueListTableCustomField: value })}
                                  onSearch={this.searchFilter}
                                  onClearSearch={this.listTableCustomFilters}
                                  onApply={(filter) => this.setFilters(filter, 'listCustomTableFilter')}
                                  onEditStep={this.setEditStep}
                                  onDeleteStep={this.openConfirmDeleteTableCustomFilterDialog}
                                  editData={this.state.editTableCustomDialog}
                                  contentFilterEdit={this.state.contentFilterEdit}
                                  contentOrderEdit={this.state.contentOrderEdit}
                                  organizationList={this.state.tableCustomFilterOrganizationList || []}
                                  filterOptions={this.state.filters}
                                  filterSelectedEdit={this.state.filterSelectedEdit}
                                  searchValueEdit={this.state.searchValueEdit}
                                  onBack={this.closeEditStep}
                                  onSave={this.editTableCustomFilter}
                                  onInputChange={this.handleInputChange}
                                  onChangeOrgs={this.changeValuesEditTableCustomDialog}
                                  onChangeEditField={this.changeValuesEditTableCustomDialog}
                                  onDeleteFilterChip={this.handleDeleteFilterEdit}
                                  onDeleteOrderChip={this.handleDeleteOrderEdit}
                                  onAddFilterEdit={this.addFilterEdit}
                                  onClearFieldsEdit={this.clearFieldsEdit}
                                  onCallSearchEdit={this.callSearchEdit}
                                  onHandleChangeFieldValue={this.handleChangeFieldValue}
                                  admGlobal={this.admGlobal}
                                  isAdmOrg={this.isAdmOrg}
                                  isCoordenator={this.isCoordenator}
                                  isClient={this.isClient}
                                  isTechnical={this.isTechnical}
                                  isAdm={this.isAdm}
                                  currentUserId={userSession?.user?.id}
                                  orderFields={this.state.orderFields}
                                  intl={intl}
                                  classes={classes}
                                />

                                {(this.admGlobal && (userSession && userSession.user && (userSession.user.email == 'suporte@papiro.ai' || userSession.user.email == 'suporte@mexx.ai' || userSession.user.email == 'eduardo.lima@cmtech.com.br' || userSession.user.email == 'tpporto@gmail.com'))) ? (
                                <Grid container className={classes.mb20} spacing={0}>
                                    <Grid item xs={6} sm={6} md={6} lg={6} >
										{((userSession != null && userSession.user != null && userSession.user.isexternal != null && userSession.user.isexternal && userSession.user.canexternaluserclientcreatecalled != null && userSession.user.canexternaluserclientcreatecalled) || (userSession != null && userSession.user.isexternal != null && !userSession.user.isexternal)) &&
											<Can I="Open" a="Called">
												<Button
													variant="contained"
													color="secondary"
													size="large"
													className={classes.button}
													startIcon={<AddIcon />}
													component={Link} {...{ to: link }}
												>
													{<FormattedMessage id="called.new" />}
												</Button>
											</Can>
										}
                                     
                                    </Grid>
                                    <Grid item xs={5} sm={5} md={5} lg={5} >
										
                                            {/*<Button
                                                variant="contained"
                                                color="secondary"
                                                size="large"
                                                className={classes.button}
                                                startIcon={<SaveIcon />}
                                                onClick={() => this.openPopulateCalledsDialog()}
                                            >
                                                Popular chamados (Métricas de tempo) {this.state.calledCountNotTimeData} chamados restantes
                                            </Button>*/}
									
									</Grid>
                                    <Grid item xs={1} sm={1} md={1} lg={1} style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end' }} >
                                        {!this.isClient && 
                                            <TreeDots items={this.state.itemsTree} />
                                        }
                                    </Grid>
                                </Grid>) : (
                                <Grid container className={classes.mb20} spacing={0}>
                                    <Grid item xs={11} sm={11} md={11} lg={11} >
									{(
                                        (
                                         (userSession != null && userSession.user != null && userSession.user.isexternal != null && userSession.user.isexternal && userSession.user.canexternaluserclientcreatecalled != null && userSession.user.canexternaluserclientcreatecalled)
                                        || 
                                        (userSession != null && userSession.user.isexternal != null && !userSession.user.isexternal)
                                        ) 
                                        
                                        && (userSession.user.originrequestid != 8 && userSession.user.originrequestid != 9)
                                        ) &&
                                        <Can I="Open" a="Called">
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                size="large"
                                                className={classes.button}
                                                startIcon={<AddIcon />}
                                                component={Link} {...{ to: link }}
                                            >
                                                {<FormattedMessage id="called.new" />}
                                            </Button>
                                        </Can>
										}
                                    </Grid>
                                    <Grid item xs={1} sm={1} md={1} lg={1} style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end' }} >
                                        {!this.isClient && 
                                                <TreeDots items={this.state.itemsTree} />
                                        }
                                        
                                    </Grid>
                                </Grid>
                                )}
                                {!this.isClient && this.state.isFinished == 0  && this.state.isArchived == 0 &&  this.state.isCanceled == 0 &&
                                    <Grid container  mb={1}>

                                    
                                        <Grid item xs={12} sm={6} md={2}  style={{ padding: '2px' }}>
                                            <CalledsQuantityCards message="expired.calleds.total" quantity={this.state.countExpiredCalleds} icon="expiredGeral"  refresh={false} callSearch={this.callSearch} clearFilters={this.clearFilters} disabledCardActionArea={false} origin="called-list" tooltipCard ="expired.calleds.total.tooltip"  />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}  style={{ padding: '2px' }}>
                                            <CalledsQuantityCards message="expired.calleds.today" quantity={this.state.countExpiredCalledsToday} icon="expiredToday" refresh={false} callSearch={this.callSearch} clearFilters={this.clearFilters} disabledCardActionArea={false} origin="called-list" tooltipCard ="expired.calleds.today.tooltip"    />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}  style={{ padding: '2px' }}>
                                            <CalledsQuantityCards message="general.open.calleds" quantity={this.state.countOpenCalleds} icon="openGeral" refresh={false} callSearch={this.callSearch} clearFilters={this.clearFilters} disabledCardActionArea={false} origin="called-list" tooltipCard ="general.open.calleds.tooltip"    />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}  style={{ padding: '2px' }}>
                                        <   CalledsQuantityCards message="today.pending.calleds" quantity={this.state.countPendingCalledsToday} icon="pendingToday" refresh={true} getCalledsToCard ={this.getCalledsToCard} callSearch={this.callSearch} clearFilters={this.clearFilters} disabledCardActionArea={false} origin="called-list"  tooltipCard="today.pending.calleds.tooltip" />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}  style={{ padding: '2px' }}>
                                        <   CalledsQuantityCards message="today.open.calleds" quantity={this.state.countOpenCalledsToday} icon="openToday" refresh={true} getCalledsToCard ={this.getCalledsToCard} callSearch={this.callSearch} clearFilters={this.clearFilters} disabledCardActionArea={false} origin="called-list"  tooltipCard="today.open.calleds.tooltip" />
                                        </Grid>
                                        
                                        <Grid item xs={12} sm={6} md={2}  style={{ padding: '2px' }}>
                                            <CalledsQuantityCards message="calleds.without.assigned" quantity={this.state.countCalledsWithoutAssignedUser} icon="WithoutAssignedUser"  refresh={false} callSearch={this.callSearch} clearFilters={this.clearFilters} disabledCardActionArea={false} origin="called-list"  tooltipCard="calleds.without.assigned.tooltip"  />
                                        </Grid>
                                        

                                    </Grid>
                                }
                                                                
                                {!this.isClient && (
                                    <div style={{ marginBottom: '10px' }} data-tour="called-list-filters">
                                        <Accordion 
                                        onChange={this.setAccordion} 
                                        defaultExpanded={this.state.openAccordionFilter}
                                        >
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                                data-tour="called-list-filters-toggle"
                                            >
                                                <Typography className={classes.heading}>
                                                    {!!this.state.filtersByFlag
                                                        && this.state.filtersByFlag.length > 0
                                                        ? `${intl.formatMessage({ id: "called.duedate.card" })}/${intl.formatMessage({ id: "called.card.filters.user.created" })}`
                                                        : intl.formatMessage({ id: "called.duedate.card" })
                                                    }
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Grid container mb={1} spacing={1} direction="row" justify="space-between" alignItems="stretch">
                                                    <Grid item xs={12} sm={6} md={2}>
                                                        <CalledsQuantityCards
                                                            message="called.duedate.card.today"
                                                            quantity={this.state.countCalledsDueDateToday}
                                                            icon="calledDueDatetodayRounded"
                                                            refresh={false}
                                                            callSearch={this.callSearch}
                                                            clearFilters={this.clearFilters}
                                                            origin="called-due-date-list"
                                                            tooltipCard="called.duedate.card.today.tooltip"
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={2}>
                                                        <CalledsQuantityCards
                                                            message="called.duedate.card.week"
                                                            quantity={this.state.countCalledsDueDateWeek}
                                                            icon="calledDueDateweekRounded"
                                                            refresh={false}
                                                            callSearch={this.callSearch}
                                                            clearFilters={this.clearFilters}
                                                            origin="called-due-date-list"
                                                            tooltipCard="called.duedate.card.week.tooltip"
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={2}>
                                                        <CalledsQuantityCards
                                                            message="called.duedate.card.month"
                                                            quantity={this.state.countCalledsDueDateMonth}
                                                            icon="calledDueDatemonthRounded"
                                                            refresh={false}
                                                            callSearch={this.callSearch}
                                                            clearFilters={this.clearFilters}
                                                            origin="called-due-date-list"
                                                            tooltipCard="called.duedate.card.month.tooltip"
                                                        />
                                                    </Grid>

                                                    {!!this.state.filtersByFlag
                                                        && this.state.filtersByFlag.length > 0
                                                        && this.state.filtersByFlag.map((item, key) => {
                                                            return (
                                                                <Grid item xs={12} sm={6} md={2} key={key}>
                                                                    <Favoritefilterscards item={item} clearFilters={this.clearFilters} quantity={item.countcalleds} icon="FilterListIcon" goToCalledWithFilter={this.goToCalledWithFilter} origin="called-list" callSearch={this.callSearch} />
                                                                </Grid>
                                                            )
                                                        })}
                                                </Grid>
                                            </AccordionDetails>
                                        </Accordion>
                                    </div>
                                )}

                                
                                {(this.state.contentFilter) && false &&
                                    <Grid container spacing={6} style={{marginBottom:'15px'}}>
                                        <Grid item xs={12} sm={12}>
                                            <Card className="background-title-search">
                                                <CardContent>
                                                    <Grid container spacing={1} alignItems="flex-end">
                                                        <Grid item xs={8} md={6}>
                                                            <Typography component={'span'} variant="h5">
                                                                {intl.formatMessage({id:"filters"})}
                                                        </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <strong>
                                                                {this.state.contentFilter && this.state.contentFilter.length > 0 && this.state.contentFilter.split("\n").map((i, key) => {
                                                                    if (i.trim() != "") {
                                                                        return <Chip
                                                                            key={key}
                                                                            label={i}
                                                                            onDelete={() => this.handleDelete(key)}
                                                                            color="primary"
                                                                            variant="outlined"
                                                                        />
                                                                    }
                                                                })}
                                                                {/*this.state.contentOrder && this.state.contentOrder.length > 0 && this.state.contentOrder.split("\n").map((i, key) => {
                                                                    if (i.trim() != "") {
                                                                        return <Chip
                                                                            key={key}
                                                                            label={i}
                                                                            onDelete={() => this.handleOrderDelete(key)}
                                                                            color="primary"
                                                                            variant="outlined"
                                                                        />
                                                                    }
                                                                })*/}
                                                            </strong>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                }
                                {/*Filtro do chamado antigo*/}
                                {/*<Grid container spacing={6}>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <Card className="background-title-search">
                                            <CardContent>
                                                <Grid container spacing={1} justify="space-between" alignItems="center">
                                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                                        <Typography component={'span'} variant="h5">
                                                            {<FormattedMessage id="called.header" />}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={12} md={10} lg={10}>
                                                        <Grid container spacing={1} direction="row" alignItems="center">
															<SearchBar
                                                                field={this.state.filterSelected}
                                                                filterValue={this.state.searchValue}
                                                                filterName={"searchValue"}
                                                                filters={this.state.filters}
                                                                addFilterEdit={this.addFilter} 
																clearFieldsEdit={this.clearFields}
                                                                callSearch={this.callSearch}
                                                                orderFields={this.state.orderFields}
                                                                handleChangeFieldValue={this.handleChangeFieldValue}
																{...this.props} />
															<Grid item xs={1} sm={1} md={1} lg={1}>
                                                                <IconButton
                                                                    color='primary'
                                                                    aria-label='filters'
                                                                    component='span'
                                                                    id="filter-menu"
                                                                    aria-controls={ openFilterMenu ? 'filter-menu' : undefined }
                                                                    aria-haspopup="true"
                                                                    aria-expanded={ openFilterMenu ? 'true' : undefined }
                                                                    onClick={this.handleClickFilterMenu} >
                                                                    <MoreVert />
                                                                </IconButton>
                                                                <Menu
                                                                    id="filter-menu"
                                                                    aria-labelledby="filter-menu"
                                                                    anchorEl={this.state.filterMenuAnchorEl}
                                                                    open={openFilterMenu}
                                                                    onClose={this.handleCloseFilterMenu}
                                                                    anchorOrigin={{
                                                                        vertical: 'top',
                                                                        horizontal: 'left'
                                                                    }}
                                                                    transformOrigin={{
                                                                        vertical: 'top',
                                                                        horizontal: 'left'
                                                                    }} >
                                                                        <MenuItem onClick={this.openCreateTableCustomDialog} disabled={ (this.state.contentFilter == null || this.state.contentFilter == '') && (this.state.contentOrder == null || this.state.contentOrder == '') }>
                                                                            <ListItemIcon style={{ minWidth: 25 }}>
                                                                                <SaveIcon style={{ fontColor: "#3f51b4", fill: "#3f51b4" }} />
                                                                            </ListItemIcon>
                                                                            {intl.formatMessage({id:"save"})}
                                                                        </MenuItem>
                                                                        <Divider />
                                                                        <MenuItem disabled={true}>{intl.formatMessage({id:"custom.filters"})}</MenuItem>
                                                                        { this.state.filterFavorite && this.state.filterFavorite.map((item, idx) => {
                                                                            return <MenuItem key={idx} onClick={() => this.setFilters(item)}>
                                                                                {item.tablecustomfilterfavorite != null && (
                                                                                <ListItemIcon style={{ minWidth: 25 }}>
                                                                                    <StarRateIcon style={{ fontColor: "#ffb400", fill: "#ffb400" }} />
                                                                                </ListItemIcon>
                                                                                )}
                                                                                {item.name}
                                                                            </MenuItem>
                                                                        })}
                                                                        { (this.state.countFavorite || this.admGlobal) &&
                                                                        (<Divider />)}
                                                                        { (this.state.countFavorite > 0 || this.admGlobal) &&
                                                                        (<MenuItem onClick={this.openListTableCustomDialog} >
                                                                            <ListItemIcon style={{ minWidth: 25 }}>
                                                                                <FormatListBulletedIcon style={{ fontColor: "#3f51b4", fill: "#3f51b4" }} />
                                                                            </ListItemIcon>
                                                                            {intl.formatMessage({id:"called.report.config.organization.field.block.list.all"})}
                                                                        </MenuItem>)}
                                                                        <Divider />
                                                                        <MenuItem onClick={this.handleClickExportToCSV} >
                                                                            <ListItemIcon style={{ minWidth: 25 }}>
                                                                                <ExitToAppIcon style={{ fontColor: "#3f51b4", fill: "#3f51b4" }} />
                                                                            </ListItemIcon>
                                                                            {intl.formatMessage({id:"called.list.export"})}
                                                                        </MenuItem>
                                                                </Menu>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>

                                    </Grid>

                                </Grid>*/}
                                {/*Filtros HTML*/}
                                <Can I="List" a="Called">
                                
                                    <Grid container>
                                        <Grid container direction="row-reverse">
                                            <IconButton
                                                color='primary'
                                                aria-label='filters'
                                                component='span'
                                                id="filter-menu"
                                                aria-controls={ openFilterMenu ? 'filter-menu' : undefined }
                                                aria-haspopup="true"
                                                aria-expanded={ openFilterMenu ? 'true' : undefined }
                                                onClick={this.handleClickFilterMenu} >
                                                <MoreVert />
                                            </IconButton>
                                            <Menu
                                                id="filter-menu"
                                                aria-labelledby="filter-menu"
                                                anchorEl={this.state.filterMenuAnchorEl}
                                                open={openFilterMenu}
                                                onClose={this.handleCloseFilterMenu}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left'
                                                }}
                                                transformOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left'
                                                }} >
                                                    <MenuItem 
                                                        onClick={() => {this.submitNewFilter(true)}} 
                                                        disabled={!Object.values(this.state.filtersCalled).some(value => value !== null && value !== undefined && value !== '')}
                                                    >
                                                        <ListItemIcon style={{ minWidth: 25 }}>
                                                            <SaveIcon style={{ fontColor: "#3f51b4", fill: "#3f51b4" }} />
                                                        </ListItemIcon>
                                                        {intl.formatMessage({id:"save"})}
                                                    </MenuItem>
                                                    <Divider />
                                                    <MenuItem disabled={true}>{intl.formatMessage({id:"custom.filters"})}</MenuItem>
                                                    { this.state.filterFavorite && this.state.filterFavorite.map((item, idx) => {
                                                        return <MenuItem key={idx} onClick={() => this.setFilters(item)}>
                                                            {item.tablecustomfilterfavorite != null && (
                                                                <ListItemIcon style={{ minWidth: 25 }}>
                                                                    <StarRateIcon style={{ fontColor: "#ffb400", fill: "#ffb400" }} />
                                                                </ListItemIcon>
                                                            )}
                                                            {item.name}
                                                        </MenuItem>
                                                    })}
                                                    { (this.state.countFavorite || this.admGlobal) &&
                                                    (<Divider />)}
                                                    { (this.state.countFavorite > 0 || this.admGlobal) &&
                                                    (<MenuItem onClick={this.openListTableCustomDialog} >
                                                        <ListItemIcon style={{ minWidth: 25 }}>
                                                            <FormatListBulletedIcon style={{ fontColor: "#3f51b4", fill: "#3f51b4" }} />
                                                        </ListItemIcon>
                                                        {intl.formatMessage({id:"called.report.config.organization.field.block.list.all"})}
                                                    </MenuItem>)}
                                                    <Divider />
                                                    <MenuItem onClick={this.handleClickExportToCSV} >
                                                        <ListItemIcon style={{ minWidth: 25 }}>
                                                            <ExitToAppIcon style={{ fontColor: "#3f51b4", fill: "#3f51b4" }} />
                                                        </ListItemIcon>
                                                        {intl.formatMessage({id:"called.list.export"})}
                                                    </MenuItem>
                                            </Menu>

                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                size="large"
                                                data-tour="called-list-filters-toggle"
                                                className={`${this.state.openDrawerFilterMenu ? 'button-active' : ''}`}
                                                startIcon={<ManageSearchIcon size="100" />}
                                                endIcon={this.state.openDrawerFilterMenu ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                onClick={this.toggleDrawer}
                                            >
                                                Filtros
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                size="large"
                                                style={{
                                                    marginRight: '8px',
                                                }}
                                                className={classes.button}
                                                onClick={this.cleanNewFilter}
                                            >
                                                Limpar
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                size="large"
                                                style={{
                                                    marginRight: '8px',
                                                }}
                                                className={classes.button}
                                                onClick={() => {this.submitNewFilter(false)}}   
                                            >
                                                Aplicar
                                            </Button>
                                            <Button
                                                color="secondary"
                                                size="large"
                                                aria-label='filters'
                                                component='span'
                                                variant="outlined"
                                                disableElevation
                                                id="order-menu"
                                                aria-controls={ openOrderMenu ? 'order-menu' : undefined }
                                                aria-haspopup="true"
                                                aria-expanded={ openOrderMenu ? 'true' : undefined }
                                                onClick={this.openDrawerOrder}
                                                style={{
                                                    borderRadius: '4px',
                                                    textTransform: 'none',
                                                    justifyContent: 'space-between',
                                                    padding: '8px 16px',
                                                    minWidth: '200px',
                                                    marginRight: 10, 
                                                    color: 'rgb(33,150,243)'
                                                }}
                                                endIcon={<KeyboardArrowDownIcon />}
                                            >
                                                <Typography>{this.state.orderFilterSelected?.name}</Typography>
                                            </Button>
                                            
                                            <Typography style={{marginRight: '10px'}} alignItems="center" alignContent="center" align="center" textAlign="center">Ordernado por: </Typography> 
                                            {/*<Stack mt={3} spacing={1}>
                                                <Typography variant="body2">
                                                Ordenando por: <strong>{this.state.orderFilterSelected?.name}</strong>
                                                </Typography>
                                                <Typography variant="body2">
                                                Direção: <strong>{this.state.orderTypeFilterSelected == "cresc" ? 'Ascendente' : 'Descendente'}</strong>
                                                </Typography>
                                            </Stack>*/}

                                            {/*<Menu
                                                anchorEl={this.state.orderCurrent}
                                                MenuListProps={{
                                                    'aria-labelledby': 'add-action-more-button',
                                                }}
                                                open={openOrderMenu}
                                                onClose={this.closeDrawerOrder}
                                                anchorOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left'
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left'
                                                }} 
                                            >
                                                {this.state.orderNewFields.map((item, key) => {
                                                    return <MenuItem selected={item.id == this.state.orderFilterSelected} key={key} onClick={() => {this.changeSelectedOrderFilter(item.id)}}>
                                                        {item.name} {item.id == this.state.orderFilterSelected ? <CheckIcon style={{marginLeft: 10}} /> : ''}
                                                    </MenuItem>
                                                })}
                                                <Divider />
                                                <MenuItem onClick={() => {this.changeSelectedTypeOrderFilter('desc')}} selected={this.state.orderTypeFilterSelected == "desc"}>
                                                    Decrescente {this.state.orderTypeFilterSelected == "desc" ? <CheckIcon style={{marginLeft: 10}} /> : ''}
                                                </MenuItem>
                                                <MenuItem onClick={() => {this.changeSelectedTypeOrderFilter('cresc')}} selected={this.state.orderTypeFilterSelected == "cresc"}>
                                                    Crescente {this.state.orderTypeFilterSelected == "cresc" ? <CheckIcon style={{marginLeft: 10}} /> : ''}
                                                </MenuItem>
                                            </Menu>*/}

                                            <Menu
                                                id="custom-select-menu"
                                                anchorEl={this.state.orderCurrent}
                                                open={openOrderMenu}
                                                onClose={this.closeDrawerOrder}
                                                MenuListProps={{
                                                    'aria-labelledby': 'custom-select-button',
                                                }}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'center',
                                                }}
                                            >
                                                {this.state.orderNewFields.map((option, index) => (
                                                    <MenuItem 
                                                        key={index}
                                                        onClick={() => this.changeSelectedOrderFilter(option)}
                                                        selected={option.id == this.state.orderFilterSelected?.id}
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            padding: '10px 16px',
                                                            color: option.id == this.state.orderFilterSelected?.id ? 'rgb(33,150,243)' : 'inherit',
                                                        }}
                                                    >
                                                        <Typography color={this.state.orderFilterSelected?.id == option.id ? 'rgb(33,150,243)': ''}>{option.name}</Typography>
                                                        {option.id == this.state.orderFilterSelected?.id && (
                                                            <>
                                                                <CheckIcon style={{ color: 'rgb(33,150,243)' }} fontSize="8px" />
                                                            </>
                                                        )}
                                                    </MenuItem>
                                                ))}
                                                <Divider />
                                                <MenuItem 
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        padding: '10px 16px',
                                                    }} 
                                                    onClick={() => {this.changeSelectedTypeOrderFilter('desc')}} selected={this.state.orderTypeFilterSelected == "desc"}
                                                >
                                                    <Typography color={this.state.orderTypeFilterSelected == "desc" ? 'rgb(33,150,243)': ''}>Decrescente</Typography>
                                                    {this.state.orderTypeFilterSelected == "desc" ?
                                                        <ListItemIcon style={{ minWidth: 'auto', ml: 1 }}>
                                                            <CheckIcon style={{ color: 'rgb(33,150,243)' }} fontSize="small" />
                                                        </ListItemIcon> : ''
                                                    }
                                                </MenuItem>
                                                <MenuItem 
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        padding: '10px 16px',
                                                        color: this.state.orderTypeFilterSelected == "cresc" ? 'rgb(33,150,243)' : 'inherit',
                                                    }} 
                                                    onClick={() => {this.changeSelectedTypeOrderFilter('cresc')}} 
                                                    selected={this.state.orderTypeFilterSelected == "cresc"}
                                                >
                                                    <Typography color={this.state.orderTypeFilterSelected == "cresc" ? 'rgb(33,150,243)': ''}>Crescente</Typography>
                                                    {this.state.orderTypeFilterSelected == "cresc" ?
                                                        <ListItemIcon style={{ minWidth: 'auto', ml: 1 }}>
                                                            <CheckIcon style={{ color: 'rgb(33,150,243)' }} fontSize="small" color="primary" />
                                                        </ListItemIcon> : ''
                                                    }
                                                </MenuItem>
                                            </Menu>
                                        </Grid>
                                        <Grid xs={this.state.valueSpacingGrid}>
                                            <div className='material-table'>
                                                <Grid container spacing={0}>
                                                    {this.state.calledsList.length == 0 && this.state.displayNotFound && (
                                                        <Grid container justifyContent="center" alignItems="center" style={{ marginTop: 50 }}>
                                                            <Grid item xs={12} style={{ textAlign: 'center', marginTop: 16 }}>
                                                                <Typography variant="h3">
                                                                   Nenhum dado encontrado
                                                                </Typography>
                                                                <Typography variant="body1">
                                                                    Não existem registros para o filtro pesquisado. Tente ajustar os critérios de busca.
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    )}
                                                    {this.state.calledsList.map((item) => {
                                                        return <ItemCard
                                                            called={item}
                                                            isAdm={this.isAdm}
                                                            isClient={this.isClient}
                                                            isTechnical={this.isTechnical}
                                                            goToCalled={this.openCanAssignCalledDialog}
                                                            openConfirmAssignCalledDialog={this.openConfirmAssignCalledDialog} openConfirmAssignCalledDialogFinal={this.openConfirmAssignCalledDialog}
                                                            popupColumns={this.isClient ? this.popupColumnsClient : this.popupColumns}
                                                            context={this.context}
                                                            showMessage={this.showMessage} {...this.props}
                                                            currentPopupData={this.state.currentPopupData}
                                                            setCurrentPopupData={this.setCurrentPopupData}
                                                            consultCalled={this.consultCalled}
                                                            openConfirmTreatCalledDialog={this.openConfirmTreatCalledDialog} />
                                                    })}
                                                </Grid>
                                            </div>
                                        </Grid> 
                                        
                                        {this.state.openDrawerFilterMenu && (
                                            <CalledFilters
                                                filtersCalled={this.state.filtersCalled}
                                                drawerAnimationClass={this.state.drawerAnimationClass}
                                                organizationsFilterList={this.state.organizationsFilterList}
                                                loadingOrganizationFilter={this.state.loadingOrganizationFilter}
                                                categoriesFilterList={this.state.categoriesFilterList}
                                                loadingCategoryFilter={this.state.loadingCategoryFilter}
                                                statusFilterList={this.state.statusFilterList}
                                                loadingStatusFilter={this.state.loadingStatusFilter}
                                                typeFilterList={this.state.typeFilterList}
                                                loadingTypeFilter={this.state.loadingTypeFilter}
                                                requestUserFilterList={this.state.requestUserFilterList}
                                                loadingRequestUserFilter={this.state.loadingRequestUserFilter}
                                                assignedUserFilterList={this.state.assignedUserFilterList}
                                                loadingAssignedUserFilter={this.state.loadingAssignedUserFilter}
                                                locationFilterList={this.state.locationFilterList}
                                                loadingLocationFilter={this.state.loadingLocationFilter}
                                                originFilterList={this.state.originFilterList}
                                                loadingOriginFilter={this.state.loadingOriginFilter}
                                                deptFilterList={this.state.deptFilterList}
                                                loadingDeptFilter={this.state.loadingDeptFilter}
                                                techinicalTeamFilterList={this.state.techinicalTeamFilterList}
                                                loadingTechinicalTeamFilter={this.state.loadingTechinicalTeamFilter}
                                                mailboxAddressFilterList={this.state.mailboxAddressFilterList}
                                                loadingMailboxAddressFilter={this.state.loadingMailboxAddressFilter}
                                                externalFormsFilterList={this.state.externalFormsFilterList}
                                                loadingExternalFormsFilter={this.state.loadingExternalFormsFilter}
                                                registeredNumberFilterList={this.state.registeredNumberFilterList}
                                                loadingRegisteredNumberFilter={this.state.loadingRegisteredNumberFilter}
                                                customerNumberFilterList={this.state.customerNumberFilterList}
                                                loadingCustomerNumberFilter={this.state.loadingCustomerNumberFilter}
                                                webChatFilterList={this.state.webChatFilterList}
                                                loadingWebChatFilter={this.state.loadingWebChatFilter}
                                                chatbotFilterList={this.state.chatbotFilterList}
                                                loadingChatbotFilter={this.state.loadingChatbotFilter}
                                                customOrganizationFilterFieldsList={this.state.customOrganizationFilterFieldsList}
                                                changeInputValuesPerFilterTags={this.changeInputValuesPerFilterTags}
                                                changeValuesPerFilter={this.changeValuesPerFilter}
                                                getFilterOrganizations={this.getFilterOrganizations}
                                                getFilterCategoriesByOrganization={this.getFilterCategoriesByOrganization}
                                                getFilterStatus={this.getFilterStatus}
                                                getFilterType={this.getFilterType}
                                                getFilterAssignedUser={this.getFilterAssignedUser}
                                                getFilterLocationByOrganization={this.getFilterLocationByOrganization}
                                                getFilterClassification={this.getFilterClassification}
                                                getFilterOrigin={this.getFilterOrigin}
                                                getFilterDeptByOrganization={this.getFilterDeptByOrganization}
                                                getFilterTechinicalTeam={this.getFilterTechinicalTeam}
                                                getFilterMailboxAddress={this.getFilterMailboxAddress}
                                                getFilterExternalForms={this.getFilterExternalForms}
                                                getFilterRegisteredNumber={this.getFilterRegisteredNumber}
                                                getFilterWebChat={this.getFilterWebChat}
                                                getFilterChatbot={this.getFilterChatbot}
                                                submitNewFilter={this.submitNewFilter}
                                                cleanNewFilter={this.cleanNewFilter}
                                                isClient={this.isClient}
                                                classes={classes}
                                            />
                                        )}
                                    </Grid>
                                </Can>

                                <Can I='List' a='Called'>

                                    <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                                        <Grid item xs={12} md={4}>
                                            <Pagination
                                                count={this.state.totalPages}
                                                page={this.state.page}
                                                onChange={this.onChangePaginate}
                                                showFirstButton
                                                showLastButton />
                                        </Grid>
                                        <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                                            {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
                                        </Grid>
                                    </Grid>

                                </Can>

                            </div>)
                            : (


                                <div>

                                    {this.state.emptyArray && this.state.emptySearchArchived && 
                                        <div>
                                            
                                            {this.ShowFilter()}
                        
                                            <FirstElement
                                                title={intl.formatMessage({id:"archived.calleds"})}
                                                subtitle={intl.formatMessage({id:"need.search"})}
                                                
                                                link={link}
                                                icon={<QueuePlayNextIcon style={{ fontSize: "45px" }} />}
                                            />
                                             
                                        </div>
                                        
                                    }
                                    {this.state.emptyArray && this.state.emptySearchFinishCalleds && 
                                        <div>
                                            
                                            {this.ShowFilter()}
                        
                                            <FirstElement
                                                title={intl.formatMessage({id:"called.finished"})}
                                                subtitle={intl.formatMessage({id:"need.search"})}
                                                
                                                link={link}
                                                icon={<QueuePlayNextIcon style={{ fontSize: "45px" }} />}
                                            />
                                             
                                        </div>
                                        
                                    }
                                    {this.state.emptyArray && this.state.emptySearchCanceled && 
                                        <div>
                                            
                                            {this.ShowFilter()}
                        
                                            <FirstElement
                                                title={intl.formatMessage({id:"canceled.calleds"})} 
                                                subtitle={intl.formatMessage({id:"need.search"})}
                                                
                                                link={link}
                                                icon={<QueuePlayNextIcon style={{ fontSize: "45px" }} />}
                                            />
                                             
                                        </div>
                                        
                                    }
                                    {this.state.emptyArray && this.state.emptySearchFinishCalleds == false && this.state.emptySearchArchived == false && this.state.emptySearchCanceled == false  && 
                                        <div>
                                            
                                           
                                            <FirstElement
                                                title={intl.formatMessage({id:"called.list.create.first.call"})}
                                                subtitle={((userSession.user.isexternal != null && userSession.user.isexternal && userSession.user.canexternaluserclientcreatecalled != null && userSession.user.canexternaluserclientcreatecalled) || (userSession.user.isexternal != null && !userSession.user.isexternal) && (userSession.user.originrequestid != 8 && userSession.user.originrequestid != 9) ) ? intl.formatMessage({id:"called.list.create.call.subtitle"}) : ""}
                                                buttonText={((userSession.user.isexternal != null && userSession.user.isexternal && userSession.user.canexternaluserclientcreatecalled != null && userSession.user.canexternaluserclientcreatecalled) || (userSession.user.isexternal != null && !userSession.user.isexternal)&& (userSession.user.originrequestid != 8 && userSession.user.originrequestid != 9) ) ?
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    size="large"
                                                    className={classes.button}
                                                    startIcon={<AddIcon />}
                                                    component={Link} {...{ to: link }}
                                                >
                                                    {<FormattedMessage id="called.new" />}
                                                </Button> : null}

                                                link={link}
                                                icon={<QueuePlayNextIcon style={{ fontSize: "45px" }} />}

                                            />
                                        </div>
                                        
                                    }
                                    
                                    
                                  
                                </div>
                            )}
                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color="secondary" />
                            </Overlay>
                        )}

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>
                </main>
                <Footer organizations={this.userOrganizations} />
            </div>
        );
    }
}

NewCalleds.propTypes = {
    classes: PropTypes.object.isRequired,
};


const mapStateToProps = state => ({
    lastCalledsQueue: state.lastCalledsQueue,
    actionsHeaderMenu: state.actionsHeaderMenu,
    headerMenu: state.headerMenu,
    userSession: state.userSession
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(Object.assign({}, calledsActions, headerMenuActions, lastCalledsQueueActions), dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(NewCalleds)));
NewCalleds.contextType = AbilityContext;